module.exports = {
  landing: {
    section1: {
      title: 'Em breve algo completamente novo',
      txt2: 'Aumente a produtividade, padronize processos, controle glosas e repasse com segurança, simplicidade e rapidez',
    },
    section2: {
      overline: 'recursos',
      title: 'Inteligência no Centro Cirúrgico',
      p2: 'O Volan possibilita que os profissionais estejam em constante evolução e sincronia. Com informações e insights inteligentes através da alta tecnologia como o Big Data e anos de experiência no assunto compilados em um único aplicativo, é possível elevar a administração de sua clínica e empresa para outro nível.'
    },
    section3: {
      overline: 'recursos',
      title: 'Gestão que faz Diferença',
      txt1: 'Tenha acesso aos recursos do sistema por meio de dispositivos iOS ou em qualquer lugar por meio da interface web.',
      tab1: {
        title: 'Gestão de Faturamento',
        description: 'Organização assertiva e inteligente é indispensável para ter as finanças sempre em dia. Com o Volan, é possível aumentar o faturamento através do bom controle de procedimentos, processos, locais de atuação e até mesmo realizando o gerenciamento das glosas.'
      },
      tab2: {
        title: 'Gestão de Escala',
        description: 'O Volan simplificou o processo para você e sua equipe. Além de, rápido e extremamente intuitivo, é possível otimizar a gestão entre os próprios profissionais de forma transparente e prática, evitando assim falhas do dia a dia e aumentando ainda mais a performance e produtividade.'
      },
      tab3: {
        title: 'Controle de Qualidade',
        description: 'Dar voz à experiência de seu cliente e paciente possibilitam melhorias assertivas no desempenho do médico anestesista e equipe. Consequentemente a evolução virá acompanhada da satisfação de ambos.'
      }
    },
    announcement: {
      overline: 'entrevista',
      title: 'Nossos Fundadores sobre o Volan',
      p1: 'Entrevista para a Rádio CBN.',
      p2: 'Confira na íntegra a entrevista dada pelos fundadores do Volan para a rádio CBN ',
      goToInterview: 'ir para entrevista'
    },
    section4: {
      overline: 'entrevista',
      title: 'O que estão dizendo sobre o Volan',
      t_i1_p1: 'Aqui no consultório tudo tava ruim, mas agora parece que melhorou.',
      t_i1_p2: 'Graças ao Volan e ao serviço, estou muito mais produtivo, e sinto diferença real no dia a dia.',
      t_i1_name: 'Frank Hard',
      t_i1_specialty: 'Anestesista',
      t_i2_p1: 'Aqui no consultório tudo tava ruim, mas agora parece que melhorou.',
      t_i2_p2: 'Graças ao Volan e ao serviço, estou muito mais produtivo, e sinto diferença real no dia a dia.',
      t_i2_name: 'Frank Sereia',
      t_i2_specialty: 'Cirurgião',
      t_i3_p1: 'Aqui no consultório tudo tava ruim, mas agora parece que melhorou.',
      t_i3_p2: 'Graças ao Volan e ao serviço, estou muito mais produtivo, e sinto diferença real no dia a dia.',
      t_i3_name: 'Frank Easy',
      t_i3_specialty: 'Médico'
    },
    section5: {
      overline: 'roadmap',
      title: 'Novas funcionalidades que estão por vir',
      description: 'O Volan está em constante desenvolvimento e crescimento, confira os próximos recursos que você pode esperar da plataforma na hora de tomar a sua decisão.',
      t_i1_title: 'Lançamento com gestão de faturamento.',
      t_i1_date: '19 de Janeiro de 2021',
      t_i1_version: '1.0',
      t_i2_title: 'Lançamento do modulo de escala de equipe.',
      t_i2_date: '23 de Fevereiro de 2021',
      t_i2_version: '1.1',
      t_i3_title: 'Lançamento do módulo de controle de qualidade.',
      t_i3_date: '23 de Março de 2021',
      t_i3_version: '1.5',
      t_i4_title: 'Novos Recursos',
      t_i4_date: 'Acompanhe também o blog e nossas redes para saber as próximas novidades.',
      t_i4_version: '...'
    },
    section6: {
      overline: 'plataformas',
      title: 'Disponíveis nas principais plataformas mobile e além',
      description: 'Confira as plataformas em que o Volan está disponível e descubra a solução que mais se adequa à sua necessidade.',
      t_i1_title: 'macOS',
      t_i1_content: 'O Volan também oferece uma experiência nativa, com paridade de funcionalidades em relação aos aplicativos móveis, em computadores Apple rodando macOS.',
      t_i2_title: 'Android e iOS',
      t_i2_content: 'As principais funcionalidades e, em breve, todos os recursos, do Volan estão disponíveis em smartphones e tablets com os sitemas Android e iOS. Confira!',
      t_i3_title: 'Navegadores Web',
      t_i3_content: 'Utilize o Volan em qualquer equipamento, basta acessar a interface web por meio de um navegador moderno em um dispositivo  conectado  à internet.'
    }
  },
  format: {
    time: 'HH:mm',
    date: 'DD/MM/YYYY',
    dateHour: 'DD/MM/YYYY HH:mm',
    dateSecond: 'DD/MM/YYYY HH:mm:ss',
    yearMonth: 'MM/YYYY',
  },
  login: {
    login: 'Entrar',
    goReset: 'Esqueci minha senha',
    goLogin: 'Retornar ao login',
    accessClient: 'Acesso Cliente',
    accessAdmin: 'Acesso Admin',
    facebook: 'Entrar com Facebook',
    google: 'Entrar com Google',
    apple: 'Entrar com Apple',
    phone: 'Entrar com Telefone',
    facebookRegister: 'Cadastro com Facebook',
    googleRegister: 'Cadastro com Google',
    appleRegister: 'Cadastro com Apple',
    phoneRegister: 'Cadastro com Telefone',
    emailRegister: 'Cadastro com Email',
    getPhoneNumber: 'Insira seu número de telefone',
    getPhoneCode: 'Insira seu código de verificação enviado ao seu celular',
    resetCompany: 'Resetar Senha',
    reset: 'Enviar email',
    error: {
      generic: 'Houve algum erro ao efetuar login',
      phoneEmpty: 'Número de telefone vazio',
      phoneCodeEmpty: 'Código de verificação vazio',
      loginTitle: 'Erro ao efetuar login',
      changePasswordTitle: 'Erro ao alterar a senha',
      providerTitle: 'Erro ao adicionar provider',
      resetNotFound: 'Reset de senha não encontrado',
      accessDenied: 'Acesso negado'
    },
    providerCode: {
      'auth/invalid-email': 'Email inválido',
      'auth/user-disabled': 'Conta desabilitada',
      'auth/user-not-found': 'Usuário não encontrado',
      'auth/wrong-password': 'Senha incorreta',
      'auth/credential-already-in-use': 'Credencial já utilizada',
      'auth/email-already-exists': 'Email já utilizado',
      'auth/too-many-requests': 'Muitas tentativas, tente novamente mais tarde',
      'auth/operation-not-allowed': 'Tipo de login não configurado, tente outra forma de login',
      'auth/network-request-failed': 'Parece que você não está conectado na internet',
      missingEmail: 'O email é necessário',
      missingPassword: 'A senha é necessária',
      internal: 'Erro interno',
      notFound: 'Esse usuário não existe'
    },
    addFacebook: 'Adicionar Facebook',
    addGoogle: 'Adicionar Google',
    addApple: 'Adicionar Apple',
    providers: 'Métodos de autenticação',
    remove: 'Remover',
    providerId: 'Provider',
    email: 'E-mail',
    uid: 'uid',
    changePassword: 'Alterar senha',
    addPassword: 'Adicionar Senha',
    resetClient: 'Resetar senha',
    register: 'Registrar',
    registerClient: 'Registrar',
    resetPassword: 'Resetar senha',
    makeRegister: 'Efetuar cadastro',
    title: 'Entrar',
    password: 'Senha',
    copyright: '© Volan',
    choseAnotherPassword: 'Escolha uma nova senha',
    resetSuccess: 'Senha alterada com sucesso',
    userAssociated: 'Usuário existente associado a essa empresa, a senha dele é a senha previamente cadastrada',
    welcomeClient: 'Bem vindo ao Volan Doutor',
    welcomeAdmin: 'Bem vindo ao Volan Admin',
    welcomeClientDev: 'Volan Doutor, área de desenvolvimento',
    welcomeAdminDev: 'Volan Admin, área de desenvolvimento',
    goLoginAdmin: 'Acesso Admin',
    goLoginClient: 'Acesso Doutor'
  },
  admin: {
    inbox: 'Mensagens',
    quiz: {
      qualityManagement: 'Gestão de Qualidade.',
      scaleManagement: 'Gestão de Escala.',
      billingManagement: 'Gestão de Faturamento.'
    }
  },
  quest: {
    name: 'Qual é seu nome?',
    platformPreferences: 'Em quais plataformas você mais gostaria de utilizar os recursos do Volan?'
  },
  months: {
    january: 'Janeiro',
    february: 'Fevereiro',
    march: 'Março',
    april: 'Abril',
    may: 'Maio',
    june: 'Junho',
    july: 'Julho',
    august: 'Agosto',
    september: 'Setembro',
    october: 'Outubro',
    novenber: 'Novembro',
    december: 'Dezembro'
  },
  ragVolan: {
    addFirstDocument: 'Adicionar primeiro documento',
    addFirstAudio: 'Adicionar primeiro audio',
    noDocuments: 'Sem documentos selecionados',
    noAudios: 'Sem áudios selecionados',
    documents: 'Documentos',
    audios: 'Audios',
    types: {
      SUPPORT: 'Suporte',
      CUSTOMER_SUCCESS: 'Sucesso do cliente',
      BILLING: 'Faturamento',
      FINANCIAL: 'Financeiro',
      SCHEDULE: 'Escala',
    },
  },
  all: {
    code: 'Código',
    financialCategoryFee: 'Categorias de impostos',
    bankReconciliation: 'Conciliação bancária',
    adminTools: 'Adm Tools',
    batchMigrate: 'Migrar lotes',
    backups: 'Backups',
    financialItemGroups: 'Grupos de movimentações',
    default: 'Padrão',
    externalINSS: 'INSS externo',
    group: 'Grupo',
    doctor: 'Médico',
    RAGVolan: 'RAG Volan',
    financialItemsRecurrents: 'Mov Recorrentes',
    intervalMonth: 'Mês',
    intervalCustom: 'Customizado',
    numberTransfer: 'Nº Mov',
    numberInvoice: 'Nº Nota',
    recurrentCode: 'Nº Recorrente',
    readingFile: 'Lendo arquivo',
    prepareData: 'Preparando dados',
    creatingEvents: 'Criando eventos para importação',
    loadingPatients: 'Buscando pacientes já cadastrados',
    checkingDuplicateEvents: 'Conferindo eventos duplicados',
    checkingDuplicatePasswords: 'Conferindo senhas duplicadas',
    recurrentPayments: 'Pagamentos recorrentes',
    financialItemsGroups: 'Grupos de pagamento',
    paymentSlips: 'Boletos',
    paymentSlipCode: 'Código do Boleto',
    releases: 'Releases',
    changeLog: 'Alterações',
    sortBy: 'Ordenar por',
    sort: 'Ordenar',
    previousData: 'Dados Anteriores',
    updatedData: 'Dados Alterados',
    emergency: 'Emergência',
    companiesData: 'Dados empresas',
    import: 'Importar',
    externalPayments: 'Pagamentos tomador',
    systemNeedUpdate: 'É necessário atualizar a página',
    bi: 'Power BI',
    map: 'Mapa eventos',
    queryInFirestore: 'Buscar dados no firestore',
    MigrateCompany: 'Migrar empresa',
    MigrateUser: 'Migrar usuário',
    CheckTransactions: 'Verificar transações',
    ParallelUniverse: 'Universo paralelo',
    guideUpperCase: 'GUIA',
    upperCaseInAllSystem: 'Letra maiúscula em tudo que for salvo.',
    ocr: 'OCR',
    ocrAmazonCredit: 'Créditos de OCR',
    dashboardOcr: 'Dashboard OCR',
    externalPayment: 'Pagamento externo',
    guideOcrAmazon: 'Ocr 2.0',
    view: 'Visualizar',
    transfersItems: 'Itens de repasse',
    coopFinancial: 'Financeiro cooperado',
    transfers: 'Repasses',
    generatePdf: 'Gerar PDF',
    notCalculateAutomaticEmergency: 'Não calcular emergência automática na criação do evento.',
    userTransfer: 'Tranferências',
    appeal: 'Recurso',
    appeals: 'Recursos',
    blueAccount: 'Conta Azul',
    typesOfPayment: 'Tipos de pagamento',
    typesOfPaymentRemoved: 'Formas de Pagamento <strong>DESABILITADAS</strong>',
    customFields: 'Campos Customizados',
    to: 'até',
    emissionDate: 'Data de emissão:',
    referenceMonth: 'Mês de Referência:',
    reportTransactions: 'Relatório de transações',
    warningReplaceAttendanceFee: '* Se for adicionado um novo valor de recebimento do co-participativo a transação antiga será substituída. E o valor produzido passará a ser o novo valor recebido.',
    confirmReceiveAttendanceFee: 'Realizar recebimento do co-participativo?',

    // === ATTENDANCE FEE SWEETALERT MODALS ===
    askReceiveAttendanceFeeModal: 'Deseja receber a taxa de co-participativo?',
    askInvoiceQuestionAttendanceFeeModalTitle: 'Deseja anexar uma nota fiscal?',
    askInvoiceQuestionAttendanceFeeModalText: '',
    askInvoiceQuestionAttendanceFeeModalButtonAccept: 'Sim, anexar agora',
    askInvoiceQuestionAttendanceFeeModalButtonDenied: 'Não, receber sem nota',

    // === ATTENDANCE FEE PROCESSING ===
    processingAttendanceFeeReceiveLoading: 'Processando recebimento...',
    attendanceFeeReceiveProcessedSuccess: 'Recebimento processado!',
    attendanceFeeReceiveProcessedSuccessText: 'Taxa de {value} processada com sucesso',

    // === ERROR MESSAGES ===
    errorProcessingTitle: 'Erro ao processar',
    unexpectedErrorTitle: 'Erro inesperado',
    errorProcessingAttendanceFeeReceive: 'Erro ao processar recebimento',
    unknownErrorProcessingAttendanceFee: 'Erro desconhecido ao processar recebimento',
    errorAddingAttendanceFeeTitle: 'Erro ao adicionar taxa de Co-participativo',
    errorAddingAttendanceFeeMessage: 'Erro ao adicionar taxa de Co-participativo',
    errorLoadingDataTitle: 'Erro ao carregar dados',
    uploadErrorTitle: 'Erro no Upload',
    errorProcessingInvoiceTitle: 'Erro ao processar nota fiscal',
    unexpectedErrorProcessingAttendanceFee: 'Erro inesperado ao processar recebimento',
    unexpectedErrorProcessingInvoice: 'Erro inesperado ao processar nota fiscal',
    unknownError: 'Erro desconhecido',
    unexpectedUploadError: 'Erro inesperado no upload',
    companyIdNotFoundError: 'CompanyId não encontrado. Prop modalCompanyId: {modalCompanyId}',

    // === UI LABELS ===
    receiveDateLabel: 'Data de Recebimento',
    fileUploadedSuccessMessage: 'Arquivo carregado com sucesso',
    acceptedFileFormatsMessage: 'Formatos aceitos: PDF, JPG, PNG (até 10MB)',


    receive: 'Receber',
    imports: 'Importações',
    posts: 'Publicações',
    postsCategories: 'Categorias de publicações',
    postsPublishers: 'Publicadores de publicações',
    templatesImportEvents: 'Templates para importação de eventos',
    spreadsheetProcedureCodes: 'Siglas de exame das planilhas',
    importEvents: 'Importar eventos',
    surgerySideBar: 'Cirurgia/Honorário',
    consultationSideBar: 'Consulta',
    examSideBar: 'Exame/ SP/SADT',
    surgery: 'Cirurgia',
    consultation: 'Consulta',
    exam: 'Exame',
    cobrancas: 'Cobranças',
    financial: 'Financeiro',
    integrationConfig: 'Configurações da integração',
    scheduleConfig: 'Configurações da escala',
    tooltips: {
      eventAttachments: 'Baixar todos os anexos em PDF',
      batchFilters: 'Filtros dos lotes',
      insurancesFromCooperativeOrNot : 'convênios da cooperative ou próprios',
      toDownloadEnterAName: 'Para baixar verifique o nome e/ou campos obrigatórios invalidos',
      eventFromAxRegWithId: 'Evento importado do AxReg, id: ',
      eventFromAxReg: 'Evento importado do AxReg',
      eventExportToContaAzul: 'Evento exportado para a Conta Azul',
      downloadPDF: 'Baixar em PDF',
      downloadallInPDF: 'Baixar todos em PDF',
      downloadXLSX: 'Baixar em Planilha',
      invertOrderByDate: 'Inverter ordenação de data',
      filter: 'Filtros',
      selectAll: 'Selecionar todos',
      removeSelect: 'Remover seleção',
      selectEvent: 'Selecionar evento',
      expandEvent: 'Expandir evento',
      minimizeEvent: 'Minimizar evento',
      expandContract: 'Expandir contrato',
      minimizeContract: 'Minimizar contrato',
      actionsOnContract: 'Ações no contrato',
      actionsOnEvent: 'Ações no evento',
      actionsOnEvents: 'Ações nos eventos',
      observations: 'Observações',
      showEventStatus: 'Mostrar histórico de status do evento',
      eventFinishedCannotCreateTransactionAppeal: 'Em evento finalizado não é permitido adicionar transações de recebimento ou de glosa. Os valores adicionados agora ficarão salvos somente no recurso.',
      selectModes: 'Modos de seleção',
      flagEventsHadPendingStatus: 'Evento com pendência resolvida',
    },
    translate: 'Tradução',
    tools: 'Ferramentas',
    advancedResources: 'Recursos avançados',
    adminResources: 'Recursos de administrador',
    atTime: 'às',
    observations: {
      type: {
        RevertStatus: 'Mudança de status',
        Pending: 'Pendência',
        Message: 'Evento',
        Guide: 'Observação da guia',
        Remove: 'Remoção do evento',
        InternalPending: 'Pendência Interna'
      }
    },
    addedCommentToa: 'adicionou um comentário à ',
    addedCommentTo: 'adicionou um comentário ao ',
    showInGuide: 'Mostrar na guias/xml',
    verifyProcedures: 'Procedimentos',
    verifyEvents: 'Verificar eventos',
    protocols: 'Protocolos',
    items: 'Itens',
    empty: 'Vazio',
    exclude: 'Excluir',
    questions: 'Perguntas',
    fillWithANSPattern: 'Preencher com padrão ANS',
    mandatoryFieldsGuidesXMLAndNewEvent: 'Campos obrigatórios das(os) guias/XML\'s e lançamento do evento',
    mandatoryFieldsGuidesXML: 'Campos obrigatórios das(os) guias/XML\'s',
    mandatoryFields: 'Campos obrigatórios',
    safety: 'Segurança',
    responses: 'Respostas',
    eventsNumber: 'Nº de eventos: ',
    eventsAverage: 'Ticket médio: ',
    active: 'Ativo',
    inactive: 'Inativo',
    importResume: 'Resumo da importação',
    importedEvents: 'Evento(s) importado(s): ',
    notImportedEvents: 'Evento(s) não importado(s): ',
    notImported: 'Não importados',
    imported: 'Importados',
    importationMultiple: 'Importação múltipla',
    integrationsMultiples: 'Integração múltipla',
    taxes: 'Taxas',
    hours: 'Horas',
    axregIntegrations: 'Integraçoes do AXReg',
    noAssignments: 'Sem atribuições',
    myAnesthesias: 'Minhas anestesias',
    noMesssage: 'Sem conteúdo',
    guideConsultation: 'Guia de consulta',
    additionalData: 'Dados adicionais',
    patientInfo: 'Informações do Paciente',
    addressAlertSavedSucess: 'Endereço salvo com sucesso',
    addressAlertSavedError: 'Erro ao salvar endereço',
    complementationValue: 'Valor complementação: ',
    attendanceFee: 'Co-participativo',
    invoiceData: 'Dados da Nota Fiscal',
    attendanceFeeValue: 'Valor co-participativo: ',
    attendanceFeeValueReceived: 'Valor co-participativo recebido: ',
    add: 'Adicionar',
    cuts: 'Glosas',
    reasonsCut: 'Motivos de glosa',
    createTheNote: 'Crie a nota',
    monthFilter: 'Filtrar mês',
    producedReceived: 'Produzido e Recebido',
    isEmergency: 'É Emergência?',
    guideSPSADT: 'Guia SP/SADT',
    guideFees: 'Guia de honorários',
    save: 'Salvar',
    OK: 'OK',
    selectGlosaReasons: 'Selecione os motivos da glosa',
    addReason: 'Adicionar motivo',
    addGeneralCut: 'Glosa geral',
    addCut: 'Adicionar glosa',
    download: 'Baixar',
    titleGenericDownloadModal: 'Opções de Download',
    tooltipGenericDownloadModal: 'Opções de Download',
    xlsxSheetGenericDownloadModal: 'Baixar em Planilha',
    pdfGenericDownloadModal: 'Baixar em PDF',
    moreOptionsGenericDownloadModal: 'Mais Opções',
    genericTitleDownloadModal: 'Opções Personalizadas',
    maxHeadersSelections: 'Ordene ou Selecione os Cabeçalhos para o Relatório (Limite de 8 p/ PDF) ',
    nameSheet: 'Nome da Planilha',
    cbhpm: 'CBHPM',
    associateds: 'Associados',
    notAssociateds: 'Não Associados',
    helpAnesthetistNotAssociated: 'Todos os anestesistas que não estão em nenhum integração com o AXREG.',
    helpAnesthetistAssociated: 'Todos os anestesistas que estão em pelo menos uma integração em alguma instituição no AXREG.',
    helpInsuranceNotAssociated: 'Todos os convênios que não estão em nenhum integração com o AXREG.',
    helpInsuranceAssociated: 'Todos os convênios que estão em pelo menos uma integração em alguma instituição no AXREG.',
    helpNotAssociated: 'Todos os cirurgiões que não estão em nenhum integração com o AXREG.',
    helpAssociated: 'Todos os cirurgiões que estão em pelo menos uma integração em alguma instituição no AXREG.',
    dataSurgeonAXREG: 'Dados do cirurgião no AXREG:',
    dataSurgeonVolan: 'Dados do cirurgião no Volan:',
    dataAnesthetistAXREG: 'Dados do Anestesista no AXREG:',
    dataAnesthetistVolan: 'Dados do Anestesista no Volan:',
    dataInsuranceAXREG: 'Dados do Convênio no AXREG:',
    dataInsuranceVolan: 'Dados do Convênio no Volan:',
    hospitalDefault: 'Hospital Padrão',
    itemsNotAssociateds: 'Items do AXREG não associados ao Volan: ',
    allItems: 'Relação de todos os items do AXREG e do Volan: ',
    showNotAssociateds: 'Mostrar não associados?',
    eventReports: 'Eventos',
    reportEvents: 'Relatório de Eventos',
    reportEventsCustom: 'Relatório de Eventos Customizado',
    listEventsInPreparation: 'Eventos em Preparação',
    reports: 'Produção',
    schedules: 'Escala',
    schedulesLimits: 'Turnos',
    core: 'Controle e Registro',
    demands: 'Demandas',
    workloads: 'Horários do profissional',
    exceptionServices: 'Exceções de trabalho',
    onCallSchedule: 'Escalas de plantões',
    workplaces: 'Locais de trabalho',
    export: 'Exportar',
    value: 'Valor',
    helpInformation: 'Processando, glosas e perdas. Todos estão sendo comparados com o mesmo período (mês) do ano anterior.',
    loading: 'Carregando',
    att: 'Atualizar',
    over: 'Over',
    produced: 'Produzido',
    received: 'Recebido',
    processing: 'Processando',
    glosas: 'Glosas',
    loss: 'Perdas',
    overview: 'Visão geral',
    axreg: 'Axreg',
    axregToFrom: 'Axreg De/Para',
    waiting: 'Aguardando',
    integrations: 'Integrações',
    all: 'Todos',
    showAll: 'Mostrar todos',
    notAssociate: 'Não associados',
    anesthetistsIntegration: 'Integração de anestesistas',
    surgeonsIntegration: 'Integração de cirurgiões',
    specialties: 'Especialidades',
    sigla: 'Sigla',
    othersRecentsPosts: 'OUTRAS PUBLICAÇÕES RECENTES.',
    lastPostsDescription: 'Logo abaixo você encontra as publicações mais recentes.',
    lastPublications: 'ÚLTIMAS PUBLICAÇÕES',
    lastPublicationsInThisCAtegory: 'ÚLTIMAS PUBLICAÇÕES NESTA CATEGORIA',
    recents: 'RECENTES',
    backToHome: 'VOLTAR AO INÍCIO',
    publishedIn: 'PUBLICADO EM ',
    keepReading: 'CONTINUAR LENDO>>',
    othersCategories: 'OUTRAS CATEGORIAS',
    subscribeStart: 'Começar',
    know: 'Conheça',
    contact: 'Contato',
    rightsReserved: 'Volan 2020. Todos os direitos reservados',
    next: 'Próximo',
    knowMore: 'Saiba Mais',
    notImplemented: 'Não implementado',
    attendance: 'Atendimento',
    settings: 'Configurações',
    schedule: 'Horários',
    information: 'Informação',
    informations: 'Informações',
    performance: 'Performance',
    history: 'Histórico',
    of: 'de',
    step: 'Etapa',
    category: 'Categoria',
    subCategory: 'Sub Categoria',
    profile: 'Perfil',
    categories: 'Categorias',
    users: 'Usuários',
    conclude: 'Concluir',
    close: 'Fechar',
    cancel: 'Cancelar',
    nothingToList: 'Lista vazia',
    search: 'Pesquisar',
    searchBy: 'Buscar por:',
    searchByNameCodeHealthInsuranceOrDate: 'nome, código, convênio ou data',
    additionals: 'Adicionais',
    createProduct: 'Criar Produto',
    editCategory: 'Editar Categoria',
    companyConfigs: 'Configurações',
    edit: 'Editar',
    create: 'Novo',
    clients: 'Clientes',
    regions: 'Regiões',
    region: 'Região',
    utcOffset: 'UtcOffset',
    jobs: 'Jobs',
    tags: 'Tags',
    tagAssociate: 'Tag associada',
    company_tags: 'Tags Empresa',
    companyFilialNotSelected: 'Filial não selecionada',
    blog: 'Blog',
    faq: 'Faq',
    pages: 'Páginas',
    blogCategories: 'Blog Categorias',
    yes: 'Sim',
    no: 'Não',
    contactSupport: 'Entre em contato com o suporte',
    exports: 'Exportar',
    changeImage: 'Alterar imagem',
    companies: 'Empresas',
    filials: 'Empresas/Filiais',
    notifications: 'Notificações',
    dashboard: 'Dashboard',
    configs: 'Configurações',
    billing: 'Faturamento',
    registers: 'Cadastros',
    newEvent: 'Novo evento',
    patients: 'Pacientes',
    hospitals: 'Hospitais',
    contracts: 'Contratos',
    medicalSpecialties: 'Especialidades médicas',
    insurances: 'Planos de saúde',
    anesthetists: 'Anestesistas',
    surgeons: 'Cirurgiões',
    services: 'Serviços',
    goBack: 'Voltar',
    test: 'Teste',
    switchDarkTheme: 'Tema escuro',
    switchLightTheme: 'Tema claro',
    switchLanguage: 'Idioma',
    logout: 'Sair',
    changeCompany: 'Alterar Empresa',
    test3: 'Página de teste3',
    test2: 'Página de teste2',
    versionNav: 'Volan',
    events: 'Eventos',
    noCompanySelected: 'Nenhuma empresa selecionada',
    clearSelectedCompany: 'Limpar empresa selecionada',
    adminUsers: 'Usuários adm',
    inbox: 'Contatos',
    quiz: 'Quiz',
    ok: 'Ok',
    bigData: 'Big Data',
    about: 'Sobre',
    faqs: 'Faq',
    faqsCategories: 'Categorias de Faq',
    changes: 'Mudanças',
    guidesOcr: 'Guias OCR *',
    historyTitle: 'Histórico',
    historyShow: 'Mostrar histórico',
    historyShowSuperAdmin: 'Mostrar histórico(SuperAdmin)',
    isSuperAdminAccess: '* Apenas para Super Admin',
    oneSelected: '1 item selecionado',
    multiSelected: 'itens selecionados',
    invoices: 'Notas',
    batches: 'Lotes',
    onlySuperAdmin: 'SuperAdmin',
    onlySuperAdminTeste: '(Em Teste)',
    newTicket: 'Novo Ticket',
    regionUtcOffset: 'UtcOffset',
    formsQuality: 'Qualidade',
    forms: 'Formulários',
    formsAdd: 'Criar Formulários',
    formsToResponse: 'Responder Formulários',
    FormsResponses: 'Respostas dos Formulários',
    formsCategories: 'Tipos de Formulários',
    importSurgeons: 'Importar cirurgiões',
    exportSurgeons: 'Exportar cirurgiões',
    confirmImportSurgeons: 'Verifique as informações e conclua no final da tela',
    importAnesthetists: 'Importar anestesistas',
    exportAnesthetists: 'Exportar anestesistas',
    confirmImportAnesthetists: 'Verifique as informações e conclua no final da tela',
    birthDate: 'Nascimento',
    functionsEnabled: 'Funcionalidades habilitadas',
    notValuedEvents: 'Eventos não faturáveis (sem valor)',
    customEventStatus: 'Status de evento customizado (Depois de aguardando conferência)',
    customEventStatusName: 'Nome do status customizado',
    customEventStatusAction: 'Ação do status customizado (Ex. Status \'Em auditoria\' ação \'Auditado\')',
    periodOfPayments: 'Períodos de pagamento',
    partialLostStatus: 'Status parcialmente perdido',
    partialCutStatus: 'Status parcialmente glosado',
    contractInstallment: 'Parcelas do contrato',
    valuePerHour: 'Valor hora',
    valuePerHourLabel: '* Ao ativar o valor hora, os campos de (data início e data fim do procedimento ou anestesia) serão obrigatórios para todos os convênios. O campo valor hora aparecerá no Dashboard, nos eventos e no campo Produzido da Produção. Ao habilitar essa opção, ela começa a valer para os eventos lançados no próximo dia. No Dashboard, começa a valer a partir do próximo mês.',
    selectProcedureOrAnesthesiaAsBaseValueHour: 'Selecione o intervalo a ser usado como base de cálculo do valor hora (Padrão: Intervalo da Anestesia)',
    procedureInterval: 'Intervalo do Procedimento',
    anesthesiaInterval: 'Intervalo da Anestesia',
    spreadsheetConfig: 'Campos da tabela',
    noSuportLocalStorage: 'Navegador obsoleto ou com os cookies desabilitados, atualize o navegador e ou habilite os cookies',
    billingContract: 'Contratos',
    periodOfPayment: 'Períodos de pagamento',
    configOnCallSchedule: 'Configuração de Plantão',
    reportsOption: 'Relatórios',
    reportsGeneral: 'Relatórios Gerais',
    customReport: 'Relatórios Customizados',
    customReportToDownload: 'Relatório Customizado para download',
    reportsGeneratorEditList: 'Listar/Editar Relatórios',
    appealNumber: 'Nº do Recurso',
    factorTransfer: 'Fatores de transferência',
    suppliers: 'Fornecedores',
    financialItems: 'Contas a pagar e receber',
    billsToPayAndReceive: 'Old Contas a pagar e receber',
    chartOfAccounts: 'Plano de contas',
    accountCards: 'Cartões',
    bankAccounts: 'Contas bancárias',
    cardBrands: 'Bandeiras dos cartões',
    banks: 'Bancos',
    financialStatements: 'Fechamento financeiro',
    selectModes: {
      title: 'Modos de seleção',
      allByPage: 'Selecionar todos na página',
      all: 'Selecionar todos'
    },
    calculatingTotal: 'Calculando total...'
  },
  reports: {
    selectCustomReport: 'Selecione o Relatório Customizado',
    healthInsurances: 'Convênios',
    anesthetists: 'Anestesistas',
    hospitals: 'Hospitais',
    surgeons: 'Cirurgiões',
    without_surgeon: 'Sem cirurgião',
    without_healthInsurance: 'Sem convênio',
    without_hospital: 'Sem hospital',
    without_anesthetist: 'Sem anestesiologista',
    without_name: 'Sem nome',
    items: 'ITENS',
    total: 'TOTAL',
    received: 'RECEBIDO',
    produced: 'PRODUZIDO',
    diff: 'DIFERENÇA',
    glossed: 'GLOSADO',
    lost: 'PERDIDO',
    xlsx: {
      received: 'Recebido',
      produced: 'Produzido',
      difference: 'Diferença',
      glossed: 'Glosado',
      lost: 'Perdido'
    },
    orderBy: 'Ordernar por:',
    lostAbbr: 'P',
    totalProduced: 'Total produzido: ',
    residentNotAllowed: 'Acesso Negado: Produção',
    valuePerHour: 'Valor hora',
    externalPayment: 'Pagamentos externos',
    byAnesthetist: 'Por Anestesista'
  },
  schedules: {
    duplicate: 'Duplicar escala',
    name: 'Nome',
    dtBegin: 'Início',
    dtEnd: 'Fim',
    formDtBegin: 'Data de início',
    formDtEnd: 'Data de fim',
    observations: 'Observações:',
    vacation: 'Férias',
    other: 'Outro',
    canScale: 'Pode ser escalado em eventualidade?',
    infoVacation: 'Profissional de férias',
    infoDayOff: 'Profissional de folga',
    infoDayBetterOff: 'Profissional de folga, mas pode ser escalado conforme necessidade',
    removeWorkload: 'Remover horário',
    confirmDeleteWorkload: 'Tem certeza que deseja remover o horário?',
    confirmDeleteItemCore: 'Tem certeza que deseja remover essa escala?',
    withoutAnesthetistError: 'Selecione um profissional',
    withoutWeekdayError: 'Selecione pelo menos um dia da semana',
    invalidInterval: 'Selecione um intervalo de horário válido',
    intervalAlreadyAllocated: 'Conflito entre horários',
    withoutTimes: 'Selecione o horário de início e de fim',
    weekdayInput: 'Selecione os dias da semana deste horário',
    typeInput: 'Escolha o tipo do horário',
    intervalInput: 'Selecione os horários de início e fim',
    workdayType: 'Dia de trabalho',
    dayBetterOffType: 'Folga',
    dayOffType: 'Indisponível',
    hospital: 'Hospital',
    workExceptions: 'Exceções de trabalho',
    anesthetist: 'Profissional',
    filial: 'Filial',
    withoutAnesthetist: 'Selecione um profissional',
    find: 'Buscar',
    findAll: 'Buscar Todos',
    weekdays: 'Dias da semana',
    value: 'Valor',
    order: 'Ordem',
    slot: 'Horários',
    schedulesLimits: 'Turnos',
    iconTitle: 'Ícone',
    color: 'Cor',
    startText: 'Ínicio',
    endText: 'Fim',
    duration: 'Duração',
    selectColor: 'Selecione uma cor:',
    selectIcon: 'Selecione um ícone:',
    moreThan24Hours: 'Duração acima de 24h?',
    isOnCallShift: 'É um turno de plantão?',
    outOfWorkLoadSchedule: 'Pode ser escalado fora do horário de trabalho?',
    beginHour: 'Hora início',
    endHour: 'Hora fim',
    durationHours: 'Duração (horas)',
    available: 'Disponível',
    unavailable: 'Indisponível',
    profWorkload: 'Horários do profissional',
    onCallSchedule: 'Escala de sobreaviso',
    workplaces: 'Locais de trabalho',
    demands: 'Demandas',
    badIntervalTitleError: 'Erro no intervalo de horário',
    badIntervalTextError: 'A hora de início deve ser menor que a de fim',
    badDateIntervalTextError: 'A data de fim deve ser maior que a de início',
    pickAnesthetist: 'Selecione um profissional',
    showNames: 'Mostrar nomes',
    dayBetterOff: 'De folga, mas pode ser escalado',
    actions: 'Ações',
    confirmDeleteExceptionService: 'Tem certeza que deseja excluir a exceção de trabalho?',
    deleteSuccess: 'Apagado com sucesso',
    exceptionAlreadyStartedError: 'Não é possível editar ou apagar esta exceção de trabalho pois ela já está em vigência.',
    badInterval: 'Erro no intervalo de horários',
    withoutHospitalError: 'Selecione um Hospital',
    valueFactor: 'Fator do turno',
    badValueFactor: 'Insira um fator do turno válido',
    valueFactorHint1: 'Valor do fator do turno. Valor de R$ 100,00 com o fator do turno em',
    valueFactorHint2: 'resulta em',
    core: 'Controle e Registro de Escalas',
    coreObject: {
      listAnesthetistsModeOptions: {
        ALL: 'Todos os Profissionais',
        ONLY_SCHEDULED: 'Somente Escalados',
        NOT_SCHEDULED: 'Não Escalados',
        VACATION: 'Profissionais Em Férias',
      },
      listAnesthetists: 'Listar profissionais'
    },
    dailySchedule: 'Escala diária (D)',
    onCallScheduleCore: 'Escala de plantão (P)',
    totalFactor: 'Total Fator',
    totalValue: 'Total Valor',
    period: 'Período',
    clear: 'Limpar',
    edit: 'Editar',
    save: 'Salvar',
    types: 'Tipos',
    type: 'Tipo',
    KGeneral: 'Geral',
    KWorkplace: 'Local de trabalho',
    KEvent: 'Evento',
    KOnCall: 'Sobreaviso',
    errorPastItem: 'Não é possível escalar em datas passadas',
    prediction: 'Previsão',
    add: 'Adicionar',
    demandIsOutOfWeekday: 'A demanda não está configurada para este dia da semana',
    doNotEditIfPublished: 'Não é possível editar esta escala uma vez que já se encontra publicada',
    demand: 'Demanda',
    onCallHeader: 'Configuração',
    onCallHeaderAsHospital: 'Hospital',
    confirmChangeAnesthetistCore: 'Já existe um profissional nessa demanda no dia selecionado. Deseja realmente adicionar outro?',
    conflictDemands: 'Conflito entre horários para o profissional selecionado. Escalar mesmo assim?',
    confirmAnesthetistKDayOff: 'Profissional indisponível. Escalar mesmo assim?',
    day: 'Dia',
    scheduleOnDutyAllocated: 'Escala diária',
    workplace: 'Local de trabalho',
    withoutSlotError: 'Selecione um Horário',
    withoutWorkplaceError: 'Selecione um local de trabalho',
    scheduleAddSuccess: 'Escala adicionada com sucesso.',
    realized: 'Realizado',
    modes: 'Modos',
    scheduleDeleteSuccess: 'Escala removida.',
    openDialogWarning: 'Edição aberta. Conclua ou feche a edição.',
    history: 'Histórico',
    date: 'Data',
    slotDesc: 'Turno',
    factor: 'Fator',
    begin: 'Início',
    end: 'Fim',
    start: 'Começo',
    action: 'Ação',
    realizedBy: 'Realizado por',
    alteration: 'Alteração',
    dateBegin: 'Data início',
    dateEnd: 'Data fim',
    dateRange: 'Período de datas',
    resetToFullRange: 'Resetar para período completo',
    withoutAlteration: 'Não há alterações registradas para o item selecionado',
    ADD: 'Adicionado',
    RM: 'Removido',
    CLOSEONDUTY: 'Fechado',
    source: 'ORIGEM',
    destiny: 'DESTINO',
    addition: 'Acréscimo',
    reduction: 'Decréscimo',
    onCallfactorHint: 'Para um plantão de R$ 100,00 o valor fica',
    onCallFactor: 'Porcentagem',
    dailyFactorHint: 'Para uma escala de R$ 100,00 o valor fica',
    dailyFactor: 'Porcentagem',
    configOnCall: 'Configurações de Plantão',
    configOnCallAsHospital: 'Hospitais',
    selectAConfig: 'Selecione uma configuração de Plantão',
    selectAConfigAsHospital: 'Selecione um Hospital',
    hasDemandValue: 'Usar valor diferente do padrão da empresa?',
    canInsertMultipleAnesthetists: 'Pode escalar mais de um anestesista na demanda?',
    anesthetistsScheduled: 'Escalados no dia',
    positiveNumberError: 'Insira um número positivo',
    sameValueOfCompany: 'Valor igual à configuração da empresa',
    additionValue: 'Acréscimo de ',
    reductionValue: 'Decréscimo de ',
    smallerThanHundredError: 'O valor deve ser menor ou igual a 100 (cem)',
    hasDiffValueInSchedule: 'Aplicar valores diferentes na escala para o anestesista?',
    diffInDailySchedule: 'Acréscimo/Decréscimo da escala',
    diffInOnCallSchedule: 'Acréscimo/Decréscimo do plantão',
    confirmDeleteSlotCategory: 'Tem certeza que deseja excluir o turno?',
    workloads: 'Horários do profissional',
    slotCategories: 'Turnos',
    exceptionServices: 'Exceções de trabalho',
    configOnCallSchedule: 'Configuração de plantão',
    configOnCallScheduleAsHospital: 'Hospital',
    tags: 'Tags',
    anesthetists: 'Anestesistas',
    confirmDeleteTag: 'Tem certeza que deseja excluir a tag?',
    tagDeleteSuccess: 'Tag apagada com sucesso.',
    confirmDeleteDemand: 'Tem certeza que deseja excluir a demanda?',
    confirmDeleteOnCallHeader: 'Tem certeza que deseja excluir a configuração de plantão?',
    confirmDeleteOnCallHeaderAsHospital: 'Tem certeza que deseja excluir o hospital?',
    confirmDeleteWorkplace: 'Tem certeza que deseja excluir o local de trabalho?',
    demandWithoutSlotError: 'Selecione um horário',
    demandWorkplaces: 'Demanda de local de trabalho',
    demandOnCall: 'Demanda de plantão',
    slotWorkplaces: 'Turno de local de trabalho',
    slotOnCall: 'Turno de plantão',
    ofWorkplaces: 'de local de trabalho',
    ofOnCall: 'de plantão',
    demandWithoutUserError: 'Selecione pelo menos um anestesista ou uma tag que tenha um ou mais anestesistas',
    withoutValue: 'Sem valor',
    itemCore: 'Possui item manipulado pelo CoRE',
    onDutyNotClosed: 'Possui escala diária não fechada',
    closeCoreMonth: 'Fechar o mês',
    confirmCoreCloseMonth: 'Tem certeza que deseja fechar este mês? Depois de fechado, será bloqueado para mudanças.',
    coreMonthClosed: 'Mês fechado',
    updateCoreNow: 'Atualizar período',
    successUpdateMonth: 'Mês atualizado com sucesso',
    isPaidVacation: 'Férias remuneradas?',
    totalFactorDay: 'Total Fator do dia',
    totalValueDay: 'Total Valor do dia',
    hasVacation: 'Possui férias',
    vacationConfig: 'Configuração de Férias',
    weekdayVacationConfig: 'Dias da semana em que as férias são pagas',
    configFactorVacationByDay: 'Fatores para os dias selecionados',
    noneWeekdaySelected: 'Nenhum dia da semana selecionado',
    valueConfigVacation: 'Valor padrão das férias',
    deleteItemCore: 'Apagar item pelo CoRE',
    closeOnDutyCore: 'Fechar escala diária',
    confirmCloseOnDuty: 'Tem certeza que deseja fechar essa escala diária?',
    closedByCore: 'Fechado pelo CoRE',
    publish: 'Publicar',
    confirmPublishOnCall: 'Tem certeza que deseja publicar esse mês?',
    publishOnCallScheduleTooltip: 'Publicar escala de sobreaviso',
    published: 'Publicado',
    errorNotPublisherUser: 'Somente quem publicou pode editar o mês selecionado',
    confirmUpdateMonth: 'Esta ação irá reconstruir o mês no CORE e pode demorar alguns minutos. Deseja continuar?',
    updatingMonthInfo: 'Atualizando o mês no CORE. Por favor, aguarde um momento.',
    // Traduções para intervalDate
    startDate: 'Data Início',
    endDate: 'Data Fim',
    fetchData: 'Trazer Dados',
    maxIntervalDays: 'O intervalo máximo permitido é de {maxDays} dias',
    confirmUpdateInterval: 'Esta ação irá reconstruir o período selecionado no CORE. Deseja continuar?',
    successUpdateInterval: 'Período atualizado com sucesso!',
    updatingIntervalInfo: 'Atualizando período no CORE. Por favor, aguarde...',
    confirmCoreClosePeriod: 'Tem certeza que deseja fechar este período? Depois de fechado, será bloqueado para alterações.',
    closeCorePeriod: 'Fechar período',
    corePeriodClosed: 'Período fechado',
    closePeriodTooltip: 'Fechar o período para alterações',
    closedByTooltip: 'Fechado por',
    closedPeriods: 'Períodos Fechados',
    viewClosedPeriods: 'Ver períodos fechados',
    confirmReopenPeriod: 'Tem certeza que deseja reabrir este período?',
    periodReopened: 'Período reaberto com sucesso',
    closedPeriodColumn: 'Período',
    closedByColumn: 'Fechado por',
    noClosedPeriods: 'Nenhum período fechado',
    onCallLabel: 'Plantão',
    onDutyLabel: 'Diária',
    productionLabel: 'Produção',
    scheduleCharge: 'Cobranças',
    charge: 'Cobranças da Escala',
    chargeTypes: {
      DEFAULT_ONCALL: 'Padrão de plantão',
      DEFAULT_ONDUTY: 'Padrão de diária',
      ADDITIONAL_TOTAL: 'Adicional no total',
      ADDITIONAL_BASE: 'Adicional na base',
      BASE: 'Valor base',
    },
    chargeItemTypes: {
      HOSPITAL: 'Local de trabalho',
      ANESTHETIST: 'Anestesista',
      DEMAND: 'Demanda',
      SHIFT: 'Turno'
    },
    items: 'items',
    slotOnDuty: 'Turno de local de trabalho',
    onCall: 'Escala de plantão',
    scheduleType: 'Tipo de escala',
    chargeType: 'Tipo de cobrança',
    valueType: 'Tipo de valor',
    valueTypes: {
      VALUE: 'Valor',
      PERCENTAGE: 'Porcentagem',
    },
    negotiations: 'Negociações',
    addNegotiation: 'Adicionar Negociação',
    slots: 'Turnos',
    infinity: '∞',
    sameChargeNegotiationError: 'A nova negociação possui os mesmos dados da anterior',
    companyHasntDefaults: 'A empresa precisa ter os valores de "Padrão de Plantão" e "Padrão de Diária" configurados na Cobrança para ter acesso ao CORE.',
    reportsSchedule: 'Relatórios da Escala',
    total: 'Total',
    onDutyType: 'Diária',
    onCallType: 'Sobreaviso',
    changeLayoutTableTooltip: 'Trocar layout da tabela',
    changeLayoutTable: 'Trocar layout da tabela',
    downloadSchedulesTable: 'Baixar escala',
    downloadSchedulesTableTooltip: 'Baixar escala de sobreaviso',
    needschedulesToExport: 'Precisa de escalas para exportar',
    reportsWithoutPermissions: 'Sem permissões para acessar os relatórios.',
    additionOf: 'Acréscimo de',
    reductionOf: 'Decréscimo de',
    errors: {
      apiCallTitle: 'Erro ao buscar dados',
      apiCallText: 'Favor entrar em contato com o suporte'
    },
    notFilterConfigurationIfOnlyOnDuty: 'Não é possível filtrar Configuração em Escala Diária',
    notFilterConfigurationIfOnlyOnDutyAsHospital: 'Não é possível filtrar Hospital em Escala Diária',
  },
  contracts: {
    type: 'Tipo do contrato',
    taxesApplaying: 'Taxas aplicáveis',
    hospital: 'Hospital',
    hospitals: 'Hospitais',
    contract: 'Contrato',
    healthInsurances: 'Convênios',
    healthInsurance: 'Convênio',
    validity: 'Vigência do contrato',
    KDetermined: 'Determinado',
    KUndetermined: 'Indeterminado',
    beginValidity: 'Início da vigência',
    chartOfAccounts: 'Plano de contas',
    numberContract: 'Número do contrato',
    dateSignature: 'Data de assinatura',
    startValidity: 'Início da vigência',
    endValidity: 'Fim da vigência',
    billCollectionType: 'Tipo da cobrança',
    billCollectionDay: 'Dia da cobrança',
    KMonthly: 'Mensal',
    KBiannual: 'Semestral',
    KYearly: 'Anual',
    description: 'Descrição do contrato',
    contractCopy: 'Anexar cópia do contrato',
    chartOfAccount: 'Plano de contas',
    periodOfPayment: 'Período de pagamento',
    addPeriodOfPayment: 'Adicionar período de pagamento',
    save: 'Salvar',
    periodOfPaymentName: 'Nome do período de pagamento',
    paymentValidity: 'Vencimento',
    unitQuantity: 'Quantidade',
    measurementUnit: 'Unidade de medida',
    KDay: 'dias',
    KWeek: 'semanas',
    KMonth: 'meses',
    KYear: 'anos',
    positiveNumberError: 'Insira um número positivo',
    actions: 'Ações',
    confirmDeletePeriodOfPayment: 'Tem certeza que deseja excluir o período de pagamento?',
    deleteSuccess: 'Contrato deletado com sucesso',
    periodOfPaymentDeleteSuccess: 'Período de pagamento deletado com sucesso',
    changeActiveContract: 'Existe um contrato ativo para este convênio. Deseja substituí-lo?',
    dateBeginIsBeforeNowError: 'A data de ínicio da vigência precisa ser maior ou igual a data de hoje.',
    dateEndGreaterDateBeginError: 'A data de fim da vigência precisa ser maior que a de início.',
    current: 'Contrato corrente?',
    disabledActivedContract: 'Deseja realmente desativar o contrato ativo deste convênio?',
    contractInstallments: 'Parcelas do contrato',
    addContractInstallment: 'Adicionar parcela do contrato',
    installmentDueDate: 'Data de vencimento da parcela',
    installmentValue: 'Valor da parcela',
    addInstallments: 'Cadastrar parcelas?',
    biggerThanDateValidityError: 'A data da parcela precisa ser depois do início da vigência do contrato.',
    dateEndIsBeforeBeginError: 'A data de fim precisa ser maior que a de início.',
    dateInstallmentsConfig: 'Ajustar dia do pagamento',
    oneToTwentyEightRange: 'Selecione um dia entre 1 e 28.',
    confirmTotalInstallmentsDiff: 'O total das parcelas é diferente do valor do contrato. Deseja salvar o contrato mesmo assim?',
    errorOnSaveInstallments: 'Erro ao tentar salvar parcelas do contrato.',
    isInvoiceFromContract: 'Nota de Contrato?',
    installments: 'Parcelas do contrato',
    installmentsValueBiggerThanContractValueError: 'Em contrato de valor fixo o valor das parcelas não pode ser maior que o valor do contrato.',
    confirmDeleteInstallment: 'Tem certeza que deseja apagar esta parcela do contrato?',
    installmentDeletedSuccess: 'Parcela apagada com sucesso',
    default: 'Padrão do sistema *',
    startPaymentDate: 'Data do início do pagamento',
    selectType: 'Selecione o tipo:',
    qtDays: 'Qtd. de dias',
    dayFixed: 'Dia fixo',
    selectTypeDayFixed: 'Selecione o tipo de dia fixo:',
    selectDayWeek: 'Selecione o dia da semana:',
    selectDayOfMonth: 'Selecione o dia do mês:',
    selectDayYear: 'Selecione o dia do ano',
    periodOfPaymentsTypes: {
      KDay: 'Dia',
      KMonth: 'Mês',
      KWeek: 'Semana',
      KDayFixedWeek: 'Dia da semana',
      KDayFixedMonth: 'Dia do mês',
      KDayFixedYear: 'Dia do ano',
    },
    quantityDaysType: 'Quantidade de dias',
    dayWeek: {
      '1': 'Domingo',
      '2': 'Segunda',
      '3': 'Terça',
      '4': 'Quarta',
      '5': 'Quinta',
      '6': 'Sexta',
      '7': 'Sábado',
    },
    dayWeekSelected: 'Dia da semana selecionado',
    invalidDateError: 'Por favor, selecione uma data válida, de acordo com o período de pagamento selecionado.',
    KHour: 'Divisão de horas',
    KEvent: 'Eventos',
  },
  contractBilling: {
    importDivideHour: 'Importar divisão de horas',
    import: 'Importar',
    customHourCost: 'Custo fixo por hora',
    hourCost: 'Custo por hora',
    customTotalTransfer: 'Valor transferido customizado',
    totalTransfer: 'Total a ser transferido',
    contract: 'Contrato',
    contracts: 'Contratos',
    periodOfPayment: 'Período de pagamento',
    duration: 'Duração',
    startValidity: 'Início vigência',
    endValidity: 'Fim vigência',
    contractValue: 'Valor do contrato',
    valueReceived: 'Valor recebido',
    valueToReceived: 'A receber',
    valueNotReceived: 'Valor não recebido',
    predictionValue: 'Valor de predição',
    installments: 'Parcelas',
    viewEvents: 'Ver eventos',
    intervalYear: 'Ano',
    intervalMonth: 'Mês',
    intervalCustom: 'Customizado',
    dateYear: 'Ano',
    active: 'Ativo',
    inactive: 'Inativo',
    installmentDate: 'Data da parcela',
    installmentValue: 'Valor da parcela',
    waitPayment: 'Aguard. Pagamento',
    received: 'Recebido',
    receiveInstallment: 'Receber parcela',
    actionsOnContract: 'Ações no contrato',
    noDataAvailable: 'Não há dados disponíveis',
    noInstallmentsAvailable: 'Não há parcelas cadastradas para este contrato',
    invoice: 'Nota',
    confirmReceiveAllInstallment: 'Tem certeza que deseja marcar essa parcela de contrato como recebida?',
    addInvoice: 'Adicionar nota',
    closeContract: 'Finalizar contrato',
    confirmCloseContract: 'Deseja realmente fechar o contrato?',
    successOnCloseContract: 'Contrato fechado com sucesso',
    isFixedValue: 'Valor fixo?',
    isFixedValueInfo: '* Quando ativado o valor do contrato deve ser informado. E, o valor total das parcelas não pode ser maior que o valor do contrato. Quando desativado, o valor total do contrato é computado a partir dos valores das parcelas.',
    residentNotAllowed: 'Acesso Negado: Contrato',
    KOpen: 'Corrente',
    KWaitPayment: 'Aguard. Pagamento',
    KClosed: 'Finalizado',
    contractHours: 'Dividir horas',
    contractHoursTitle: 'Divisão de horas da parcela',
    addAnesthetist: 'Adicionar anestesista',
    addDivideHourItem: 'Adicionar item',
    anesthetist: 'Anestesista',
    company: 'Serviço',
    value: 'Valor',
    qtdHours: 'Horas',
    remaining: 'Restante',
    total: 'Total',
    hoursDivisionErrorSave: 'Error ao salvar divisão de horas',
    hoursDivisionSuccessSave: 'Divisão de horas salva com sucesso',
    releasedForTransfer: 'Liberado para repasse?',
    confirmReleasedForTransfer: 'Deseja realmente marcar a divisão de horas como liberada para repasse?',
    discounts: 'Descontos',
    remainingTotalError: 'O valor restante precisa ser zero',
  },
  form: {
    dueDate: 'Data prevista',
    none: 'Nenhum',
    selectFormToResponse: 'Selecione o formulário a ser respondido',
    formsAvailable: 'Formulários disponíveis',
    errors: {
      expired: 'Formulário expirado',
      alreadyResponded: 'Formulário já foi respondido'
    },
    statusForm: {
      responded: 'Formulário respondido',
      requiredNotResponded: 'Formulário obrigatório não respondido',
      optionalNotResponded: 'Formulário opcional não respondido'
    },
    warnings: {
      atLeastOneColumn: 'Precisa haver pelo menos um item selecionado',
      dateStartAfterDateEnd: 'Data Fim não pode ser anterior à Data Início',
    },
    document: 'Documento',
    pix: 'Pix',
    createAt: 'Criar em',
    begin: 'Início',
    end: 'Fim',
    start: 'Começo',
    invoiceCode: 'Nº nota',
    userInspector: 'Conferente',
    filtersOptionsOfBatchuserInspectors: 'Opções de Filtragem dos Conferentes/Responsaveis dos lotes',
    userInspectorsOnRespectiveBatches: 'Conferentes dos respectivos lotes',
    noUserInspectorContains: 'Não Possui Conferente',
    userInspectorContains: 'Possui Conferente',
    userInspectorSpecific: 'Conferente Específico',
    specificTo: 'Específico para ',
    totalValueOverAvailable: 'Valor do over disponível: ',
    payWithValueFromOver: 'Pagar com valor do over',
    checkTransactions: 'Confira as transações',
    checkTransactionsBecauseHasOver: 'Confirme as transações antes de salvar, porque há valor de over no evento.',
    crfaState: 'Estado CRFA',
    teamType: 'Ator',
    number: 'Número',
    flags: 'Flags',
    responseMsgOnSaveItem: {
      success: 'Salvo com sucesso',
      cantDeleteParentNode: 'Não é possível excluir uma categoria sintética (com filhos ativos)',
      isDefaultCategory: 'Não é possível excluir uma categoria configurada como padrão da empresa',
      notFound: 'Registro não encontrado',
      unknown: 'Não foi possível concluir a operação',
    },
    chartOfAccountsDefaultsTitle: 'Categorias padrão',
    chartOfAccountsDefaultsHint: 'Defina qual categoria do plano de contas cada papel do sistema usa ' +
      '(repasse, impostos, receitas). Use "Aplicar plano padrão" para criar os registros sugeridos.',
    chartOfAccountsDefaultsSaved: 'Categorias padrão salvas',
    applyChartOfAccountsPreset: 'Aplicar plano padrão',
    applyChartOfAccountsPresetConfirm: 'Criar os registros padrão do plano de contas que ainda não ' +
      'existem e preencher as categorias padrão não configuradas?',
    applyChartOfAccountsPresetDone: '{created} registro(s) criado(s), {skipped} já existente(s)',
    jobRole: 'Cargo',
    otherContacts: 'Outros contatos',
    addContact: 'Adicionar contato',
    suframaEnrollment: 'Inscrição suframa',
    cityEnrollment: 'Inscrição municipal',
    stateEnrollment: 'Inscrição estadual',
    stateEnrollmentType: 'Tipo de inscrição estadual',
    stateInscriptionType: 'Inscrição estadual',
    enrollments: 'Inscrições',
    chooseNationalSimple: 'Optante pelo Simples Nacional',
    taxInfos: 'Informações adicionais',
    dtOpenCompany: 'Data de abertura da conta',
    cellphone: 'Celular',
    chartOfAccounts: 'Plano de contas',
    parentNode: 'Nó pai',
    changeOnlyOnCreate: 'Só pode ser alterado na criação',
    isAnalytical: 'É analítico',
    isAnalyticalHint: 'Se falso, então será sintético',
    addChartOfAccountRevenue: 'Adicionar Receita',
    addChartOfAccountExpense: 'Adicionar Despesa',
    addChartOfAccountBankAccount: 'Adicionar Conta Bancária',
    addChartOfAccount: 'Adicionar plano de conta',
    editChartOfAccount: 'Editar plano de conta',
    limitValue: 'Valor de limite',
    brand: 'Bandeira',
    account: 'Conta',
    agency: 'Agência',
    accountNumber: 'Número da conta',
    bank: 'Banco',
    alias: 'Alias',
    voucher: 'Ticket',
    debit: 'Débito',
    credit: 'Crédito',
    percent: 'Porcentagem a ser cobrada',
    isVisibleClient: 'Visível ao cliente',
    isDeployed: 'Em produção?',
    isDeployedDev: 'Em Dev?',
    environments: 'Ambientes',
    markAsAccepted: 'Marcar como aceito',
    accepted: 'Aceito',
    filterable: 'Filtrável',
    addOnObsGuide: 'Adicionar nas Observações da Guia',
    searchable: 'Buscável',
    info: {
      listOptionsEventInBatch: {
        title: 'Detalhes sobre as opções: ',
        info: '<div style="display: flex; flex-direction: column"> ' +
          '<div style="margin: 0 0 10px 0;"><b>Quando cada ação estará disponível:</b></div> ' +
          '<div style="display: flex; flex-direction: column; margin: 0 0 10px 10px;">' +
          '<div><b>Editar dados adicionais:</b></div> <div style="margin-left: 10px;">Em qualquer status do evento ou do lote.</div></div>' +
          '<hr>' +
          '<div style="display: flex; flex-direction: column; margin: 10px 0 0 10px;"> <div><b>Alterar lote e Remover do lote:</b></div> <div style="margin-left: 10px;">Somente em alguns status específicos do evento:</div>' +
          '<div style="display: flex; flex-direction: column; margin-left: 20px;"><b>Aguardando conferência;</b><b>Customizado;</b><b>Pendente;</b><b>Aguardando envio de guia;</b><b>Aguardando pagamento;</b></div>' +
          '<div style="margin: 10px 0 10px 10px;">Haverá uma segunda validação para estas ações porque elas não podem ser executadas se houver transações ativas relacionadas ao lote em que o evento está inserido.</div>' +
          '</div>' +
          '<hr>' +
          '</div>'
      }
    },
    changeBatch: 'Trocar evento de lote',
    removeEventBatch: 'Remover evento do lote',
    searchAppealsField: 'Buscar pelo número da guia ou nome do paciente',
    searchAppeals: 'Filtrar itens do recurso',
    batchCode: 'Código do lote',
    isFollowUp: 'É retorno',
    shouldBeFollowUp: 'Deveria ser retorno',
    notFollowUpNeitherShouldBe: 'Não é retorno e nem deveria ser',
    mode: 'Modo',
    templates: 'Templates',
    isTemplate: 'É template? (não é necessário publicar o formulário)',
    published: 'Publicado',
    attachmentsName: 'Anexos',
    invoiceNumber: 'Nº nota',
    emergency: 'Emergência',
    noCompanyBinded: 'Nenhuma Empresa Vinculada',
    elective: 'Eletiva',
    _totalOpened: 'Valor em aberto',
    resolvedReports: 'Relatório de baixas',
    cobrancas: 'Cobranças',
    filterBy: 'Filtrar por',
    filterBatchesBy: 'Filtrar lotes por',
    showCobrancasResolved: 'Visualizar baixados por cobrança',
    cannotRemoveProcedureAfterSentAppeal: 'Não pode ser removido depois que o recurso foi enviado',
    canRemoveProcedure: 'Remover procedimento',
    markedToAppeal: 'Marcado para recursar',
    qtdProcedures: 'Qtd. procedimentos',
    addProcedures: 'Adicionar procedimentos',
    reasonAppealed: 'Justificativa',
    numberGuide: 'Nº Guia',
    numberWallet: 'Carteirinha',
    startBilling: 'Início Fat.',
    endBilling: 'Fim Fat.',
    procedure: 'Procedimento',
    dtAppealed: 'Data do recurso',
    cutReason: 'Motivo da glosa',
    totalValue: 'Valor',
    totalAppealed: 'Valor do recurso',
    totalReceivedAppeal: 'Valor recebido do recurso',
    totalAccepted: 'Valor do acatado',
    reasonProvider: 'Justificativa prestador',
    appeal: 'Recurso',
    xml: 'XML',
    successDownload: 'Download gerado com sucesso!',
    errorDownload: 'Erro ao gerar download!',
    addEvent: 'Adicionar evento',
    numberGuideAppealByOperator: 'Número da guia de recurso de glosas atribuído pela operadora',
    objectAppealName: 'Objecto de recurso',
    objectAppeal: {
      guide: 'Recurso de guia',
      protocol: 'Recurso de protocolo',
    },
    guide: 'Guia',
    reasonGuideAppeal: 'Justificativa (no caso de recurso integral da guia)',
    cutReasonGuide: 'Código da glosa da guia',
    numberGuideOperator: 'Número da guia no operador',
    numberGuideProvider: 'Número da guia no prestador',
    guideDataAppeal: 'Dados do recurso da guia',
    reasonProtocolAppeal: 'Justificativa (no caso de recurso integral do protocolo)',
    cutReasonProtocol: 'Código da glosa do protocolo',
    numberProtocol: 'Número do protocolo',
    protocolDataAppeal: 'Dados do recurso do protocolo',
    batchData: 'Dados do lote',
    batchResource: 'Lote do recurso',
    willNotUseInAppeal: 'Este nome não será utilizado no recurso, serve apenas para identificar o recurso',
    createTypesOfPayment: 'É necessário criar os tipos de pagamento',
    createPeriodOfPayment: 'É necessário criar os períodos de pagamento',
    installmentsAmount: 'Quantidade de parcelas',
    installmentValue: 'Valor da parcela',
    periodOfPayment: 'Período dos pagamentos',
    typeOfPayment: 'Forma de pagamento',
    startPaymentDate: 'Data do início do pagamento',
    fieldName: 'Nome do campo',
    save: 'Salvar',
    username: 'Username',
    saveAndDownloadPatternSheetTable: 'salvar e baixar tabela modelo',
    generateBy: 'Gerar por:',
    optionsGenerateBy: {
      numberGuide: 'Nº Guia',
      infoAssociation: 'Associação de Informações',
    },
    optionsAssociateBy:{
      typeEvent: 'Tipo',
      dateTime: 'Data / Hora',
      patient: 'Paciente',
      insuranceWallet: 'Carteirinha do Convênio',
      anesthetist: 'Anestesista',
      surgeon: 'Cirurgião',
    },
    associateBy: 'Associar por:',
    minTwoSelections: 'Selecione pelo menos 2 opções',
    proceduresByRow: 'Procedimentos por Linha',
    typeNumberWallet: 'Digitar número da Carteirinha do Convênio',
    addressName: 'Endereço',
    AXREG: 'AxReg',
    SPREADSHEET: 'Planilha',
    axreg: 'AxReg',
    spreadsheet: 'Planilha',
    anesthesiaMinutesHint: 'Se não digitar nada, ficará disponível para preencher na planilha. Se digitar um valor menor do que 1, também ficará disponível para preencher na planilha.',
    anesthesiaMinutes: 'Tempo da anestesia, em minutos',
    selectAnesthesiaStartAndEnd: 'Hora de início e fim da anestesia',
    showMinutesInterval: 'Selecionar tempo de intervalo entre os eventos',
    minutesInterval: 'Minutos de intervalo entre os eventos',
    minutesIntervalHint: 'Intervalo de tempo entre os eventos',
    showOnlyPayers: 'Mostrar apenas empresas pagantes',
    no: 'Não',
    nickName: 'Apelido',
    isPayer: 'Empresa pagante',
    typeObservation: 'Digitar a observação',
    addCustomFields: 'Adicionar Campos Customizados',
    typePatientEmail: 'Digitar o email do paciente',
    typePatientAddress: 'Digitar o endereço do paciente',
    selectSecondaryAnesthetist: 'Selecionar segundo anestesista',
    selectResident: 'Selecionar residente',
    selectAccommodation: 'Selecionar acomodação',
    showOptionalItems: 'Mostrar itens opcionais para criar evento.',
    showMandatoryItems: 'Mostrar itens obrigatórios para criar evento.',
    companies: 'Empresas',
    company: 'Empresa',
    patientNoCPFInImportation: 'Paciente sem cpf ou cpf inválido, no momento da importação',
    integrationConfig: {
      showOnlyDone: 'Mostrar somente eventos realizados',
      importOnlyDone: 'Importar do AxReg somente eventos realizados',
      showActiveOnly: 'Mostrar somente integrações ativas',
    },
    companyData: 'Dados da emrpesa: ',
    healthInsuranceData: 'Dados do convênio: ',
    hospitalData: 'Dados dos hospitais: ',
    surgeonData: 'Dados dos cirurgiões: ',
    anesthetistData: 'Dados dos anestesistas: ',
    eventData: 'Dados dos eventos: ',
    additionalData: 'Dados adicionais: ',
    showAdditionalData: 'Dados adicionais ',
    mandatoryFieldsInXML: 'Campos obrigatórios para enviar XML: ',
    mandatoryFieldsInNewEvent: 'Campos obrigatórios para criar um evento: ',
    scheduleConfig: {
      workplaceValue: 'Valor padrão na escala diária',
      onCallScheduleValue: 'Valor padrão do plantão na escala',
      minimumTradeTimeInHours: 'Tempo mínimo para solicitar troca de plantão',
      minimumTradeTimeInHoursHint: 'Tempo em horas e minutos. Ex: 14:30 antes do plantão é o tempo mínimo para solicitar a troca.',
      allowedUserTypes: 'Tipos de usuário na Escala',
      allowedUserTypesHint: 'Deixe vazio para mostrar todos.'
    },
    initialsLengthError: 'A sigla deve ter entre 2 e 4 caracteres',
    addInstitutionKey: 'Adicionar chaves de instituição',
    addObservation: 'Adicionar observação',
    observation: 'Observação',
    observations: 'Observações',
    integratorKey: 'Chave de integração',
    institutionKey: 'Chave de instituição',
    nameInstitution: 'Nome da instituição',
    companyName: 'Nome da empresa',
    institutionKeys: 'Chaves de instituições',
    mainKey: 'Chave principal',
    answerRequired: 'Resposta obrigatória',
    yes: 'Sim',
    not: 'Não',
    idProc: 'Procedimento',
    porte: 'Porte',
    portePercent: 'Porcentagem do porte',
    portePercentHint: '0 representa 0%, 0.5 representa 50% e 1 representa 100%.',
    porteAnestesico: 'Porte anestésico',
    sendMail: 'Enviar email',
    cell: 'Celular',
    state: 'UF',
    concludeAndSendEmail: 'Concluir e enviar email',
    notFound: 'Não encontrado',
    quantity: 'Quantidade',
    quantityEvents: 'Qtd. eventos',
    answers: 'Respostas',
    allAnswers: 'Todas respostas',
    isAdmin: 'É administrador',
    all: 'Todos',
    today: 'Hoje',
    lastWeek: 'Últimos 7 dias',
    lastMonth: 'Últimos 30 dias',
    custom: 'Customizado',
    selectForm: 'Selecionar formulário',
    form: 'Formulário',
    restrictFilial: 'Restringir Filial',
    createdBy: 'Criado por',
    taxe: 'Taxa',
    taxeLabel: 'valor da taxa',
    selectCBHPM: 'Selecione a CBHPM',
    attachment: 'Anexo',
    attachments: {
      logoUrl: 'Logo',
      attachment: 'Anexo',
      addNewAttachment: 'Adicionar anexo',
    },
    mandatoryKeys: 'Chave primária obrigatória: ',
    patient: 'Paciente',
    patientCPF: 'CPF do paciente',
    cbo: 'Código CBO',
    companyAccess: 'Acesso da Empresa',
    companyInfo: 'Informações da Empresa',
    companyContract: 'Contrato da Empresa',
    adminAccess: 'Acesso do Administrador',
    user: 'Nome de usuário',
    emailAdmin: 'Email administrador',
    userAdmin: 'Nome administrador',
    dateLimitStartUse: 'Limite para começar a usar',
    contractSignedAt: 'Contrato assinado em',
    cnes: 'Código CNES',
    tradeName: 'Razão social',
    selectInvoices: 'Selecione as notas',
    addInvoice: 'Adicionar nota',
    dateProcessing: 'Data de processamento',
    dateInvoice: 'Data da nota',
    dateBatch: 'Data do lote',
    dateSent: 'Data de envio do lote',
    dateCobranca: 'Data de Cobrança',
    favored: 'Favorecido',
    note: 'Observação',
    hospitals: 'Hospitais',
    hospital: 'Hospital',
    momName: 'Nome da mãe',
    hasCPF: 'Tem CPF?',
    healthInsurances: 'Convênios',
    healthInsurance: 'Convênio',
    anesthetists: 'Anestesistas',
    anesthetist: 'Anestesista',
    surgeons: 'Cirurgiões',
    type: 'Tipo',
    crmState: 'UF CRM',
    speciality: 'Especialidade',
    idCrmState: 'Id Estado do CRM',
    axregId: 'Axreg Id',
    specialty: 'Especialidade',
    insuranceWallet: 'Carteira do convênio',
    gender: {
      male: 'Masculino',
      female: 'Feminino',
      other: 'Outro',
      m: 'Masculino',
      f: 'Feminino',
      o: 'Outro',
    },
    tellTheSex: 'Informe o sexo',
    birthDate: 'Data de nascimento',
    code: 'Código',
    value: 'Valor',
    error: {
      cantAddOverWithLosed: 'A soma dos valores já adicionados mais o valor perdido não pode ser maior que o valor do procedimento',
      cantAddOverWithGlosado: 'A soma dos valores já adicionados mais o valor glosado não pode ser maior que o valor do procedimento',
      cantAddOverWithDiscounted: 'A soma dos valores já adicionados mais o valor descontado não pode ser maior que o valor do procedimento',
      error: 'Erro',
      invalidAmountHours: 'Quantidade de horas e minutos inválida',
      needSelectHealthInsurance: 'É necessário selecionar um convênio',
      requireFields: 'Há campos obrigatórios ainda não preenchidos',
      warning: 'Atenção',
      startAndEndTitle: 'Hora de início e fim',
      startCantBeBefore: 'Hora de início não pode ser maior ou igual a hora de fim!',
      anesthesiaStartBeforeProcedureStart: 'A hora de início da anestesia não pode ser antes da hora de início do procedimento!',
      anesthesiaEndAfterProcedureEnd: 'A hora de fim da anestesia não pode ser depois da hora de fim do procedimento!',
      startAndEnd: 'Escolha o horário de início e fim do procedimento',
      invalidCPF: 'CPF  inválido',
      invalidNit: 'NIT inválido',
      justNumbers: 'Digite apenas números',
      dateOutOfRange: 'Data fora do intervalo permitido (o ano deve estar entre 0001 e 9999)',
      invalidHour: 'Informe a hora completa, de 00:00 até 23:59',
      invalidDate: 'Data inválida',
      required: 'Esse campo é requerido',
      needPositive: 'Esse número precisa ser positivo',
      minLengthRequired: 'O tamanho mínimo é: ',
      maxLengthRequired: 'O tamanho máximo é: ',
      minLength: 'O campo é muito curto',
      maxLength: 'O campo é muito longo',
      update: 'Algo deu errado, tente novamente',
      email: 'Email inválido',
      image: {
        type: 'Tipo de arquivo inválido, esperado: PNG, JPEG',
        upload: 'Erro ao fazer ulpload da imagem, tente novamente mais tarde!'
      },
      invalidValue: 'Entrada inválida',
      formInvalid: 'Campo inválido',
      uploadImage: 'Erro ao fazer upload de imagem',
      closeEditor: 'Conclua ou cancele o editor antes de proseguir',
      showOnMenu: 'Mostrar no menu',
      regionAreaName: 'Erro ao obter nome da área da região',
      schedule: 'Erro a reduzir número de escalas',
      scheduleMax: 'Número máximo de escalas atingido',
      tagType: 'A tag deve ser aplicável a produtos e ou empresas',
      companyNeedApproved: 'É preciso aprovar a empresa para habilitar',
      needOnePayment: 'É necessário selecionar pelo menos uma forma de pagamento aceita(Pelo App ou na Entrega)',
      NeedRegion: 'É necessário definir uma região',
      changeOnlyAdmin: 'Entre em contato com o suporte para efetuar essa ação',
      passwordRequired: 'A senha é necessária',
      emailRequired: 'O email é necessário',
      createUser: 'Erro ao criar autenticação do usuário',
      changePassword: 'Erro ao alterar senha do usuário',
      changeEmail: 'Erro ao alterar email do usuário',
      cpfInvalid: 'CPF inválido',
      cpfExist: 'O CPF já existe',
      cpfError: 'Erro ao validar o cpf',
      copiedToClipboard: 'Falha ao copiar para o Clip Board',
      passwordConfirmError: 'As senhas são diferentes',
      passwordTryChange: 'Erro ao tentar alterar a senha',
      uploadError: 'Erro ao fazer upload',
      uploadErrorContinueAsk: 'Deseja salvar o evento sem fazer o upload?',
      isMatrizLocked: 'Só é possível alterar essa flag na criação',
      accessCompanyId: 'Acesso negado',
      emptyAddress: 'Nenhum endereço encontrado',
      listAddressError: 'Erro ao buscar endereço',
      validateAddressError: 'Erro ao validar endereço',
      onlyOnNew: 'Editável apenas na criação',
      needAddEvent: 'É necessário adicionar pelo menos 1 evento',
      companyNeed: 'Selecione uma empresa',
      exportEventToContaAzulTitle: 'Erro ao exportar evento para a Conta Azul',
      exportEventToContaAzulMsg: 'Tente novamente ou entre em contato com o suporte.',
      exportEventToContaAzulUnauthorized: 'Seu usuário não tem permissão para exportar para a Conta Azul, ou a sessão expirou. Entre de novo no Volan; se continuar, peça acesso ao administrador da empresa.',
    },
    update: 'Atualizar',
    corporateName: 'Razão social',
    updateSuccess: 'Dados salvos',
    onlySuccess: 'Sucesso',
    ownerName: 'Nome do proprietário',
    emailPlaceholder: 'Adicione o e-mail do paciente',
    email: 'Email',
    password: 'Senha',
    currentPassword: 'Senha antiga',
    newPassword: 'Nova senha',
    passwordConfirmation: 'Confirmação da nova senha',
    continue: 'Continuar',
    cnpj: 'CNPJ',
    cpf: 'CPF',
    nit: 'NIT',
    name: 'Nome',
    specialtyName: 'Nome da especialidade',
    prevStep: 'Etapa Anterior',
    nextStep: 'Próxima etapa',
    conclude: 'Concluir',
    customFieldsUserSheetTitle: 'Campos Customizados da Tabela',
    close: 'Fechar',
    cancel: 'Cancelar',
    generateSheet: 'Gerar Planilha',
    changePrimaryColor: 'Alterar cor primária',
    changeSecondaryColor: 'Alterar cor secundária',
    emailResetSuccess: 'Em instantes você receberá um email para redefinir a sua senha',
    emailResetError: 'Houve um erro ao tentar enviar email de redefinição de senha',
    changePassword: 'Alterar Senha',
    passwordNew: 'Nova Senha',
    passwordOld: 'Senha atual',
    address: {
      label: 'Endereço',
      city: 'Cidade',
      complement: 'Complemento',
      country: 'Pais',
      district: 'Bairro',
      number: 'Número',
      search: 'Buscar Endereço',
      state: 'Estado',
      street: 'Rua',
      zipcode: 'CEP',
      fieldWarning: 'Erro ao buscar endereço',
      emptyResult: 'Nenhum endereço encontrado',
      codigoIBGEMunicipio: 'Código IBGE município',
    },
    contact: 'Contato',
    description: 'Descrição',
    descriptionInternal: 'Descrição interna',
    phone: 'Telefone',
    contactPhone: 'Telefone para contato',
    delete: 'Deletar',
    confirmDelete: 'Tem certeza que deseja deletar?',
    edit: 'Editar',
    add: 'Adicionar',
    permission: 'Permissão',
    active: 'Ativo',
    inactive: 'Inativo',
    isActive: 'Ativo?',
    create: 'Criar',
    isMandatory: 'Obrigatório',
    print: 'Imprimir',
    showIds: 'Mostrar Ids',
    visible: 'Visísvel',
    required: 'Obrigatório',
    getDeliveryAreaName: 'Nome da área de entrega',
    getRegionName: 'Nome da área da região',
    uniqueName: 'Identificador único',
    slug: 'Slug(url)',
    title: 'Título',
    subTitle: 'Legenda',
    bodyText: 'Texto',
    abstract: 'Resumo',
    response: 'Resposta',
    category: 'Categoria',
    isAdvanced: 'Edição avançada',
    alert: {
      selectedIsEmpty: 'Não há itens selecionados',
      confirmChangeBatch: 'Deseja realmente mover o evento para o lote: ',
      emailAddSuccess: 'Email adicionado com sucesso',
      hasChangesPending: 'Há alterações pendentes, Tem certeza que deseja fechar?',
      importSuccess: 'Importado com sucesso',
      informationImportScratched: 'Registros riscados já existem no sistema',
      informationRedError: 'Registros em vermelho contém erro e não serão importados',
      confirmNoRevert: 'Tem certeza que deseja concluir essa ação?',
      isToUpDateInformations: 'Deseja atualizar as informações já existentes?',
      isToUpDateInformationsByProcId: 'Deseja atualizar as informações já existentes com base no id do procedimento?',
      notUpdate: 'Não atualizar',
      confirmRemove: 'Deseja realmente remover os registros?',
    },
    region: 'Região',
    isTest: 'Mostrar em teste',
    isNew: 'novo',
    regionAll: 'Todas as Regiões',
    selectUser: 'Selecione o usuário',
    selectUsers: 'Selecione os usuários',
    selectCompany: 'Selecione a empresa',
    selectCompanies: 'Selecione as empresas',
    link: 'Link',
    search: 'Buscar',
    color: 'Cor',
    createdAt: 'Criado em',
    selectRules: 'Selecione os acessos',
    promptQuestion: '',
    confirmQuestion: 'Você tem certeza?',
    confirmQuestionYes: 'Concluir',
    confirmQuestionCancel: 'Cancelar',
    choseNewPassword: 'Escolha uma nova senha',
    fixUserAuth: 'Corrigir Auth do usuário',
    rules: 'Acessos',
    crm: 'CRM',
    isAnesthetist: 'É anestesista',
    copiedToClipboard: 'Url copiada para o clipboard',
    accessCompany: 'Acessar empresa',
    isMatriz: 'É Matriz? (Utilizado para cooperativa, não pode ser alterado depois de criada a empresa)',
    isFilial: 'É filial?',
    matrizName: 'Empresa matriz',
    eventsGeneralConfig: 'Configurações gerais do lançamento de eventos',
    next: 'Próximo',
    linkUser: 'Vincular o usuário {user} na empresa {company}',
    removeFromCompany: 'Remover da empresa',
    removeFromCompanyConfirm: 'Tem certeza que deseja desvincular o usuário da empresa?',
    removeFromCompanySuccess: 'Usuário removido da empresa com sucesso.',
    removeFromMatriz: 'Remover da matriz cooperativa',
    removeFromMatrizConfirm: 'Tem certeza que deseja desvincular o usuário da matriz cooperativa? O acesso às filiais não será alterado.',
    removeFromMatrizSuccess: 'Usuário removido da matriz cooperativa com sucesso.',
    selfLockWarn: 'Você não pode remover a si mesmo da matriz.',
    filiaisRemanescentes: 'Usuário ainda possui acesso ativo em {count} filial(is). Revise manualmente se necessário.',
    selectAccess: 'Selecione os acessos do usuário nessa empresa',
    addProcedure: 'Adicionar procedimento',
    addProcedureCustom: 'Adicionar procedimento customizado',
    utcOffset: 'UtcOffset',
    numberBatch: 'Número do lote',
    numberInvoice: 'Número da nota',
    generateHonorarioXml: 'Gerar XML de guia de Honorário',
    generateSADTXml: 'Gerar XML de guia de SP/SADT',
    generateConsultationXml: 'Gerar XML de guia de Consulta',
    sequencialTransacao: 'Sequencial Transação',
    actions: 'Ações',
    status: 'Status',
    errorTitle: 'Error',
    updatedAt: 'Atualizado em',
    id: 'Id',
    selectFile: 'Selecione o arquivo',
    done: 'Ok',
    limitReached: 'Limite alcançado',
    date: 'Data',
    genderTitle: 'Sexo',
    countEvents: 'Quantidade de eventos',
    maxEvents: 'Máx. eventos',
    healthInsuranceName: 'Nome do convênio',
    isClosed: 'Lote fechado?',
    isSend: 'Lote aceito?',
    isVolanUser: 'É usuário do Volan?',
    isVolanUserInfo: 'Usuários Volan não aparecem no Core da Escala',
    batch: 'Lote',
    eventType: 'Tipo de Evento',
    customProportionOnProcedureName: 'Nome da via de acesso customizada',
    customProportionOnProcedureProportion: 'Proporção',
    reportNameToDownload: 'Nome do Relatório para Download',
    needSelectItems: 'Obrigatório Selecionar Itens',
    intervalTabItems: 'Filtros para o relatório',
    addItem: 'Adicionar item',
    reports: {
      getDataExtraParams: {
        getDataExtraParams: 'Parâmetros extras para buscar itens',
        name: 'Nome',
        component: 'Componente para buscar'
      },
      params: {
        params: 'Parâmetros do relatório',
        mandatory: 'Obrigatório',
        name: 'Name',
        type: 'Type',
        value: 'Value'
      },
      configs: {
        bind: 'Bind',
        bindItems: 'Items de Bind',
        field: 'Campo',
        type: 'Tipo',
        value: 'Propriedade do objeto',
        method: 'Nome do Método',
        ifTrue: 'Se Verdadeiro',
        ifFalse: 'Se Falso',
        args: 'Argumentos',
        timestamp: 'Data Origem Timestamp',
      },
      multiselect: 'Multiselect',
      displayHandlers: {
        notFound: 'Controle de exibição não encontrado',
        title: 'Controle de exibição',
        defaultCompany: 'Empresa padrão',
        matrizCompany: 'Empresa Matriz (Cooperativa)',
        filialCompany: 'Empresa Filial (Cooperado)',
        personalProductionCompany: 'Empresa de Produção Pessoal'
      }
    },
    optionDownloadOpenAppealXLSX: 'Recursos em Planilha',
    optionDownloadOpenAppealPDF: 'Recursos em Aberto em PDF',
    optionSheetFromSentToAppeal: 'Planilha de Recursos Enviados',
    titleSheetFromSentToAppeal: 'Selecione Os Recursos Enviados',
    showProceduresToAppeal: 'Visualizar Marcados para Recursar',
    showOpenAppeals: 'Visualizar Recursos em Aberto',
    OptionsOfVizualization: 'Opções de Visualização',
    downloadPDFGuide: 'Baixar Guia em PDF',
    downloadXLSXSheet: 'Baixar em Planilha',
    openAppeals: 'Recursos em Aberto',
    resumeAppeal: 'Resumo do Recurso',
    observationMatriz: 'Observações para a Matriz',
    observationFilial: 'Observações para a Filial',
  },
  navBar: {
    meet: 'Meet',
    home: 'Home',
    services: 'Serviços',
    aboutUs: 'Sobre nós',
    contact: 'Contato',
    blog: 'Blog',
    singIn: 'Torne-se um parceiro',
    logIn: 'Entrar',
    logOut: 'Sair',
    manual: 'manual',
    isOffLine: 'Desconectado',
    faq: 'Faq'
  },
  systemLineGuard: {
    title: 'Esta empresa usa outro endereço do Volan',
    text: 'A empresa {company} deve ser acessada por {url}.',
    textNoUrl: 'A empresa {company} está configurada para outro sistema do Volan. Fale com o suporte.',
    open: 'Ir para {url}',
    changeCompany: 'Trocar de empresa',
    adminWarning: 'Empresa configurada como "{line}". Aqui o usuário comum é bloqueado; o endereço certo é {url}.',
    adminWarningNoUrl: 'Empresa configurada como "{line}". Aqui o usuário comum é bloqueado.',
    adminWarningMatriz: 'A matriz desta filial está configurada como "{line}". Aqui o usuário comum é bloqueado; o endereço certo é {url}.',
    adminWarningMatrizNoUrl: 'A matriz desta filial está configurada como "{line}". Aqui o usuário comum é bloqueado.',
  },
  notifications: {
    title: 'Notificações',
    empty: 'Nenhuma notificação no momento',
    markAllAsRead: 'Marcar todas como lidas',
    markAsSolved: 'Resolver',
    deadlineApproaching: 'Prazo de {type} em {days} dias',
    deadlineExpired: 'Prazo de {type} vencido há {days} dias',
    deadlineType: {
      guia: 'envio da guia',
      recourse: 'envio do recurso',
      receive: 'recebimento',
    },
    noBatch: 'Evento sem lote há {days} dias',
    pending: 'Evento marcado como pendente',
    cooperativeDeadline: 'Restam {days} dias para envio à cooperativa',
    statusDeadline: 'Evento há {days} dias no status {status}',
    eventChange: 'Evento de {patientName} alterado por {changedByName}',
  },
  image: {
    crop: 'Crop',
    zoomIn: 'Zoom In',
    zoomOut: 'Zoom Out',
    rotateLeft: 'Girar Esquerda',
    rotateRight: 'Girar Direita',
    mirrorY: 'Espelhar Y',
    mirrorX: 'Espelhar X',
    show: 'Mostrar Imagem',
    remove: 'Deletar Imagem',
    selectNewFile: 'Selecionar um novo arquivo',
    backgroundColor: 'Cor do background'
  },
  calendar: {
    week: {
      '0': 'Domingo',
      '1': 'Segunda',
      '2': 'Terça',
      '3': 'Quarta',
      '4': 'Quinta',
      '5': 'Sexta',
      '6': 'Sábado'
    }
  },
  access: {
    linkCompany: 'Associar Empresa',
    generateTranslate: 'Gerar tradução',
    title: 'Acesso',
    admin: 'Administrador',
    user: 'Usuário',
    idForProfile: 'Escolha o id para o perfil',
    idForModule: 'Escolha o id para o módulo',
    idForAction: 'Escolha o id para a ação',
    errors: {
      idForProfileExist: 'O id já existe',
      denied: 'Acesso Negado',
      insufficientPermissions: 'Permissões insuficientes'
    },
    generateRulesObject: 'Gerar objeto para as rules',
    addModule: 'Adicionar módulo',
    linkModule: 'Associar módulo',
    toggleAllButton: 'Alterar todas as ações',
    modules: 'Módulos',
    actions: 'Ações',
    toggleModelButton: 'Todas',
    menuAccess: 'Acessos',
    menuAccessProfiles: 'Perfis',
    menuAccessModules: 'Módulos',
    menuAccessActions: 'Ações',
    editor: 'editor',
    masterEditor: 'Editor Mestre',
    module: 'Módulo',
    tableProfilesModules: 'Módulos\\Perfis',
    dialogShowAccessTitle: 'Acessos',
    matrizOnly: 'Apenas para cooperativa',
    matriz: 'Cooperativa',
    writeToConfig: 'Migrar para config',
    userAccess: 'Acessos do usuário',
    sendEmailReset: 'Enviar email de redefinição de senha',
    setNewPassword: 'Definir uma nova senha',
    alerts: {
      haveSureSetNewPassword: 'Tem certeza que deseja definir uma nova senha para o usuário?',
      confirmCreateUserPartial: 'Tem certeza que deseja criar usuário sem email e cpf?',
      confirmCreateUserPartialBody: 'Esse usuário não vai poder acessar o sistema posteriormente',
      existUserDocument: 'Já existe usuário com esse CPF',
      existUserEmail: 'Já existe usuário com esse email',
    },
    createUserPartial: 'Criar usuário sem email ou cpf',
  },
  tools: {
    title: 'Ferramenta'
  },
  rules: {
    adm: {
      adm: 'Administrador',
      sell: 'Vendedor',
      analy: 'Analytics',
      sup: 'Suporte'
    },
    comp: {
      adm: 'Administrador',
      edit: 'Editor',
      mEdit: 'Master Editor',
      deli: 'Delivery',
      att: 'Atendente'
    }
  },
  router: {
    accessDenied: 'Acesso Negado',
    needCompany: 'É necessário selecionar uma empresa',
    modules: {
      anesthetists: 'Anestesistas',
      batches: 'Lotes',
      billing: 'Faturamento',
      companies: 'Empresa',
      dashboard: 'Dashboard',
      events: 'Eventos',
      eventsExports: 'Exportação de eventos',
      forms: 'Fomulários',
      formsQA: 'Formulários de Qualidade',
      healthInsurances: 'Convênios',
      hospitals: 'Hospitais',
      integrations: 'Integrações',
      invoices: 'Notas',
      ocr: 'Ocr',
      patients: 'Pacientes',
      schedule: 'Escala',
      surgeons: 'Cirurgiões',
      workloads: 'Horários de trabalho',
      slotCategories: 'Turnos',
      demands: 'Demandas',
      scheduleOff: 'Exceções de trabalho',
      scheduleOnCall: 'Escalas de sobreaviso',
      core: 'CORE',
      scheduleCharge: 'Cobranças',
    },
    actions: {
      list: 'Listar',
      listOwn: 'Listar Próprios',
      manageFilias: 'Gerenciar filiais',
      manager: 'Gestor',
      read: 'Ler',
      readOwn: 'Ler Próprios',
      rm: 'Remover',
      scheduler: 'Escalador',
      write: 'Gravar',
      writeOwn: 'Gravar Próprios',
    },
    profiles: {
      a: 'Administrador',
      b: 'Anestesista',
      c: 'Gestor de Escala',
      d: 'Escalador',
      e: 'Gestor Faturamento',
      f: 'Faturista',
      g: 'Residente'
    }
  },
  emailReset: {
    subject: 'Resetar senha',
    head: 'Recebemos uma solicitação para redefinir sua senha do Volan,\n acesse o link abaixo para definir uma nova senha',
    body: '',
    link: 'Resetar senha',
    hello: 'Olá'
  },
  emailAlerts: {
    subjectLabels: {
      demo_request: 'REQUISIÇÃO DE DEMONSTRAÇÃO',
      form_contact: 'Formulário de Contato',
      marketing_conversion: 'Conversão Google Ads',
    }
  },
  blog: {
    title: '',
    notFound: 'Post Não Encontrado'
  },
  page: {
    title: '',
    notFound: 'Página Não Encontrada'
  },
  faq: {
    title: 'Perguntas frequentes',
    notFound: 'Faq Não Encontrado'
  },
  inputError: {
    name: 'Preencha o nome',
    companyName: 'Preencha o nome da empresa',
    cnpj: 'Preencha o cnpj',
    priceRange: 'Preencha o intervalo de valor',
    businessType: 'Preencha o tipo de negócio',
    completeAddress: 'Termine de preencher o endereço',
    completeBank: 'Termine de preencher as informações bancárias',
    phone: 'Preencha o telefone',
    previousSend: 'Enviado anteriormente',
    needCanReceive: 'É necessário ter a conta de pagamento aprovada'
  },
  notification: {
    type: {
      title: 'Tipo',
      company: 'Empresa',
      link: 'Link',
      search: 'Busca'
    },
    sendToType: {
      title: 'Enviar para',
      region: 'Região',
      selected: 'Usuários selecionados',
      all: 'Todos'
    },
    search: {
      search: 'Termo da busca'
    },
    newSchedule: {
      title: 'Você tem uma nova escala.',
      bodyStart: 'Você foi escalado em',
      bodyEnd: 'no dia',
    },
    scheduleModify: {
      title: 'Você tem uma nova solicitação de troca de escala.',
      exchangeBody: 'deseja trocar de plantão com você no dia',
      replaceDestinyBody: 'deseja fazer seu plantão no dia',
      replaceSourceBody: 'deseja que você faça o seu plantão no dia',
    },
    scheduleModifyRefused: {
      title: 'Sua solicitação de troca de escala foi recusada.',
      body: 'recusou sua solicitação de troca de plantão.',
    },
    scheduleModifyAccepted: {
      title: 'Sua solicitação de troca de escala foi aceita.',
      body: 'aceitou sua solicitação de troca de plantão no dia',
    },
    cooperativeDeadline: {
      title: 'Prazo de envio à cooperativa',
      body: 'Restam {days} dias para enviar documentação do evento de {patient} ({healthInsurance}) à cooperativa.',
    },
  },
  paginate: {
    prev: 'Prev',
    next: 'Next'
  },
  _404: {
    notFoundHeader: 'Página não encontrada, tente recarregar a página.',
    timeout: 'A página atingiu o tempo limite durante o carregamento. Tem certeza de que ainda está conectado à Internet?'
  },
  jobs: {
    type: 'Tipo',
    name: 'Nome',
    arg: 'argumentos'
  },
  apiErrorCode: {
    otherUser: 'O usuário não tem permissão para alterar a senha de outro.',
    statusError: 'Estado inválido',
    permissionDenied: 'O usuário não tem permissão para executar essa ação',
    unknown: 'Erro desconhecido',
    paymentError: 'Erro ao efetuar o pagamento',
    inputError: 'Erro nos parâmetros',
    exhaustedAttempts: 'Muitas tentativas',
    paymentInvalidValue: 'Valor de pagamento inválido',
    notFound: 'Não encontrado',
    OK: 'Sucesso',
    warningAnswered: 'Já respondido',
    versionError: 'Erro de versão',
    extrasError: 'A movimentação foi salva, mas o detalhamento (eventos/horas) não pôde ser gravado. Salve novamente para regravar o detalhamento',
    paymentOverflow: 'Os pagamentos deixariam a movimentação quitada acima do próprio valor. A gravação foi recusada para não inflar o saldo bancário. Confira o valor da movimentação e o plano de parcelas — e, se a diferença for juros ou multa, registre-a nos campos próprios da baixa, que não contam como quitação.',
    transferSameAccount: 'A transferência tem parcela cuja conta de origem é a própria conta de destino: o dinheiro sairia e entraria na mesma conta, e o saldo das duas contas ficaria errado. A gravação foi recusada. Escolha outra conta na parcela ou outra conta de destino. Se a parcela já está baixada, estorne a baixa, escolha a conta de origem e baixe de novo.',
  },
  FcmComponents: {
    name: 'Nome',
    search: 'Buscar',
    save: 'Salvar',
    conclude: 'Concluir',
    selected: 'Selecionado',
    selecteds: 'Selecionados',
    confirmButton: 'Confirmar',
    warn: {
      noSave: 'Você fechou o form sem salvar os dados',
      invalidType: 'Tipo inválido'
    },
    dateMonth: 'Mês',
    dateYear: 'Ano',
    setTransparent: 'Definir transparente',
    cantOpenFile: 'Não foi possível abrir o arquivo',
    noDataText: 'Não há dados disponíveis'
  },
  hospital: {
    faturamento: 'Faturamento?',
    ponto_automatico: 'Ponto Automático?',
    local_de_trabalho: 'Local de trabalho?',
    value: 'Valor de escala',
    sigla: 'Sigla',
    color: 'Cor',
    integrations: 'Integrações',
    proceduresIdsToBlockInEvent: 'Procedimentos bloqueados no evento (códigos)',
    proceduresIdsToBlockInEventHint: 'Informe o código do procedimento (idProc) e pressione Enter. Procedimentos com esses códigos não ficam disponíveis nos eventos deste hospital.',
    eventsFromOwnSpreadsheet: 'Eventos vêm de planilha própria deste hospital',
    eventsFromOwnSpreadsheetHint: 'Os eventos deste hospital são importados pela planilha de hospitais. Na importação da planilha geral, eles são ignorados — a planilha do hospital traz mais informação para o repasse.',
    ownSpreadsheetExecutantRole: 'Papel do executante na planilha',
    ownSpreadsheetExecutantRoleHint: 'Quem a coluna "Técnico Executante" representa nos eventos deste hospital.',
    ownSpreadsheetExecutantUser: 'Executante fixo',
    executantRole: {
      KPHONOAUDIOLOGIST: 'Fonoaudiólogo',
      KSURGEON: 'Médico (cirurgião)',
      KFIXED: 'Executante fixo — ignora a coluna',
    },
  },
  cruds: {
    hospitalAdd: '',
    hospitalEdit: '',
    batchAdd: 'Adicionar Lote',
    patientAdd: 'Adicionar paciente',
    batchSelect: 'Selecionar Lote'
  },
  optionsSort: {
    dtProcedure: 'Data do Evento',
    numberGuide: 'Nº da Guia',
    patient: 'Paciente',
    anesthetist: 'Anestesista',
    surgeon: 'Cirurgião',
    hospital: 'Hospital',
    insurance: 'Convênio',
    produced: 'Valor produzido',
    addedToBatch: 'Data de adição ao lote',
    asc: 'Crescente',
    desc: 'Decrescente',
  },
  event: {
    onlyPendingEvents: 'Só pendentes',
    onlyPendingEventsTooltip: 'Mostrar apenas os eventos que não passaram na validação, com o motivo de cada um',
    validationReasons: 'Não passou na validação',
    selectEvent:'Selecione o Evento',
    resetToFullRange: 'Resetar para o período original',
    dateRange: 'Período de datas',
    negotiationId: 'Negociação',
    phonoaudiologistName: 'Fonoaudiólogo',
    requester: 'Solicitante',
    replaceExecutant: 'Executado no nome de ',
    COMPLEMENTATION: 'Complementação',
    ATTENDANCEFEE: 'Co-participativo',
    EXPENSE : 'Taxa/Despesa',
    KSURGEON: 'Cirurgião',
    KSCRUB_NURSE: 'Instrumentador',
    KANESTHETIST: 'Anestesista principal',
    KSECONDARY_ANESTHETIST: 'Segundo anestesista',
    KRESIDENT_ANESTHETIST: 'Anestesista residente',
    KRESIDENT_SURGEON: 'Cirugião residente',
    KASSISTANT_SURGEON: 'Cirurgião auxiliar',
    KASSISTANT_ANESTHETIST: 'Anestesista auxiliar',
    KOVERRIDE_EXECUTANT: 'Executante sobreescrito',
    attendanceFeeBatchNegotiator: 'Pacientes — co-participativo',
    attendanceFeeBatchDescription: 'Co-participativo — importação de eventos {competence}',
    KNURSE: 'Enfermeiro',
    anesthetist: 'Anestesista',
    hospital: 'Hospital',
    selectCompanyToImportEvents: 'Selecione a empresa para importar os eventos',
    numberTransfer: 'Nº repasse',
    numberCobranca: 'Nº cobrança',
    numberBatch: 'Nº lote',
    numberWallet: 'Nº carteirinha',
    numberInvoice: 'Nº nota',
    customFields: 'Campos Customizados',
    additionalItem: 'Adicional',
    eventId: 'Id',
    searchByPatient: 'Nome ou carteirinha do Paciente',
    searchById: 'Id',
    onlyMatriz: 'Cooperativa',
    filial: 'Cooperado',
    onlyFilial: 'Próprios',
    actives: 'Ativos',
    inactives: 'Removidos',
    addedToBatch: 'Adicionado ao lote',
    anesthesiaStart: 'Início da anestesia',
    procedureStart: 'Início do procedimento',
    anesthesiaEnd: 'Fim da anestesia',
    procedureEnd: 'Fim do procedimento',
    observationPlaceholder: 'Digite suas observações sobre o evento...',
    observationGuidePlaceholder: 'Digite suas observações para a guia...',
    observations: 'Observações',
    dateEffective: 'Data efetiva',
    techniques: {
      KConventional: 'Convencional',
      KVideo: 'Vídeo',
      KRobotic: 'Robótica',
      KNone: 'Convencional',
    },
    batchOutOfRange: 'Sem lotes por estar fora do período máximo de competências',
    autoFix: 'Auto Fix',
    cobrancaNotFound: 'Cobrança não encontrada',
    additional: 'Valor adicional',
    totalProcedures: 'Total procedimentos',
    qtd: 'Qtd.',
    code: 'Código',
    techniqueUsed: 'Téc. utilizada',
    emissionDateBatch: 'Data de emissão do lote',
    events: 'Eventos',
    seq: 'Seq',
    batchNumber: 'Nº lote',
    batchResume: 'Resumo do lote',
    procedures: 'Procedimentos',
    total: 'Total',
    emissionDate: 'Data de emissão',
    professionalPerformer: 'Profissional executante',
    requestingProfessional: 'Profissional solicitante',
    hospitalOrClinic: 'Hospital/clínica',
    healthInsurance: 'Convênio',
    eventResume: 'Resumo do evento',
    value: 'Valor',
    way: 'Via',
    porteAnesthetic: 'Porte anest.',
    porte: 'Porte',
    amount: 'Quantidade',
    description: 'Descrição',
    council: 'Conselho',
    registerNumber: 'Registro',
    name: 'Nome',
    isEmergency: 'Feriado/emergência/urgência',
    yes: 'Sim',
    no: 'Não',
    password: 'Senha',
    patient: 'Paciente',
    confirmAddTransaction: 'Tem certeza que deseja adicionar essa transação?',
    confirmSaveTransaction: 'Tem certeza que deseja salvar as transações?',
    confirmRemoveTransaction: 'Tem certeza que deseja remover a transação?',
    confirmRevertTransaction: 'Tem certeza que deseja reverter a transação?',
    justify: 'Justifique',
    justifyNotFound: 'Justificativa não encontrada',
    addBy: 'Adicionado por {name} em {date} às {time}, data efetiva: {dateEffective}  recebedor: {receiverName}. status: {transferred}',
    eventDate: 'Data do evento',
    transactionPending: 'Transação pendente, recebedor: {receiverName}',
    transactionIsRevert: 'reversão',
    transactionReverted: 'revertida',
    headAddTransactions: 'Adicionar transações',
    emptyTransactions: 'Nenhuma transação',
    resident: 'Residente',
    residentAnesthetist: 'Anestesista residente',
    healthInsurancesToFilterInEvent: 'Convênios para filtrar na criação do evento',
    actionsOnEvent: 'Ações no evento',
    addTransaction: 'Aplicar valores',
    transactionNow: 'Agora',
    billingActionsAll: {
      Received: 'Receber restante',
      Losed: 'Perder restante',
      Glosado: 'Glosar restante',
      Discounted: 'Descontar restante',
      ReceivedToOver: 'Receber restante para over',
      ReceivedFromOver: 'Receber restante do over'
    },
    billingAction: 'Operação',
    showGuide: 'Visualizar Guia',
    viewGuideAll: {
      errorType: 'Erro ao gerar guia para este tipo de evento',
      error: 'Erro ao visualizar guias',
    },
    allCompanies: 'Todas',
    eventActionsCompanySelectionEmptyHint: 'Nenhuma seleção = todas as filiais da matriz.',
    searchByNumberProviderGuide: 'Buscar pelo número da guia',
    getMonth: 'Buscar mês',
    selectedProtocolCodeToSearch: 'Buscar pelo código do protocolo',
    searchByNumberWallet: 'Buscar pelo número da carteirinha',
    searchByPassword: 'Buscar pela senha',
    searchBynumberTransfer: 'Código repasse',
    searchBynumberBatch: 'Código lote',
    searchBynumberCobranca: 'Código cobrança',
    searchBynumberInvoice: 'Nº nota',
    searchByCustomField: 'Buscar por campo customizado',
    type: 'Tipo',
    preEventIntegrations: 'Importar pré eventos',
    pendingEvents: 'Eventos com informações pendentes: ',
    importEvents: 'Importar eventos',
    selectEventToImport: 'Selecione os eventos para serem importados',
    associate: {
      patient: 'Associar paciente aos eventos selecionados',
      healthInsurance: 'Associar convênio aos eventos selecionados',
      anesthetist: 'Associar anestesista a todos os grupos',
      hospital: 'Associar hospital a todos os grupos',
      surgeon: 'Associar cirurgião a todos os grupos',
      secondaryAnesthetist: 'Associar segundo anestesista a todos os grupos',
      resident: 'Associar residente a todos os grupos',
      phonoaudiologist: 'Associar fonoaudiólogo aos eventos selecionados',
      requester: 'Associar solicitante aos eventos selecionados',
      overrideExecutant: 'Associar executante sobrescrito aos eventos selecionados',
      discard: 'Descartar todos eventos selecionados',
    },
    associateItems: 'Associar itens: ',
    discard: 'Descartar',
    doAction: 'Executar ação',
    selectHealthInsurance: 'Selecionar convênio',
    eventsReadyToBecomeVolan: 'Evento(s) pronto(s) para se tornar(em) evento Volan',
    eventsNotReadyToBecomeVolan: 'Evento(s) pendente(s): Será necessário adicionar as informações que estão faltando para se tornar(em) evento volan.',
    eventsSelecteds: 'Evento(s) selecionado(s)',
    fillOut: 'Preencher',
    selectHealthInsuranceFirst: 'Você precisa selecionar um convênio para poder mostrar/adicionar os procedimentos',
    healthInsuranceNotFound: 'Convênio não encontrado',
    searchPatient: 'Pesquisar paciente',
    empty: 'Vazio',
    // Diagnóstico da importação por planilha: o que veio no arquivo e não
    // casou com o cadastro da empresa.
    importMatch: {
      summaryTitle: 'Informações da planilha que não casaram com o cadastro',
      notFound: 'Não encontrado no cadastro',
      ambiguous: 'Mais de um cadastro com esta informação ({count} encontrados)',
      ambiguousShort: '{count} cadastros com este nome',
      inactive: 'Existe no cadastro, mas está inativo',
      inactiveShort: 'inativo',
      approximate: 'Casado por semelhança com "{raw}" da planilha ({percent}%) — confira',
      approximateShort: 'casado por semelhança',
      approximateTitle: 'Casados por semelhança de nome — vale conferir',
      columnNotFound: 'Coluna não encontrada',
      procedureCodeNotMapped: 'Sigla de exame sem de-para',
      duplicatedProcedureCode: 'Sigla cadastrada mais de uma vez',
      ignoredTitle: 'Ignorados por virem da planilha própria do hospital',
      unknownHospital: 'Hospital sem nome',
      eventsCount: '({count} evento) | ({count} eventos)',
      createRegister: 'Criar cadastro com este nome',
      createRequesterTitle: 'Novo solicitante',
      requesterLinked: 'Solicitante vinculado a {count} evento | Solicitante vinculado a {count} eventos',
    },
    averageTicket: 'Ticket médio',
    proportions: {
      100: '100% - Principal',
      70: '70% - Outra via de acesso',
      50: '50% - Mesma via de acesso',
    },
    proportionsEventResume: {
      100: 'Principal/Única',
      70: 'Outra via de acesso',
      50: 'Mesma via de acesso',
    },
    dataFrom: 'Dados',
    wallet: 'Carteirinha',
    start: 'Início anestesia',
    startConsultation: 'Início da consulta',
    end: 'Fim anestesia',
    endConsultation: 'Fim da consulta',
    changeValue: 'Alterar valor',
    originalValue: 'Alterar valor base',
    finalValue: 'Alterar valor final',
    detailFinish: 'Há procedimentos que não foram recebidos completamente, nem descontados, glosados ou perdidos. Todos esses (citados) que estão ligados à CBHPM, precisam de um motivo. Escolha um motivo para todos, ou especifique em cada procedimento os seus respectivos motivos.',
    choseReasonsCut: 'Escolha os motivos de glosa',
    addCuteReason: 'Adicione pelo menos um motivo de glosa!',
    urgencyEmergency: 'Urgência/Emergência',
    selecteds: 'Procedimentos selecionados',
    select: 'Selecionar procedimentos',
    invoices: 'Notas',
    patientTitle: 'Identificação do paciente',
    proceduresTitle: 'Procedimentos: ',
    proceduresNotFoundInHealthInsurance: 'Procedimentos não encontrados: ',
    obsTitle: 'Observações',
    patientName: 'Nome do paciente',
    patientNameReport: 'Paciente',
    patientCpf: 'CPF',
    patientBirthDate: 'Nascimento',
    healthInsuranceName: 'Convênio',
    healthInsuranceNames: 'Convênios',
    healthInsuranceWallet: 'Carteira do convênio',
    save: 'Salvar',
    saveAndFillLater: 'Finalizar Mais Tarde',
    saveAndCheck: 'Salvar e Conferir',
    hospitalName: 'Hospital',
    hospitalsNames: 'Hospitais',
    anesthetistName: 'Anestesista',
    secondaryAnesthetist: 'Segundo anestesista',
    thirdAnesthetist: 'Terceiro anestesista',
    anesthetistsNames: 'Anestesistas',
    surgeonName: 'Cirurgião',
    surgeonsNames: 'Cirurgiões',
    accommodation: 'Acomodação',
    dateBegin: 'Inicio',
    dateEnd: 'Fim',
    dateDay: 'Dia',
    dateMonth: 'Mês',
    dateYear: 'Ano',
    beginDate: 'Data de início',
    endDate: 'Data de término',
    search: 'Nome ou CPF ou senha ou carteirinha  do paciente',
    searchTitle: 'Eventos',
    filterTitle: 'Selecionar filtros',
    filterApply: 'Aplicar filtros',
    apply: 'aplicar',
    filters: {
      medicalReturn: 'Retorno',
      payments: 'Pagamentos',
      typesOfPayment: 'Formas de Pagamento',
      typePerson: 'Tipo de pessoa',
      appeals: 'Recursos',
      residents: 'Residentes',
      secondaryAnesthetists: '2º Anestesistas',
      anesthetists: 'Anestesistas',
      hospitals: 'Hospitais',
      status: 'Status',
      hadPending: 'Houve Pendência',
      hadPendingOptions:{
        yes: 'Houve Pendência Resolvida',
        no: 'Não Houve Pendência Resolvida'
      },
      healthInsurances: 'Convênios',
      surgeons: 'Cirurgiões',
      assistantsSurgeons: 'Cirurgiões Auxiliares',
      invoices: 'Notas',
      batches: 'Lotes',
      types: 'Tipos',
      contracts: 'Contratos',
      procedures: 'Procedimentos',
      emergencyOrElective: 'Emergência/Eletiva',
      lastModifier: 'Último Modificador',
      noModifier: 'Sem modificador',
      custom: 'Customizados',
      patients: 'Pacientes'
    },
    filterClear: 'Limpar filtros',
    filtersClear: 'Limpar todos os filtros',
    savedFilters: {
      title: 'Filtros salvos',
      save: 'Salvar filtro atual',
      saveAs: 'Salvar como…',
      noSavedFilters: 'Nenhum filtro salvo',
      nameLabel: 'Nome do filtro',
      namePlaceholder: 'Ex.: Convênios pendentes do mês',
      nameRequired: 'Informe um nome para o filtro',
      nameMaxLength: 'O nome deve ter no máximo 100 caracteres',
      setDefault: 'Definir como padrão',
      removeDefault: 'Remover padrão',
      rename: 'Renomear',
      delete: 'Excluir',
      confirmDelete: 'Tem certeza que deseja excluir o filtro "{name}"?',
      savedSuccess: 'Filtro salvo com sucesso',
      deletedSuccess: 'Filtro excluído com sucesso',
      renamedSuccess: 'Filtro renomeado com sucesso',
      defaultSetSuccess: 'Filtro definido como padrão',
      defaultRemovedSuccess: 'Filtro padrão removido',
      loadedDefault: 'Filtro padrão carregado automaticamente',
      inactiveIdsWarning: 'Alguns valores do filtro salvo não estão mais disponíveis e foram ignorados',
      ariaStarIcon: 'Marcar como filtro padrão',
      ariaStarIconActive: 'Remover como filtro padrão',
      ariaDeleteIcon: 'Excluir filtro',
      ariaMenuIcon: 'Opções do filtro',
      ariaRenameIcon: 'Renomear filtro',
      cancel: 'Cancelar',
      confirm: 'Salvar',
      saveError: 'Erro ao salvar filtro',
      updateError: 'Erro ao atualizar filtro',
      noFiltersToSave: 'Selecione pelo menos um filtro antes de salvar',
    },
    largeDatasetWarning: 'Atenção: você tem mais de 2.000 eventos carregados. A aplicação do filtro pode levar alguns segundos. Considere restringir o intervalo de datas para melhor desempenho.',
    warnings: {
      searchCpf: 'Informe um CPF para realizar a busca',
      searchName: 'Informe um Nome para realizar a busca',
      clearPatient: 'Tem certeza que deseja remover o paciente desse evento?',
      cpf: 'Tem certeza que deseja salvar sem preenche o CPF?',
      success: 'Dados do evento alterados com sucesso',
      alertParticularLockProportion: 'Em convênio particular, edite o valor diretamente.',
      successSave: 'Sucesso ao salvar dados',
      transactionIsEmpty: 'Adicione pelo menos um valor para criar uma nova transação',
      selectHealthInsuranceAndDtProcedure: 'Selecione o convênio e a data do procedimento',
      errorOnLoadProcedures: 'Erro ao buscar procedimentos',
      proceduresRemovedFromEvent: 'Procedimento(s) removido(s) do evento',
      tryGetProceduresAgain: 'Tentar buscar os procedimentos novamente',
      closeCustomFieldsWithoutSave: 'Tem certeza que deseja sair dos Campos Customizados sem persistir as alterações?',
      cuteReasonAlreadyAdded: 'Já foi adicionado um motivo de glosa para este procedimento',
      atLeastOneColumn: 'Ao menos uma coluna deve estar visível',
    },
    errors: {
      attendanceFeeBatch: 'Os eventos foram importados, mas o co-participativo não foi lançado no financeiro',
      invalidEvents: 'Evento(s) inválido(s)',
      cpfExist: 'O CPF informado já existe',
      noProcedures: 'Selecione pelo menos 1 procedimento',
      noProceduresFound: 'Nenhum procedimento encontrado para este evento',
      dateNoSelected: 'Selecione uma data antes de buscar',
      invoiceNoSelected: 'Selecione uma nota antes de buscar',
      invoiceUnknown: 'Tipo de busca desconhecido',
      noFilter: 'Não há filtro selecionado',
      onActionEvent: 'Erro ao editar o evento',
      cpfEmpty: 'Informe um CPF válido',
      selectCutReason: 'Adicione pelo menos um motivo de glosa para cada procedimento!',
      errorMax10Companies: 'Selecione no máximo 10 empresas na busca',
      selectCompany: 'Selecione uma empresa',
      filialRequired: 'Selecione a filial do evento: nesta cooperativa, um evento sem filial seria repassado à própria cooperativa',
      healthInsuranceNotFound: 'Convênio não encontrado no evento',
      selectCompanies: 'Selecione as empresas',
      healthInsuranceIdNotFound: 'Convênio não encontrado no evento, entre em contato com o suporte',
      saveData: 'Erro ao salvar dados',
      batchesNoSelected: 'Selecione um lote antes de buscar',
      noSelectedMonth: 'Selecione um mês antes de buscar',
      numberProviderGuideExists: 'O número da guia informado já existe no sistema',
      neddSameLine: 'É necessário que seja na mesma linha',
      actionNotAvaliableForAdditional: 'Ação não disponível para Adicional',
      eventEditOnlyRead: 'Apenas para visualização',
      notValuedWithoutContract: 'Atenção! Este convênio não pode ser usado pois não existe um contrato ativo.',
      actionNotAvaliableForAttendanceFee: 'Ação não disponível para Co-participativo',
      mandatoryCustomFieldsEmpty: 'Preencha os Campos Customizados obrigatórios',
      mandatoryAdditionalDataEmpty: 'Preencha os Dados Adicionais obrigatórios',
      mandatoryFieldsEmpty: 'Verifique os campos obrigatórios a serem preenchidos',
      noPatient: 'Nenhum paciente encontrado',
      withoutPatient: 'Sem paciente',
      selectCustomField: 'Selecione o campo para buscar',
      onDoCheckEvent: 'Erro ao conferir evento',
      sideBarTitle: 'Campos do Evento',
      additionalDataTitle: 'Dados Adicionais',
      attachmentsTitle: 'Anexos',
      validationError: 'Erros encontrados na validação do evento',
      missingField: 'Campo obrigatório não preenchido: {field}',
      missingFields: 'Campos obrigatórios não preenchidos: {field} e mais {count} campo(s)',
      validation: {
        duplicatePassword: 'Senha duplicada detectada',
        duplicatePasswordMsg: 'Já existe um evento com a mesma senha para o convênio e data selecionados. Deseja salvar mesmo assim?',
        duplicatePasswordBatchTitle: 'Eventos com senha duplicada detectados',
        duplicatePasswordBatchMsg: 'Os seguintes eventos já possuem senha lançada (mesmo convênio, carteirinha e senha no dia). Deseja importar todos mesmo assim?',
        duplicateEvent: 'Evento duplicado detectado',
        duplicateEventMsg: 'Já existe um evento para o paciente {patient} na mesma data/hora ({date}). Deseja salvar mesmo assim?',
        duplicateEventTimeoutWarning: 'Não foi possível verificar duplicidade. Evento salvo.',
        duplicateEventBatchTitle: 'Eventos duplicados detectados',
        duplicateEventBatchMsg: 'Os seguintes eventos já existem na mesma data/hora. Deseja importar todos mesmo assim?',
        duplicateEventBatchItem: '{patient} — {date}',
        duplicateCheckSkippedTitle: 'Conferência de duplicidade incompleta',
        duplicateCheckSkippedMsg: 'Em {count} evento(s) a consulta de duplicidade não respondeu a tempo, e eles foram importados sem essa conferência. Vale revisar esses eventos.',
      },
      eventWithSameKey: 'Evento com mesma senha já lançado',
      eventWithSameKeyDetail: 'Já existe evento com mesma carteirinha, convênio e senha nesta data. Paciente: {guide} | Data: {date}',
    },
    mandatoryFields: 'Campos Obrigatórios',
    optionalFields: 'Campos Opcionais',
    customFieldsFromInsurance: 'Campos Customizados do Convênio',
    unrealized: 'Não Realizado',
    realized: 'Realizado',
    inProgress: 'Em Andamento',
    addProcedures: 'Adicionar itens',
    addProceduresOk: 'Ok',
    addProceduresTitle: 'Adicione os procedimentos/pacotes',
    addAdditionalData: 'Adicionar grupo de dados adicionais',
    emptyProcedures: 'Nenhum procedimento selecionado',
    billingActionsInput: {
      Received: 'Recebido',
      Losed: 'Perdido',
      Glosado: 'Glosado',
      Discounted: 'Descontado',
      ReceivedFromOver: 'Over',
      ReceivedToOver: 'Over',
    },
    proc: {
      participative: 'Co-participativo',
      indicator: 'Indicador',
      actions: 'Ações',
      code: 'Código',
      type: 'Tipo',
      expenses: 'Taxas/despesas',
      PROCEDURE: 'Procedimento',
      COMPLEMENTATION: 'Complementação',
      ATTENDANCEFEE: 'Co-participativo',
      EXPENSE: 'Taxa/Despesa',
      attendanceFee: 'Co-participativo',
      anesthesiaTime: 'Duração da Anestesia',
      dtProcedureDuration: 'Duração do Procedimento',
      durationEventTime: 'Duração do Evento',
      remove: 'Remover',
      porte: 'Porte',
      codProc: 'Cod. Proc.',
      value: 'Valor',
      produced: 'Produzido',
      name: 'Procedimento',
      totalReceived: 'Recebido',
      totalOver: 'Over',
      totalLoss: 'Perdido',
      totalGlosado: 'Glosa Acatada',
      totalGlosaIdentified: 'Glosa identificada',
      totalDiscount: 'Descontado',
      invoice: 'Nota',
      reasons: 'Motivos de glosa',
      complementation: 'Complementação',
      complementationReceived: 'Complementação recebida',
      complementationGlosado: 'Complementação Glosada',
      complementationlLoss: 'Complementação perdida',
      diff: 'Diferença',
      toReceive: 'A receber',
      totalAppealed: 'Recursado',
      totalReceivedAppeal: 'Recebido do recurso',
      _totalOpened: 'Em aberto do recurso',
      finalValue: 'Valor final',
      totalTransfer: 'Repassado',
      skipAppeal: 'Manter em aberto',
      notAddInAppeal: 'Procedimento não será adicionado ao recurso',
    },
    proportion: 'Proporção',
    dtProcedure: 'Data do procedimento',
    attendanceFee: 'Co-participativo',
    complementation: 'Adicional',
    setComplementation: 'Valor adicional',
    setComplementationYes: 'Adicionar',
    setAttendanceFee: 'Valor do co-participativo',
    setAttendanceFeeYes: 'Adicionar',
    intervalDay: 'Dia',
    intervalMonth: 'Mês',
    intervalYear: 'Ano',
    protocol: 'Protocolo',
    intervalCustom: 'Customizado',
    intervalCustomMonth: 'Customizado',
    intervalInvoice: 'Nota',
    getData: 'Trazer dados',
    valorTotal: 'Valor total',
    daysLeft: 'Dias',
    values: {
      totalTransferred: 'Repassado',
      values: 'Valores',
      totalProduced: 'Produzido',
      totalOver: 'Over',
      totalReceived: 'Recebido',
      totalReceivedFromOver: 'Total pago com Over',
      totalInProcessing: 'Processando',
      complementation: 'Complementação',
      totalGlosado: 'Glosado',
      totalLoss: 'Perdido',
      totalGlossAndLoss: 'Glosado e perdido',
      totalDiscount: 'Desconto',
      totalChanged: 'Modificado',
      attendanceFee: 'Co-participativo'
    },
    limits: 'Limites',
    edit: 'Editar',
    finalize: 'Finalizar',
    receiveAll: 'Receber Tudo',
    observationHeader: 'Observações',
    observationAdd: 'Adicionar',
    observationAddFull: 'Adicionar Observação',
    observationSave: 'Salvar',
    legendSymbols: 'Legenda de símbolos',
    legendColors: 'Legenda de cores',
    legendG: 'Envio de guia/XML',
    legendR: 'Envio de recurso',
    legend$: 'Recebimento',
    legendGray: 'Não solicitado',
    legendGreen: 'Enviado',
    legendYellow: '1 semana de prazo',
    legendRed: 'Prazo ultrapassado',
    limitSymbols: 'Limites desse registro',
    statusHistoryHeader: 'Histórico do registro',
    confirms: {
      '2': 'Você tem certeza que deseja marcar esse evento como conferido?',
      '4': 'Você tem certeza que deseja marcar como GUIA/XML ENVIADA(O)?',
      '8': 'Você tem certeza que deseja receber o restante dos valores do evento selecionado?',
      '16': 'Você tem certeza que deseja PERDER O VALOR RESTANTE?',
      '32': 'Você tem certeza que deseja marcar como EVENTO COM RECURSO IDENTIFICADO?',
      '64': 'Você tem certeza que deseja marcar EVENTO COM COM RECURSO ENVIADO?',
      '128': 'Você tem certeza que deseja marcar como EVENTO FINALIZADO?',
      '512': 'Você tem certeza que deseja marcar como EVENTO TOTALMENTE GLOSADO?',
      '2048': 'Você tem certeza que recebeu resposta do recurso?',
      '32768': 'ATENÇÃO! Você tem certeza que deseja reverter esse evento? Escreva uma observação',
      '65536': 'Você tem certeza que deseja Excluir o evento?',
      '131072': 'Você tem certeza que deseja marcar esse evento como pendente? Escreva uma observação',
      '1048576': 'Você tem certeza que deseja marcar esse evento como',
      '2097152': 'Você tem certeza que deseja retirar esse evento do status',
      '8388608': 'Você tem certeza que deseja marcar como EVENTO FINALIZADO?',
      '1073741824': 'Você tem certeza que deseja marcar esse evento como pendência interna? Escreva uma observação'
    },
    actions: {
      '1': 'Editar',
      '2': 'Conferir',
      '4': 'Enviar Guia/XML',
      '8': 'Receber restante',
      '16': 'Perder restante',
      '32': 'Recurso identificado',
      '64': 'Enviar recurso',
      '128': 'Finalizar',
      '256': 'Cancelar',
      '512': 'Glosar restante',
      '1024': 'Manipular valores',
      '2048': 'Recurso Recebido',
      '4096': 'Mostrar histórico',
      '8192': 'Adicionar nota',
      '16384': 'Dados adicionais',
      '32768': 'Voltar Status para Aguardando conf.',
      '65536': 'Excluir',
      '131072': 'Pendente',
      '262144': 'Editar valores',
      '524288': 'Adicionar lote',
      '4194304': 'Mostrar valores',
      '8388608': 'Campos customizados',
      '16777216': 'Forma de pagamento',
      '33554432': 'Finalizar',
      '67108864': 'Exportar para a Conta Azul',
      '536870912': 'Enviar para a Cooperativa',
      '1073741824': 'Marcar Pendência Interna',
      '2147483648': 'Resolver Pendência',
      '4294967296': 'Enviar para Aguardando Conferência',
      '8589934592': 'Prévia repasse'
    },
    matrizActions: {
      pending: 'Marcar pendência para matriz',
      internalPending: 'Marcar pendência para cooperado',
      confirms: {
        pending: 'Você tem certeza que deseja marcar pendência para a matriz? Escreva uma observação',
        internalPending: 'Você tem certeza que deseja marcar pendência para o cooperado? Escreva uma observação'
      }
    },
    actionsIntegrationsEvents: {
      '1': 'Editar',
      '2': 'Deletar',
      '4': 'Associar anestesista',
      '8': 'Associar cirurgião',
      '16': 'Associar hospital',
      '32': 'Associar convênio',
      '64': 'Associar paciente',
      '128': 'Transformar em evento',
      '256': 'Importar',
    },
    alerts: {
      G: {
        empty: 'Aguardando o envio da(o) guia/XML',
        ok: 'Guia/XML enviada(o)',
        warning: 'Faltam {days} para expirar o prazo do envio da(o) guia/XML',
        error: 'Expirado há {days} dias o prazo para envio da(o) guia/XML'
      },
      R: {
        empty: 'Recurso não solicitado',
        ok: 'O Recurso já foi enviado',
        warning: 'Faltam {days} para expirar o prazo de envio do recurso',
        error: 'Expirado há {days} dias o prazo para enviar recurso',
        noLimit: 'Aguardando o envio de recurso'
      },
      $: {
        empty: 'Aguardando o recebimento',
        ok: 'Já recebido',
        warning: 'Faltam {days} para expirar o prazo de recebimento',
        error: 'Expirado há {days} dias o prazo para recebimento'
      }
    },
    editProcedureTitle: 'Editar Valores Procedimentos',
    editProceduresValuesTitle: 'Editar valores do evento',
    onlyReadProceduresValuesTitle: 'Visualizar valores do evento (não é possível editar os valores desse evento)',
    editProcedureConclude: 'Concluir',
    editProcedureCancel: 'Cancelar',
    date: 'Data',
    momName: 'Nome da mãe',
    addAttach: 'Adicionar',
    attachments: {
      formatWarning: 'São aceitos somente arquivos de imagem no formato .png, .jpeg ou documentos PDF\'s',
      callRequest: 'Solicitar Reenvio',
      guide: 'Guia',
      record: 'Ficha',
      rgo: 'RGO',
      term: 'Termo',
      apa: 'APA',
      medicalRecord: 'Prontuário',
      hospitalizationForm: 'Ficha de Internação',
      networkCharter: 'Carta de Rede',
      other: 'Outro',
      '3AFile': '3A'
    },
    historyTitle: 'Histórico do evento',
    companiesMax10: 'Empresas (max 10)',
    companyName: 'Nome da empresa',
    companies: 'Empresas',
    company: 'Empresa',
    notActive: '(Evento deletado)',
    exports: {
      eventsInfoExtra: 'Eventos info extra',
      eventsInfoExtraResumed: 'Resumida',
      eventsInfoExtraCompleted: 'Completa',
      events: 'Eventos',
      producedReceived: 'Produzido e Recebido',
      custom: 'Customizado',
    },
    multiActions: {
      addInvoice: 'Adicionar nota',
      addBatch: 'Adicionar lote',
      receiveAll: 'Receber restante',
      sendGuia: 'Enviar Guia/XML',
      check: 'Conferir',
      associateAnesthetist: 'Associar anestesista',
      associateSurgeon: 'Associar cirurgião',
      associateHospital: 'Associar hospital',
      associateHealthInsurance: 'Associar convênio',
      becomeVolanEvent: 'Tornar evento Volan',
      import: 'Importar',
      customStatus: 'Status de evento customizado',
      multiEventEditValues: 'Editar valores',
      viewGuideAll: 'Visualizar Guia'
    },
    multiActionsConfirms: {
      selectInvoice: 'Deseja selecionar nota para associar ao recebimento?',
      addInvoice: 'Tem certeza que deseja adicionar essas notas à todos eventos selecionados?',
      addBatch: 'Tem certeza que deseja adicionar os eventos selecionados ao Lote?',
      receiveAll: 'Tem certeza que deseja Receber o restante dos valores dos eventos selecionados?',
      sendGuia: 'Tem certeza que deseja Enviar a(o) guia/XML dos eventos selecionados?',
      check: 'Tem certeza que deseja Conferir os eventos selecionados?',
      customStatus: 'Tem certeza que deseja mudar o status de todos os eventos selecionados para customizado?',
      viewGuideAll: 'Deseja visualizar as guias dos eventos selecionados? Será aberta uma aba por tipo de guia. Certifique-se de permitir popups no navegador.'
    },
    multiActionsIntegrationsConfirms: {
      1: 'Tem certeza que deseja editar o(s) evento(s) selecionado(s)?',
      2: 'Tem certeza que deseja descartar o(s) evento(s) selecionado(s)?',
      4: 'Tem certeza que deseja associar anestesista ao(s) evento(s) selecionado(s)?',
      8: 'Tem certeza que deseja associar cirurgião ao(s) evento(s) selecionado(s)?',
      16: 'Tem certeza que deseja associar hospital ao(s) evento(s) selecionado(s)?',
      32: 'Tem certeza que deseja associar convênio ao(s) evento(s) selecionado(s)?',
      64: 'Tem certeza que deseja associar paciente ao(s) evento(s) selecionado(s)?',
      128: 'Tem certeza que deseja importar o(s) evento(s) para edição no Volan?',
      256: 'Tem certeza que deseja importar o(s) evento(s)?',
      512: 'Tem certeza que deseja associar segundo anestesista ao(s) evento(s) selecionado(s)?',
      1024: 'Tem certeza que deseja associar residente ao(s) evento(s) selecionado(s)?',
      2048: 'Tem certeza que deseja associar o tipo ao(s) evento(s) selecionado(s)?',
      4096: 'Tem certeza que deseja associar a acomodação ao(s) evento(s) selecionado(s)?',
      32768: 'Tem certeza que deseja associar a empresa ao(s) evento(s) selecionado(s)?',
      65536: 'Tem certeza que deseja associar o solicitante ao(s) evento(s) selecionado(s)?',
      131072: 'Tem certeza que deseja associar o executante sobrescrito ao(s) evento(s) selecionado(s)?',
      262144: 'Tem certeza que deseja associar o fonoaudiólogo ao(s) evento(s) selecionado(s)?',
    },
    batches: 'Lotes',
    batch: 'Lote',
    multiOptLog: {
      title: {
        pending: 'Progresso...',
        OK: 'Concluído'
      },
      successCount: 'Sucessos',
      errorCount: 'Erros',
      errorTypes: {
        success: 'Sucessos',
        invalidState: 'Eventos em estado inválido para essa operação',
        unknown: 'Eventos com erro desconhecido',
        healthInsurance: 'Convênio não encontrado',
        errorStatus: 'Status inválido para esta ação no evento',
        errorAttendanceFee: 'Realizado parcialmente, não pode ser finalizado com co-participativo em aberto',
        notReadyToAddInBatch: 'Não pode ser movido para o lote',
        readOnlyForFilial: 'Evento gerido pela cooperativa: o cooperado só consulta, não executa ações',
        mandatoryFields: 'Há campos obrigatórios que devem ser preenchidos',
        validationError: 'Erros encontrados na validação do evento'
      }
    },
    reasonToRevertToAwaitCheck: 'Qual o motivo para reverter o evento?',
    intervalBatch: 'Lotes',
    numberGuide: 'Nº Guia',
    guide: 'Guia',
    batchOnlyEmpty: 'Sem lotes',
    invoiceOnlyEmpty: 'Sem notas',
    selectBatch: 'Selecione o(s) lote(s)',
    selectInvoice: 'Selecione a(s) nota(s)',
    valued: 'Valorados',
    notValued: 'Não Valorados',
    categories: 'Categorias',
    allCategories: 'Todas as categorias',
    billable: 'Faturáveis',
    notBillable: 'Não faturáveis',
    contract: 'Contrato',
    dateEndBiggerThanDateStartRule: 'A data de fim da anestesia precisa ser maior que a data de início.',
    numGuide: 'Número da guia',
    dtRecourse: 'Data do recurso',
    observation: 'Observação',
    observationGuideSent: 'Observação de envio da guia',
    observationRecourse: 'Observação de recurso',
    secondaryAnesthetistName: 'Segundo anestesista',
    spreadsheetDownload: 'Download de planilha',
    openCustomFields: 'Campos Customizados',
    openCustomFieldsTitle: 'Campos Customizados',
    contractNumber: 'Contrato',
    notValue: 'Não valorado',
    dateBatch: 'Data Lote',
    dateSentBatch: 'Data Envio Lote',
    dateTransfer: 'Data Repasse',
    datePaymentTransfer: 'Data Pagamento Repasse',
    showAllAttachments: 'Mostrar todos os anexos',
    noValueDivision: 'Sem dados de divisão de valores',
    procedureTeamTabs: {
      addTab: 'Adicionar equipe',
      deleteTab: 'Remover equipe',
      confirmDeleteTitle: 'Remover equipe',
      confirmDeleteMessage: 'Tem certeza que deseja remover esta equipe? {count} procedimento(s) serão desvinculados.',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
    }
  },
  events: {
    procedureTeamTabs: {
      defaultName: 'Padrão',
      newTabNamePrefix: 'Time',
      tabCount: '{count} abas',
      addTab: 'Adicionar equipe',
      deleteTab: 'Remover equipe',
      confirmDeleteTitle: 'Remover equipe',
      confirmDeleteMessage: 'Tem certeza que deseja remover esta equipe? {count} procedimento(s) serão desvinculados e voltarão para a equipe Padrão.',
      confirm: 'Remover',
      cancel: 'Cancelar',
      accommodationLabel: 'Acomod.',
      teamLabel: 'Equipe',
    },
  },
  EventAttachments: {
    guide: 'Guia',
    record: 'Ficha',
    rgo: 'RGO',
    term: 'Termo',
    apa: 'APA',
    medicalRecord: 'Prontuário',
    hospitalizationForm: 'Ficha de Internação',
    networkCharter: 'Carta de Rede',
    other: 'Outro',
    '3AFile': '3A',
  },
  Accommodation: {
    NURSERY: 'Enfermaria',
    APARTMENT: 'Apartamento',
    OUTPATIENT: 'Ambulatorial',
    ONE_DAY_CLINIC: 'One day clinic',
    null: '',
    NONE: 'Sem acomodação',
  },
  EventStatus: {
    AwaitingCheck: 'Aguardando Conferência',
    Pending: 'Pendente',
    WaitSendGuia: 'Aguardando Envio Guia/XML',
    WaitPayment: 'Aguardando Pagamento',
    WaitSendRecourse: 'Aguardando Envio de Recurso',
    WaitRecourse: 'Aguardando Recurso',
    Finished: 'Finalizado',
    Received: 'Recebido',
    PartialLosed: 'Parcialmente Perdido',
    Losed: 'Perdido',
    PartialCuted: 'Parcialmente Glosado',
    Cuted: 'Glosado',
    Imported: 'Importado',
    ProtocolCreated: 'Protocolo Criado',
    WaitFill: 'Em Preenchimento',
    Filled: 'Preenchido',
    InternalPending: 'Pendência Interna',
    Custom: 'Customizado',
    Released: 'Liberado',
    CustomInfo: 'Informação customizada',
  },
  ReportEventStatus: {
    ProtocolCreated: 'Protocolo Criado',
    AwaitingCheck: 'Aguar. Conferência',
    WaitSendGuia: 'Aguar. Envio Guia/XML',
    WaitPayment: 'Aguar. Pagamento',
    WaitSendRecourse: 'Aguar. Envio Recurso',
    WaitRecourse: 'Aguar. Recurso',
    Finished: 'Finalizado',
    Received: 'Recebido',
    PartialLosed: 'Parcialmente Perdido',
    Losed: 'Perdido',
    PartialCuted: 'Parcialmente Glosado',
    Cuted: 'Glosado',
    Imported: 'Importado',
    hasLoss: 'Evento com perca',
    hasCuted: 'Evento com glosa',
    Pending: 'Pendente',
    WaitFill: 'Em Preenchimento',
    Filled: 'Preenchido',
    InternalPending: 'Pendência Interna'
  },
  states: {
    0: {id: 28, name: 'Estrangeiro', acronym: '--'},
    1: {id: 1, name: 'Acre', acronym: 'AC'},
    2: {id: 2, name: 'Alagoas', acronym: 'AL'},
    3: {id: 4, name: 'Amazonas', acronym: 'AM'},
    4: {id: 3, name: 'Amapá', acronym: 'AP'},
    5: {id: 5, name: 'Bahia', acronym: 'BA'},
    6: {id: 6, name: 'Ceará', acronym: 'CE'},
    7: {id: 7, name: 'Distrito Federal', acronym: 'DF'},
    8: {id: 8, name: 'Espírito Santo', acronym: 'ES'},
    9: {id: 9, name: 'Goiás', acronym: 'GO'},
    10: {id: 10, name: 'Maranhão ', acronym: 'MA'},
    11: {id: 11, name: 'Mato Grosso ', acronym: 'MT'},
    12: {id: 12, name: 'Mato Grosso do Sul', acronym: 'MS'},
    13: {id: 13, name: 'Minas Gerais', acronym: 'MG'},
    14: {id: 14, name: 'Pará', acronym: 'PA'},
    15: {id: 15, name: 'Paraíba', acronym: 'PB'},
    16: {id: 16, name: 'Paraná', acronym: 'PR'},
    17: {id: 17, name: 'Pernambuco', acronym: 'PE'},
    18: {id: 18, name: 'Piauí', acronym: 'PI'},
    19: {id: 19, name: 'Rio de Janeiro', acronym: 'RJ'},
    20: {id: 20, name: 'Rio Grande do Norte', acronym: 'RN'},
    21: {id: 21, name: 'Rio Grande do Sul', acronym: 'RS'},
    22: {id: 22, name: 'Rondônia', acronym: 'RO'},
    23: {id: 23, name: 'Roraima', acronym: 'RR'},
    24: {id: 24, name: 'Santa Catarina', acronym: 'SC'},
    25: {id: 25, name: 'São Paulo', acronym: 'SP'},
    26: {id: 26, name: 'Sergipe ', acronym: 'SE'},
    27: {id: 27, name: 'Tocantins', acronym: 'TO'},
  },
  statesSigla: {
    '--': 'Estrangeiro',
    AC: 'Acre',
    AL: 'Alagoas',
    AP: 'Amapá',
    AM: 'Amazonas',
    BA: 'Bahia',
    CE: 'Ceará',
    DF: 'Distrito Federal',
    ES: 'Espírito Santo',
    GO: 'Goiás',
    MA: 'Maranhão',
    MT: 'Mato Grosso',
    MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais',
    PA: 'Pará',
    PB: 'Paraíba',
    PR: 'Paraná',
    PE: 'Pernambuco',
    PI: 'Piauí',
    RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte',
    RS: 'Rio Grande do Sul',
    RO: 'Rondônia',
    RR: 'Roraima',
    SC: 'Santa Catarina',
    SE: 'Sergipe',
    SP: 'São Paulo',
    TO: 'Tocantins'
  },
  statesTISS: {
    RO: {
      name: 'Rondônia',
      number: '11'
    },
    AC: {
      name: 'Acre',
      number: '12'
    },
    AM: {
      name: 'Amazonas',
      number: '13'
    },
    RR: {
      name: 'Roraima',
      number: '14'
    },
    PA: {
      name: 'Pará',
      number: '15'
    },
    AP: {
      name: 'Amapá',
      number: '16'
    },
    TO: {
      name: 'Tocantins',
      number: '17'
    },
    MA: {
      name: 'Maranhão ',
      number: '21'
    },
    PI: {
      name: 'Piauí',
      number: '22'
    },
    CE: {
      name: 'Ceará',
      number: '23'
    },
    RN: {
      name: 'Rio Grande do Norte',
      number: '24'
    },
    PB: {
      name: 'Paraíba',
      number: '25'
    },
    PE: {
      name: 'Pernambuco',
      number: '26'
    },
    AL: {
      name: 'Alagoas',
      number: '27'
    },
    SE: {
      name: 'Sergipe ',
      number: '28'
    },
    BA: {
      name: 'Bahia',
      number: '29'
    },
    MG: {
      name: 'Minas Gerais',
      number: '31'
    },
    ES: {
      name: 'Espírito Santo',
      number: '32'
    },
    RJ: {
      name: 'Rio de Janeiro',
      number: '33'
    },
    SP: {
      name: 'São Paulo',
      number: '35'
    },
    PR: {
      name: 'Paraná',
      number: '41'
    },
    SC: {
      name: 'Santa Catarina',
      number: '42'
    },
    RS: {
      name: 'Rio Grande do Sul',
      number: '43'
    },
    MS: {
      name: 'Mato Grosso do Sul',
      number: '50'
    },
    MT: {
      name: 'Mato Grosso ',
      number: '51'
    },
    GO: {
      name: 'Goiás',
      number: '52'
    },
    DF: {
      name: 'Distrito Federal',
      number: '53'
    },
    EX: {
      name: 'Países Estrangeiros',
      number: '98'
    }
  },
  appeal: {
    statusNames: {
      WaitSend: 'Aguardando envio',
      Sent: 'Enviado',
      ResponseReceived: 'Resposta recebida',
      Finished: 'Finalizado',
    },
    numberGuideAppealByOperator: 'Número da guia de recurso de glosa atribuído pela operadora',
    password: 'Senha',
    dtAppealReceived: 'Data da resposta do recurso',
    dtAppealSent: 'Data de envio do recurso',
    dtOperatorSignature: 'Data da assinatura da operadora',
    totalAccepted: 'Valor total acatado',
    totalAppealed: 'Valor total recursado',
    totalReceivedAppeal: 'Valor total recebido do recurso',
    _totalOpened: 'Valor total em aberto',
    reasonProvider: 'Justificativa prestador',
    reasonOperator: 'Justificativa operadora',
    procedureOrItem: 'Procedimento / Item Assistencial',
    status: 'Status do recurso',
    dtAppealed: 'Data do recurso',
    cutReason: 'Motivo da glosa',
    procedure: 'Procedimento do recurso',
    appealedProcedureName: 'Procedimentos do recurso',
    appealedProcedure: {
      idProc: 'Código do procedimento',
      cutReasonCode: 'Código do recurso',
      totalAppealed: 'Valor do recurso',
      totalReceivedAppeal: 'Valor recebido do recurso',
      reasonProvider: 'Justificativa prestador',
    },
    '1': '1- Registro ANS',
    '3': '3- Nome da Operadora',
    '4': '4- Objeto do Recurso',
    '5': '5- Número da Guia de Recurso de Glosas Atribuído pela Operadora',
    '6': '6- Código na Operadora',
    '7': '7- Nome do Contratado',
    '8': '8- Número do Lote',
    '9': '9- Número do Protocolo',
    '10': '10- Código da Glosa do Protocolo',
    '11': '11- Justificativa (no caso de recurso integral do protocolo)',
    '12': '12- Acatado',
    '13': '13- Número da guia no prestador',
    '14': '14- Número da guia atribuído pela operadora',
    '15': '15- Senha',
    '16': '16- Código da glosa da guia',
    '17': '17- Justificativa (no caso de recurso integral da guia)',
    '18': '18- Acatado',
    '19': '19- Data realização',
    '20': '20- Data final período',
    '21': '21- Tabela',
    '22': '22- Procedimento/Item assistencial',
    '23': '23- Descrição',
    '24': '24- Grau\n Participação',
    '25': '25- Código da glosa',
    '26': '26- Valor Recursado',
    '27': '27- Justificativa do Prestador',
    '28': '28- Valor Acatado',
    '29': '29- Justificativa da operadora',
    '30': '30- Valor Total Recursado (R$)',
    '31': '31- Valor Total Acatado (R$)',
    '32': '32- Data do Recurso',
    '33': '33- Assinatura do Contratado',
    '34': '34- Data da Assinatura da Operadora',
    '35': '35- Assinatura da Operadora',
    nameGuide: 'GUIA DE RECURSO DE GLOSAS',
    dataOfContracted: 'Dados do Contratado',
    dataOfProtocolAppeal: 'Dados do recurso do protocolo',
    dataOfGuideAppeal: 'Dados do recurso da guia',
    dataOfItem: 'Dados do recurso do procedimento ou item assistencial',
  },
  otherExpenses: {
    '1': '1- Registro ANS',
    '2': '2- Número da Guia Referenciada',
    '3': '3- Código na Operadora',
    '4': '4- Nome do Contratado',
    '5': '5- Código CNES',
    '6': '6- CD',
    '7': '7- Data',
    '8': '8- Hora Inicial',
    '9': '9- Hora Final',
    '10': '10- Tabela',
    '11': '11- Código do Item',
    '12': '12- Qtde.',
    '13': '13- Unidade\n de Medida',
    '14': '14- Fator Red.\n / Acresc',
    '15': '15- Valor Unitário - R$',
    '16': '16- Valor Total – R$',
    '17': '17- Registro ANVISA do Material',
    '18': '18- Referência do material no fabricante',
    '19': '19- Nº Autorização de Funcionamento',
    '20': '20- Descrição',
    '21': '21- Total de Gases Medicinais',
    '22': '22- Total de Medicamentos',
    '23': '23- Total de Materiais',
    '24': '24- Total de OPME ',
    '25': '25- Total de Taxas e Aluguéis',
    '26': '26- Total de diárias (R$)',
    '27': '27- Total Geral',
    nameGuide: 'ANEXO DE OUTRAS DESPESAS \n (para Guia de SP/SADT e Resumo de Internação)',
    dataOfContractedExecuter: 'Dados do Contratado Executante',
    expensesRealizeds: 'Despesas realizadas',
    totalProcedures: 'Total dos procedimentos',
  },
  SPSADT: {
    '1': '1- Registro ANS',
    '2': '2- Nº Guia no Prestador',
    '3': '3- Número da Guia Principal',
    '4': '4- Data da autorização',
    '5': '5- Senha',
    '6': '6- Data de Validade da Senha',
    '7': '7- Número da Guia Atribuído pela Operadora',
    '8': '8- Número da Carteira',
    '9': '9- Data de Validade da Carteira',
    '10': '10- Nome',
    '11': '11- Cartão nacional de saúde',
    '12': '12- Atendimento a RN',
    '13': '13- Código na operadora',
    '14': '14- Nome do contratado',
    '15': '15- Nome do profissional solicitante',
    '16': '16- Conselho profissional',
    '17': '17- Número no conselho',
    '18': '18- UF',
    '19': '19- Código CBO',
    '20': '20- Assinatura do Profissional Solicitante',
    '21': '21- Caráter do Atendimento',
    '22': '22- Data da Solicitação',
    '23': '23- Indicação Clínica',
    '24': '24- Tabela',
    '25': '25- Código do Procedimento ou Item Presencial',
    '26': '26- Descrição',
    '27': '27- Qtde. Solic.',
    '28': '28- Qtde. Aut.',
    '29': '29- Código na Operadora',
    '30': '30- Nome do Contratado',
    '31': '31- Código CNES',
    '32': '32- Tipo de Atendimento',
    '33': '33- Indicação de Acidente (acidente ou doença relacionada)',
    '34': '34- Tipo de Consulta',
    '35': '35- Motivo de Encerramento do Atendimento',
    '36': '36- Data',
    '37': '37- Hora Inicial',
    '38': '38- Hora Final',
    '39': '39- Tabela',
    '40': '40- Código do Procedimento',
    '41': '41- Descrição',
    '42': '42- Qtde.',
    '43': '43- Via',
    '44': '44- Tec.',
    '45': '45- Fator Red./Acresc.',
    '46': '46- Valor Unitário (R$)',
    '47': '47- Valor Total (R$)',
    '48': '48-Seq.Ref.',
    '49': '49-Grau Part.',
    '50': '50- Código na Operadora/CPF',
    '51': '51- Nome do Profissional',
    '52': '52- Conselho Profissional',
    '53': '53- Número no Conselho',
    '54': '54-UF',
    '55': '55- Código CBO',
    '56': '56- Data de Realização do Procedimento em Série',
    '57': '57- Assinatura do Beneficiário ou Responsável',
    '58': '58- Observação / Justificativa',
    '59': '59- Total de Procedimentos (R$)',
    '60': '60- Total de Taxas e Aluguéis (R$)',
    '61': '61- Total de Materiais (R$)',
    '62': '62- Total de OPME (R$)',
    '63': '63- Total de Medicamentos (R$)',
    '64': '64- Total de Gases Medicinais (R$)',
    '65': '65- Total Geral (R$)',
    nameGuide: 'GUIA DE SERVIÇO PROFISSIONAL / SERVIÇO AUXILIAR DE DIAGNÓSTICO E TERAPIA - SP/SADT',
    namePDF: 'GUIA SP/SADT',
    beneficiaryData: 'Dados do Beneficiário',
    requesterData: 'Dados do Solicitante',
    requesterDataProcOrItems: 'Dados da Solicitação / Procedimentos ou Itens Assistenciais Solicitados',
    dataOfContractedExecuter: 'Dados do Contratado Executante',
    executionData: 'Dados da Execução / Procedimentos e Exames Realizados',
    professionalExecutor: 'Identificação do(s) Profissional(is) Executante(s)',

    totalProcedures: 'Total dos procedimentos',
    totalTaxesAndRents: 'Total de Taxas e Aluguéis',
    totalMaterials: 'Total de Materiais',
    totalOPME: 'Total de OPME ',
    totalMedicines: 'Total de Medicamentos',
    totalMedicalGases: 'Total de Gases Medicinais',
    totalGeral: 'Total Geral',
  },
  fees: {
    '1': '1- Registro ANS',
    '2': '2- Nº Guia no Prestador',
    '3': '3- Nº Guia de Solicitação de Internação',
    '4': '4- Senha',
    '5': '5- Número da Guia Atribuído pela Operadora',
    '6': '6- Número da Carteira',
    '7': '7- Nome',
    '8': '8- Atendimento a RN',
    '9': '9- Código na Operadora',
    '10': '10- Nome do Hospital/Local',
    '11': '11- Código CNES',
    '12': '12- Código na Operadora',
    '13': '13- Nome do Contratado',
    '14': '14- Código CNES',
    '15': '15- Data do Início do Faturamento',
    '16': '16- Data do Fim do Faturamento',
    '17': '17- Data',
    '18': '18- Hora Inicial',
    '19': '19- Hora Final',
    '20': '20- Tabela',
    '21': '21- Código do Procedimento',
    '22': '22- Descrição',
    '23': '23- Qtde.24',
    '24': '24- Via',
    '25': '25- Tec.',
    '26': '26- Fator Red./Acresc.',
    '27': '27- Valor Unitário (R$)',
    '28': '28- Valor Total (R$)',
    '29': '29-Seq.Ref.',
    '30': '30-Grau Part.',
    '31': '31- Código na Operadora/CPF',
    '32': '32- Nome do Profissional',
    '33': '33- Conselho Profissional',
    '34': '34- Número no Conselho',
    '35': '35-UF',
    '36': '36- Código CBO',
    '37': '37- Observação / Justificativa',
    '38': '38- Valor total dos honorários (R$)',
    '39': '39- Data de emissão',
    '40': '40- Assinatura do Profissional Executante',
    namePDF: 'GUIA DE HONORÁRIOS',
    nameGuide: 'GUIA DE HONORÁRIOS \n (somente para pacientes internados)',
    beneficiaryData: 'Dados do Beneficiário',
    localeData: 'Dados do Contratado (onde foi executado o procedimento)',
    dataOfContractedExecuter: 'Dados do Contratado Executante',
    hospitalizationData: 'Dados da Internação',
    proceduresRealizeds: 'Procedimentos Realizados',
    professionalExecutor: 'Identificação do(s) Profissional(is) Executante(s)'
  },
  consultation: {
    '1': '1- Registro ANS',
    '2': '2- Nº Guia no Prestador',
    '3': '3- Número da Guia Atribuído pela Operadora',
    '4': '4- Número da Carteira',
    '5': '5- Validade da Carteira',
    '6': '6- Atendimento a RN (Sim ou Não)',
    '7': '7- Nome',
    '8': '8- Número do Cartão Nacional de Saúde',
    '9': '9- Código na Operadora',
    '10': '10- Nome do Contratado',
    '11': '11- Código CNES',
    '12': '12- Nome do Profissional Executante',
    '13': '13- Conselho Profissional',
    '14': '14- Número no conselho',
    '15': '15- UF',
    '16': '16- Código CBO',
    '17': '17- Indicação de Acidente (acidente ou doença relacionada)',
    '18': '18- Data do atendimento',
    '19': '19- Tipo de consulta',
    '20': '20- Tabela',
    '21': '21- Código do procedimento',
    '22': '22- Valor do procedimento',
    '23': '23- Observação / justificativa',
    '24': '24- Assinatura do profissional executante',
    '25': '25- Assinatura do beneficiário ou responsável',
    nameGuide: 'GUIA DE CONSULTA',
    namePDF: 'GUIA DE CONSULTA',
    beneficiaryData: 'Dados do Beneficiário',
    requesterData: 'Dados do Contratado',
    attendanceData: 'Dados do atendimento / procedimento ralizado'
  },
  fcm: {
    audio: {
      noFileSelected: 'Sem arquivos selecionados',
    },
    errors: {
      fileTypeNotAllowed: 'Typo de Arquivo não permitido',
      fileNotWillBeUpload: 'Não vai ser feito o upload do arquivo por causa de um erro com o arquivo',
      needFolder: 'É necessário definir um folder'
    },
    confirmDelete: 'Você tem certeza que deseja remover esse arquivo?',
    needUploadToServerToSeeInTab: 'É necessário concluir antes de abrir em nova aba'
  },
  history: {
    item: {
      action: 'Ação',
      path: 'Chave',
      old: 'Valor anterior',
      value: 'Novo valor'
    },
    add: 'Adicionado',
    deleted: 'Deletado',
    modify: 'Modificado',
    tipExpandAll: 'alt + click: para expandir todos os itens',
    viewSimple: 'Simplificado',
    viewFull: 'Completo',
  },
  eventHistory: {
    campo: 'Campo',
    antes: 'Antes',
    depois: 'Depois',
    procedimentos: 'Procedimentos',
    alteracoes: 'alterações',
    verDetalhes: 'Ver detalhes técnicos',
  },
  eventHistoryChangeCard: {
    nullValue: '—',
    objectChanged: '(objeto alterado)',
    noVisibleChanges: 'Nenhuma alteração em campos principais — use os detalhes técnicos ou a visão Completo',
    boolTrue: 'Sim',
    boolFalse: 'Não',
    fields: {
      hospitalId: 'Hospital',
      healthInsuranceId: 'Convênio',
      anesthetistId: 'Anestesista',
      surgeonId: 'Cirurgião',
      secondaryAnesthetistId: '2º Anestesista',
      residentId: 'Residente',
      accommodation: 'Acomodação',
      status: {
        status: 'Status',
      },
      dtProcedure: 'Data do Procedimento',
      observations: 'Observações',
      procedures: 'Procedimentos',
      patient: {
        name: 'Paciente',
        updatedAt: 'Atualização do Paciente',
      },
      anesthesiaStart: 'Início Anestesia',
      anesthesiaEnd: 'Fim Anestesia',
      procedureStart: 'Início Procedimento',
      procedureEnd: 'Fim Procedimento',
      values: {
        totalProduced: 'Valor Produzido',
        totalReceived: 'Valor Recebido',
        totalGlosado: 'Valor Glosado',
        totalLoss: 'Valor Perdido',
        totalDiscount: 'Desconto',
        totalInProcessing: 'Em Processamento',
        totalOver: 'Valor Excedente',
      },
      actorsTypes: 'Tipos de Profissional',
      actorsIds: 'Profissionais',
      revenueIds: 'IDs de Receita',
      actors: 'Profissionais',
      totalFees: 'Total de Taxas',
      proceduresIds: 'Procedimentos',
      additionalData: 'Dados Adicionais',
      multAdditionalData: 'Dados Adicionais (Multi)',
      type: 'Tipo',
      isMain: 'Principal',
      percentRevenue: '% Receita',
      revenue: 'Receita',
      grauPart: 'Grau Part.',
      name: 'Nome',
    },
    groups: {
      proceduresObj: 'Procedimentos',
      actors: 'Profissionais',
      additionalData: 'Dados Adicionais',
      multAdditionalData: 'Dados Adicionais (Multi)',
    },
    values: {
      KANESTHETIST: 'Anestesista',
      KSURGEON: 'Cirurgião',
      KRESIDENT: 'Residente',
      KSECONDARY_ANESTHETIST: '2º Anestesista',
      KMATRIZ: 'Matriz',
      KFILIAL: 'Filial',
      KPERSONALPRODUCTION: 'Produção Pessoal',
      Honorario: 'Honorário',
      Consulta: 'Consulta',
      SPSADT: 'SP/SADT',
      Exame: 'Exame',
      NURSERY: 'Enfermaria',
      APARTMENT: 'Apartamento',
      OUTPATIENT: 'Ambulatório',
      ONE_DAY_CLINIC: 'Day Clinic',
      NONE: 'Nenhum',
      AwaitingCheck: 'Aguardando Conferência',
      WaitSendGuia: 'Aguardando Envio de Guia',
      WaitPayment: 'Aguardando Pagamento',
      WaitSendRecourse: 'Aguardando Envio de Recurso',
      WaitRecourse: 'Aguardando Recurso',
      Received: 'Recebido',
      Cuted: 'Glosado',
      PartialCuted: 'Glosado Parcial',
      Losed: 'Perdido',
      PartialLosed: 'Perdido Parcial',
      Pending: 'Pendente',
      InternalPending: 'Pendência Interna',
    },
  },
  historyEvents: {
    noContent: 'Sem Conteúdo',
    values: {
      totalProceduresReceived: 'Total recebido de procedimentos',
      totalReceived: 'Total recebido',
      totalProcedures: 'Total procedimentos',
      totalInProcessing: 'Total processando',
      totalProduced: 'Total produzido',
      totalProceduresOver: 'Total procedimentos over',
      totalProceduresGlosado: 'Total procedimentos glosado',
      totalDiscount: 'Total desconto',
      totalProceduresLoss: 'Total procedimentos Perdido'
    },
    patient: {
      name: 'Nome do paciente',
      nameLowerCase: 'Nome do paciente lowercase',
      healthInsuranceId: 'Convênio do paciente'
    },
    healthInsuranceId: 'Convênio',
    nameXLSX: 'Relatório de Histórico de Alteração de Eventos',
    xlsxLabels: {
      accommodation: 'Acomodação',
      additionalData: {
        accidenteIndication: 'Indicação de Acidente [Dados Adicionais]',
        attendanceDateConsult: 'Data do atendimento (consulta) [Dados Adicionais]',
        attendanceRN: 'Atendimento a RN [Dados Adicionais]',
        codeProcedureConsult: 'Código do Procedimento da Consulta [Dados Adicionais]',
        consultType: 'Tipo de Consulta [Dados Adicionais]',
        name: 'Nome [Dados Adicionais]',
        numberProviderGuide: 'Nº Guia no Prestador [Dados Adicionais]',
        numberWallet: 'Nº da Carteirinha [Dados Adicionais]',
        otherExpenses: 'Outras Despesas [Dados Adicionais]',
        password: 'Senha [Dados Adicionais]',
        valueProcedureConsult: 'Valor do procedimento na Consulta [Dados Adicionais]',
        grauPart: 'Grau de participação [Dados Adicionais]',
        anesthesiaStart: 'Horário do início da anestesia [Dados Adicionais]',
        anesthesiaEnd: 'Horário do fim da anestesia [Dados Adicionais]',
        authorizationDate: 'Data da autorização [Dados Adicionais]',
        passwordExpirationDate: 'Data de validade da senha [Dados Adicionais]',
        guideNumberSetByOperator: 'Número da guia atribuído pela operadora [Dados Adicionais]',
        codeProviderInOperator: 'Código do prestador na operadora [Dados Adicionais]',
        solicitationGuideNumberHospitalization: 'Nº da guia de solicitação de serviço [Dados Adicionais]',
        walletExpirationDate: 'Data de validade da carteira [Dados Adicionais]',
        healthCard: 'Cartão Nacional de Saúde [Dados Adicionais]',
        clinicIndication: 'Indicação Clínica [Dados Adicionais]',
        attendimentType: 'Tipo de atendimento [Dados Adicionais]',
        reasonToFinishAttendiment: 'Motivo de Encerramento do Atendimento [Dados Adicionais]',
        totalProcedures: 'Total de procedimentos (R$) [Dados Adicionais]',
        totalTaxes: 'Total de taxas e aluguéis (R$) [Dados Adicionais]',
        totalMaterials: 'Total de materiais (R$) [Dados Adicionais]',
        totalOPME: 'Total de OPME (R$) [Dados Adicionais]',
        totalDrugs: 'Total de medicamentos (R$) [Dados Adicionais]',
        totalGasesMedicinals: 'Total de gases medicinais (R$) [Dados Adicionais]',
        total: 'Total geral (R$) [Dados Adicionais]',
        totalFees: 'Total honorários (R$) [Dados Adicionais]',
        startDateBilling: 'Data do início do faturamento [Dados Adicionais]',
        endDateBilling: 'Data do fim do faturamento [Dados Adicionais]',
        emissionDate: 'Data de emissão [Dados Adicionais]',
        totalDayly: 'Valor Total Diário (R$) [Dados Adicionais]',
      },
      appealsIds: 'Quantidade de Recursos Vinculados',
      anesthetist: 'Anestesista',
      anesthetistId: 'Anestesista',
      anesthesiaEnd: 'Fim da Anestesia',
      anesthesiaStart: 'Início da Anestesia',
      attachments: {
        guide: {
          url: 'URL Guia',
          mime: 'Tipo de Documento Guia'
        },
        record: {
          url: 'URL Ficha',
          mime: 'Tipo de Documento Ficha',
        },
        rgo: {
          url: 'URL RGO',
          mime: 'Tipo de Documento RGO',
        },
        term: {
          url: 'URL Termo',
          mime: 'Tipo de Documento Termo',
        },
        apa: {
          url: 'URL APA',
          mime: 'Tipo de Documento APA'
        },
        medicalRecord: {
          url: 'URL Prontuário',
          mime: 'Tipo de Documento Prontuário'
        },
        hospitalizationForm: {
          url: 'URL Ficha de Internação',
          mime: 'Tipo de Documento Ficha de Internação'
        },
        networkCharter: {
          url: 'URL Carta de Rede',
          mime: 'Tipo de Documento Carta de Rede'
        },
        other: {
          url: 'URL Outro',
          mime: 'Tipo de Documento Outro',
        },
        '3AFile': {
          url: 'URL 3A',
          mime: 'Documento vindo do 3A',
        }
      },
      batchesIds: {
        '0': {
          name: 'Nome do Lote',
          code: 'Código do Lote',
        }
      },
      customFields: {
        responseTypes: {
          default: 'Valor',
          option: 'Opção',
          options: 'Opções',
        }
      },
      dtProcedure: 'Data do Procedimento',
      dtRecourse: 'Data do Recurso',
      healthInsuranceId: 'Convênio',
      healthInsuranceWallet: 'Carteira do Convênio',
      hospitalId: 'Hospital',
      // Invoices?: 'Notas',
      isEmergency: 'É Emergência',
      isFollowUp: 'É Retorno',
      numGuide: 'Número da Guia',
      numberProviderGuides: 'Números de guia no prestador',
      observationGuideSent: 'Observação de guia enviada',
      observationRecourse: 'Observação de Recurso',
      pbservations: 'Observações',
      patient: {
        accomodation: 'Acomodação',
        birthDateIso: 'Dt. Nascimento',
        cpf: 'CPF',
        email: 'Email',
        gender: 'Gênero',
        healthInsuranceId: 'Convênio [Paciente]',
        healthInsuranceWallet: 'Carteirinha do Convênio [Paciente]',
        meta: {
          deletedAt: 'Paciente Removido Em',
          updatedAt: 'Paciente Atualizado Em [Meta]',
          updatedEnv: 'Atualizado Em Ambiente',
          updatedByAdmin: 'Atualizado Por Administrador',
          updatedByName: 'Atualizado Por',
        },
        momName: 'Nome da mãe',
        name: 'Nome',
        phone: 'Telefone',
        updatedAt: 'Paciente Atualizado Em'
      },
      protocolId: 'Protocolo',
      residentId: 'Residente',
      secondaryAnesthetistId: 'Segundo Anestesista',
      shouldBeFollowUp: 'Deveria ser Retorno',
      status: {
        alertReceive: 'Alerta Recebimento',
        alertSendGuia: 'Alerta Guia Enviada',
        alertSendRecourse: 'Alerta Recurso Enviado',
        guiaSent: 'Guia enviada [Status]',
        hasComplementation: 'Possui complementação [Status]',
        hasCuted: 'Possui glosa [Status]',
        hasLoss: 'Possui Perda [Status]',
        isProcessing: 'Em Processamento [Status]',
        received: 'Recebido [Status]',
        recourseIdentify: 'Recurso Identificado [Status]',
        recourseSent: 'Recurso Enviado [Status]',
        status: 'Status [Status]',
        urgent: 'Urgência [Status]'
      },
      surgeonId: 'Cirurgião',
      surgeon: 'Cirurgião',
      thirdAnesthetistId: 'Terceiro Anestesista',
      type: 'Tipo do Evento',
      updatedByAdmin: 'Atualizado por Administrador',
      values: {
        attendanceFee: 'Valor Co-participativo',
        attendanceFeeLoss: 'Valor Co-participativo Perdido',
        attendanceFeeReceived: 'Valor Co-participativo Recebido',
        complementation: 'Complementação',
        complementationLoss: 'Complementação Perdida',
        complementationOver: 'Complementação Over',
        complementationReceived: 'Complementação Recebida',
        expenses: 'Taxas/Despesas',
        expensesDiscount: 'Desconto Taxas/Despesas',
        expensesGlosado: 'Taxas/Despesas Glosado',
        expensesLoss: 'Taxas/Despesas Perdidas',
        expensesOver: 'Taxas/Despesas Over',
        expensesReceived: 'Taxas/Despesas Recebidas',
        totalAcceptedByAppeal: 'Valor Total Glosado por Recurso',
        totalAppealed: 'Valor Total Recursado',
        totalChanged: 'Valor Total alterado',
        totalChangedLess: 'Valor Total alterado para menos',
        totalChangedPlus: 'Valor Total alterado para mais',
        totalDiscount: 'Valor Total Descontado',
        totalGlosado: 'Valor Total Glosa Acatada',
        totalInProcessing: 'Valor Total em Processamento',
        totalLoss: 'Valor Total Perdido',
        totalOver: 'Valor Total Over',
        totalProcedures: 'Valor Total Procedimentos',
        totalProceduresGlosado: 'Valor Total Procedimentos Glosa Acatada',
        totalProceduresLoss: 'Valor Total Procedimentos Perdido',
        totalProceduresOver: 'Valor Total Procedimentos Over',
        totalProceduresReceived: 'Valor Total Procedimentos Recebido',
        totalProduced: 'Valor Total Produzido',
        totalReceived: 'Valor Total Recebido',
        totalReceivedByAppeal: 'Valor Total Recebido por Recurso',
        valueChanged: 'Valor Modificado'
      }
    }
  },
  negotiationProcedures: {
    open: 'Editar valores dos procedimentos',
    title: 'Procedimentos da negociação',
    search: 'Buscar por código ou descrição',
    count: 'Exibindo {shown} de {total}',
    noTable: 'Esta negociação ainda não tem tabela de procedimentos publicada.',
    loadError: 'Não foi possível carregar os procedimentos desta negociação',
    undo: 'Desfazer alteração',
    undoAll: 'Desfazer as {count} alterações',
    pendingHint: 'Pendências nesta negociação: {changed} valores alterados, {added} procedimentos incluídos, {removed} removidos. Nada é publicado até você salvar o convênio.',
    idProc: 'Código',
    name: 'Procedimento',
    valueTable: 'Valor',
    participative: 'Co-participação',
    participativeHint: 'Parte do valor paga pelo paciente (coluna FATOR da planilha). Já está incluída no valor do procedimento; a negociação a desconta e lança como taxa de atendimento.',
    add: 'Adicionar procedimento',
    confirmAdd: 'Confirmar inclusão',
    remove: 'Remover da tabela',
    discardAdded: 'Descartar a inclusão',
    idProcRequired: 'Informe o código do procedimento.',
    nameRequired: 'Informe a descrição do procedimento.',
    idProcDuplicated: 'Já existe um procedimento com este código nesta tabela.',
    emptyTable: 'A tabela ficaria sem nenhum procedimento. Desfaça ao menos uma remoção antes de salvar.',
    noChangeError: 'Não foi possível aplicar as alterações dos procedimentos. Reabra a tabela e refaça a edição.',
    revisionHint: 'Os procedimentos desta negociação foram alterados. Ao salvar, uma revisão da tabela será publicada e os eventos já lançados neste período passarão a usar a tabela nova.',
    newTableHint: 'Esta negociação receberá uma cópia própria da tabela de procedimentos ao salvar.',
    publishError: 'Não foi possível publicar a tabela de procedimentos',
  },

  insurancePricesImport: {
    title: 'Importação de preços por convênio',
    notEnabled: 'A importação de preços por convênio não está habilitada para esta empresa.',
    subtitle: 'Envie a planilha de preços. Cada convênio vira uma linha, e você escolhe quais publicar — os que ficarem pendentes podem ser resolvidos numa próxima importação.',
    selectFile: 'Planilha de preços (.xlsx)',
    process: 'Processar planilha',
    processed: 'Planilha processada',
    processedDetail: '{ready} de {total} convênios prontos para publicar',
    processError: 'Não foi possível ler a planilha',
    noBlocks: 'Nenhum bloco de convênio encontrado em nenhuma aba da planilha',
    selectSheets: 'Abas a importar',
    selectSheetsHint: 'Só as abas marcadas são lidas e importadas',
    readSheetsError: 'Não foi possível ler as abas da planilha',
    noSheetsSelected: 'Selecione ao menos uma aba para importar',
    duplicatedInsurance: 'Mais de uma linha marcada aponta para o mesmo convênio ({list}). Publicadas juntas, uma sobrescreveria a outra — desmarque uma delas.',
    sheetRead: '· abas lidas: {sheet}',
    anchor: 'Tabela CBHPM âncora',
    anchorHint: 'Usada só nos convênios sem negociação anterior',
    summary: '{total} convênios na planilha · {ready} prontos · {noChanges} sem alterações · {pending} pendentes',
    dateCandidates: 'Mais de uma vigência no título: {list}',
    filterStatus: 'Filtrar por situação',
    filterShowing: 'Mostrando {shown} de {total} linhas',
    filterHiddenSelected: '{count} linha(s) marcada(s) fora do filtro — elas também serão publicadas',
    filterEmpty: 'Nenhuma linha na situação escolhida. Limpe o filtro para ver as demais.',
    publish: 'Publicar {count} convênios ({procedures} procedimentos)',
    negotiationPeriod: '{start} → {end}',
    negotiationOpenEnd: 'sem fim',
    targetNew: 'Criar negociação (pela vigência)',
    targetUpdate: 'Atualizar {period}',
    targetUpdateHint: 'Recalcula os eventos já lançados neste período',
    targetUpdateNoTable: '{period} — não usa tabela de valores',
    targetLabelNew: 'Negociação nova a partir de {date}',
    targetLabelUpdate: 'Atualização da negociação {period}',
    confirmTitle: 'Publicar os preços?',
    confirmText: 'Serão publicados {count} convênios, com {procedures} procedimentos. Os convênios com alteração de valor recebem uma negociação nova a partir da vigência informada.',
    confirmTextWithUpdates: 'Serão publicados {count} convênios, com {procedures} procedimentos. Em {updates} deles a tabela de uma negociação existente será substituída, sem criar negociação nova e sem mexer nas datas — os eventos já lançados naquele período passam a recalcular pelos valores novos. Os demais recebem uma negociação nova a partir da vigência informada.',
    publishedTitle: 'Preços publicados',
    publishedText: '{count} convênios atualizados',
    publishedRow: 'Publicado ({action})',
    partialTitle: 'Publicação parcial',
    partialText: '{published} convênios publicados, {failed} com erro',
    publishError: 'Não foi possível publicar os preços',
    publishRejected: 'O servidor recusou a publicação',
    publishRejectedDetail: 'Nenhum convênio foi publicado. Motivo: {reason} ({code}).',
    col: {
      block: 'Convênio na planilha',
      insurance: 'Convênio cadastrado',
      effectiveDate: 'Vigência',
      target: 'Destino',
      procedures: 'Procedimentos',
      changes: 'Incluídos / alterados / removidos',
      status: 'Situação',
    },
    status: {
      ready: 'Pronto',
      noChanges: 'Sem alterações',
      needsInsurance: 'Sem convênio',
      needsDate: 'Confirmar vigência',
      needsAnchor: 'Escolher tabela âncora',
      skipped: 'Ignorado',
    },
    diff: {
      open: 'Ver o que está mudando',
      title: 'O que está mudando',
      noDiff: 'Esta linha ainda não foi comparada com nenhuma tabela.',
      empty: 'Nenhuma diferença nesta situação.',
      search: 'Buscar por código ou descrição',
      filterKind: 'Tipo de mudança',
      count: '{shown} de {total}',
      summary: '{added} incluídos · {changed} alterados · {removed} removidos · {zeroed} zerados por pacote · {renamed} renomeados',
      unchanged: '{count} sem alteração',
      keptZero: 'já estava zerado',
      zeroedHint: 'Procedimentos citados por um pacote ou por um grupo de faturamento por hora e ausentes da planilha permanecem na tabela com valor zero. Removê-los deixaria o pacote apontando para um procedimento que não existe mais, e o faturamento seguiria com a composição quebrada, sem erro nenhum.',
      kind: {
        added: 'Incluído',
        changed: 'Alterado',
        removed: 'Removido',
        zeroed: 'Zerado (pacote)',
        renamed: 'Renomeado',
      },
      col: {
        kind: 'Mudança',
        idProc: 'Código',
        name: 'Descrição',
        value: 'Valor da tabela',
        participative: 'Co-participação',
      },
    },
  },

  healthInsurance: {
    billingType: 'Tipo de faturamento',
    enableRangeAppealReason: 'Habilitar limites de caracteres para justificativa de recurso',
    showMatrizNameInFeeGuide: 'Mostrar o nome da matriz e cnpj no campo 40 da guia TISS de honorário',
    configXmlStructure: 'Configurações da estrutura do xml',
    financial: 'Financeiro',
    notTransferOverToProfessional: 'Não repassar valor do over para o profissional',
    enableAttendanceFeeReducingFromProcedure: 'Habilitar co-participativo removendo valor do procedimento',
    receiver: 'Recebedor',
    indicator: 'Indicador',
    defaultValueHour: 'Valor padrão por hora',
    hour: 'Hora',
    addHourToBillingPerHour: 'Adicionar hora',
    addBillingPerHour: 'Adicionar valor por hora',
    billingPerHour: 'Faturamento por hora com base na acomodação',
    idProc: 'Procedimento',
    addPackage: 'Adicionar pacote',
    packages: 'Pacotes',
    packageName: 'Nome do pacote',
    packageValue: 'Valor do pacote',
    name: 'Nome',
    code: 'Código',
    revenueConfigs: {
      SPSADT: 'SPSADT',
      Consulta: 'Consulta',
      Honorario: 'Honorario',
      valueUCO: 'Valor de UCO',
      enableUCO: 'Habilitar faturamento de UCO',
      ucoName: 'Configurações do UCO',
      name: 'Configurações de faturamento',
      type: 'Tipo de pessoa da equipe',
      enable: 'Habilitar',
      enableKSURGEON: 'Habilitar faturamento do cirurgião principal',
      enableKASSISTANT_SURGEON: 'Habilitar faturamento dos cirurgiões auxiliares',
      enableKASSISTANT_ANESTHETIST: 'Habilitar faturamento dos anestesistas auxiliares',
      enableTeamKASSISTANT_SURGEON: 'Habilitar faturamento do {number}º cirurgião auxiliar',
      enableTeamKASSISTANT_ANESTHETIST: 'Habilitar faturamento do {number}º anestesista auxiliar',
      enableKANESTHETIST: 'Habilitar faturamento do anestesista principal',
      enableKSECONDARY_ANESTHETIST: 'Habilitar faturamento do segundo anestesista',
      enableKSCRUB_NURSE: 'Habilitar faturamento do instrumentador',
      enableKPHONOAUDIOLOGIST: 'Habilitar faturamento do Fonoaudiólogo',
      enableKRESIDENT_ANESTHETIST: 'Habilitar faturamento do anestesista residente',
      enableKRESIDENT_SURGEON: 'Habilitar faturamento do cirurgião residente',
      enableKNURSE: 'Habilitar faturamento do enfermeiro',
      percentRevenue: 'Porcentagem a ser cobrada do procedimento',
      grauPart: 'Grau de participação',
      KSURGEON: 'Cirurgião principal',
      KASSISTANT: {
        KASSISTANT_SURGEON: 'Cirurgião auxiliar',
        KASSISTANT_ANESTHETIST: 'Anestesista auxiliar'
      },
      KSCRUB_NURSE: 'Instrumentador',
      KANESTHETIST: 'Anestesista principal',
      KSECONDARY_ANESTHETIST: 'Segundo anestesista',
      KRESIDENT_ANESTHETIST: 'Anestesista residente',
      KRESIDENT_SURGEON: 'Cirugião residente',
      KNURSE: 'Enfermeiro',
      KPHONOAUDIOLOGIST: 'Fonoaudiólogo',
    },
    techniquesUsed: 'Técnicas utilizadas',
    typesEvent: 'Tipo de evento',
    typesEventHint: 'Nenhum procedimento sofrerá acréscimos no tipo selecionado. O tipo tem prioridade sobre a técnica utilizada',
    ignoreCBHPMIncreases: 'Ignorar acréscimos das regras da CBHPM',
    enableIgnoreCBHPMIncreases: 'Habilitar funcionalidade de ignorar acréscimos das regras da CBHPM',
    SPSADT: 'SPSADT',
    Consulta: 'Consulta',
    Honorario: 'Honorario',
    useEventTypeAs: 'Selecionar o tipo de guia que será gerada',
    validateEventAs: 'Selecionar o tipo de guia para validação do evento',
    tableCodeDefaultPerEventType: 'Código da tabela default por tipo de evento',
    grauPartPerEventType: 'Grau de participação por tipo de evento',
    medicalReturn: 'Retorno',
    additionalTaxesOrExpenses: 'Taxas/despesas nos dados adicionais',
    exportAddedToCBHPM: 'Exportar adicionados à CBHPM',
    importProceduresToAddCBHPM: 'Importar procedimentos para CBHPM',
    exportOverridesProcedures: 'Exportar procedimentos especiais',
    importOverridesProcedures: 'Importar procedimentos especiais',
    importCustomsProcedures: 'Importar procedimentos customizados',
    codigoContratadoExecutante: 'Código/CNPJ do contratado executante',
    codigoLocalContratado: 'Código/CNPJ do local contratado',
    customProportions: 'Proporções customizadas',
    emergencyProportion: 'Proporção da emergência (padrão 130%)',
    enableCustomProportions: 'Habilitar proporções customizadas',
    fillSurgeonData: 'Preencher os dados do cirurgião com os dados do: ',
    nomeContratado: 'Nome do contratado',
    codigoPrestadorContratadoSolicitante: 'Codigo prestador na operadora do contratado solicitante',
    codigoPrestadorProfissional: 'Codigo prestador na operadora do profissional/anestesista',
    applyCBHPMRules: 'Aplicar regras da CBHPM nos procedimentos dessa tabela',
    applyCBHPMRulesHint: 'Se ativado, os procedimentos da tabela, os procedimentos especiais e os procedimentos adicionados à tabela receberão as mudanças de valores' +
      ' respectivos a urgência/emergência e acomodação em apartamento.',
    taxesApplaying: 'Taxas aplicáveis',
    configTransfer: 'Configurações de repasse',
    ignoreParticipative: 'Ignorar co-participativo no repasse',
    participativeExecutant: {
      title: 'Co-participativo recebido pelo executante',
      hint: 'Nos hospitais listados o co-participativo é pago direto ao executante: os demais participantes recebem a parte deles do co-participativo no repasse e a cooperativa cobra essa parte do executante, menos a taxa selecionada, abatendo do próprio repasse. Com repasse customizado a parte de cada um segue os fatores; sem, a divisão da edição de valores',
      tax: 'Taxa deduzida da cobrança',
    },
    transferCategory: 'Categoria do repasse (plano de contas)',
    transferCategoryHint: 'Vazio = categoria padrão da empresa. Preenchido, todo o repasse deste ' +
      'convênio/hospital cai nesta categoria (o hospital tem prioridade sobre o convênio).',
    configsOnlyAdmin: 'Configurações disponíveis somente para administradores do sistema',
    procedurePercent: 'Porcentagem no procedimento',
    techniqueHint: 'Porcentagem que será cobrada do procedimento quando esta técnica for utilizada. Ex: ',
    proportionHint: 'Porcentagem que será cobrada do procedimento. Ex: ',
    emergencyHint: 'Porcentagem que será cobrada do procedimento quando marcado emergência. Ex: ',
    emergencyFactor: 'Emergência',
    KConventional: 'Convencional',
    KVideo: 'Video',
    KRobotic: 'Robótica',
    techniqueUsed: 'Técnica utilizada',
    enableTechniqueUsed: 'Habilitar técnica utilizada?',
    filterHealthInsurancesByHospital: 'Filtrar convênios com base no hospital selecionado',
    defaultValuesXml: 'Valor padrão para cada campo no xml:',
    defaultValuesXmlByEventType: 'Valores padrão por tipo de evento:',
    configSomeFieldsXml: 'Configuração de como alguns campos serão enviados no xml, o que você selecionar substituirá o que estiver no XML:',
    appeal: 'Recurso',
    configXml: 'Configurações do XML:',
    configXmlFields: 'Configurações dos campos do XML:',
    configXmlFieldsByEventType: 'Configurações dos campos do XML por tipo de evento:',
    configXmlData: 'Configurações dos dados inseridos no XML:',
    configXmlDataByEventType: 'Configurações dos dados inseridos no XML por tipo de evento:',
    configEvents: 'Configurações dos eventos',
    configContaAzul: 'Configurações da Conta Azul',
    codProfessionalFieldReplace: 'Campo \'codProfissional\' no XML',
    codProfessionalFieldReplaceHint: 'É o campo que vai ser enviado o cpf do anestesista',
    identificacaoPrestadorFieldReplace: 'Campo \'identificacaoPrestador\' no XML',
    codigoContratadoFieldReplace: 'Campo \'codigoContratado\' no XML',
    contratadoExecutanteFieldReplace: 'Campo \'contratadoExecutante\' no XML',
    contratadoSolicitanteFieldReplace: 'Campo \'contratadoSolicitante\' no XML',
    identificacaoPrestadorFieldReplaceHint: 'É o campo que será enviado o código da empresa no provedor, ou o cnpj',
    tempStringAux: 'String temporária',
    tempStringAux2: 'String temporária 2',
    tempStringAuxDesc: 'String temporária só pra poderem gerar as guias com o nome da cooperativa',
    tempStringAux2Desc: 'String temporária só pra poderem gerar as guias com o cnpj da cooperativa',
    markAllToUseAsCBHPM: 'Marcar todos para serem usados como vindo da CBHPM',
    useAsCBHPM: 'Usar como vindo da CBHPM',
    useAsCBHPMTooltip: 'Quando esta flag estiver ativa o procedimento/pacote será semelhante à um procedimento vindo da CBHPM, podendo receber ' +
      'valor adicional quando a acomodação for apartamento e +30% quando for emergência.',
    searchProcedures: 'Filtrar por código de procedimento',
    porte: 'Porte',
    filter: 'Filtrar',
    isAnesthetic: 'É anestésico',
    valueChangeByAcommodation: 'Valores mudam de acordo com a acomodação',
    valueChangeByEmergency: 'Valores mudam de acordo com a emergência',
    rulesOfValues: {
      multiplyInApartment: 'Multiplicar valor do procedimento quando for apartamento',
      valueToMultiplyInApartment: 'Valor que o procedimento deverá ser multiplicado',
      valueToMultiplyInApartmentHint: 'O padrão da CBHPM é 2. No caso, dobra o valor do evento.',
    },
    flags: {
      mandatoryInvoiceWhenReceiveValues: 'Obrigatoriedade de nota no recebimento de valores do evento',
      groupSizeDiscriminationOnGuideObs: 'Exibir o porte, código do grupo e informações discriminadas apenas no campo de observações da guia',
      addTipoConsultaInSPSADT: 'Adicionar o campo tipoConsulta no xml do tipo SP/SADT',
      canEditNumberGuide: 'Permitir alterar o número da guia',
      splitAnesthesiaTimeInProcedures: 'Dividir tempo de anestesia para os procedimentos nos PDF\'s e XML\'s ',
      dateEmissionGuideAsDtProcedure: 'Usar a data do evento para a data de emissão da guia',
      multAdditionalData: 'Múltiplos dados adicionais',
      allowPatientOnlyByName: 'Aceitar paciente identificado só pelo nome',
      allowPatientOnlyByNameHint: 'Para o convênio que não fornece CPF nem carteirinha. Na importação o paciente é cadastrado a partir do nome — sem chave de identidade, cada evento gera um cadastro e a duplicidade não é detectada.',
      enableAdvancedAdditionalDataCalculation: 'Habilitar cálculo avançado para múltiplos dados adicionais',
      automaticNumberGuide: 'Gerar número da guia automaticamente',
      allowAlphanumericInNumberProviderGuide: 'Permitir alfanumérico no número da guia do prestador',
      beginEndFaturamentoUseDtProcedure: 'Data de inicio e fim do faturamento utilizará a data do procedimento por padrão',
      contratadoExecutanteIsHospital: 'O hospital é o contratado executante nas consultas',
      autoBatch: 'Lote automático',
      guideNumberSetByOperatorSameAsNumberProviderGuide: 'Número da guia atribuído pela operadora utiliza o número da guia no operador(número do evento)',
      autoProportion: 'Via de acesso automática ao adicionar procedimentos(procedimento de maior valor 100%, demais procedimentos 50%)',
      customContaAzulNotesOfServices: 'Nota fiscal customizada',
      overrideProcedureValuesWithAdditionalInContaAzul: 'Agrupamento de procedimentos',
      notJoinProceduresInXML: 'Sempre separar os procedimentos no XML',
      hasCustomReceivedOver: 'Tem recebimento de over customizado',
      autoBatchAfterCheck: 'Adicionar automaticamente ao lote somente após conferir o evento',
      autoBatchAfterCheckFilialOnly: 'Lote automático somente após conferir eventos criados por cooperados (os criados pela cooperativa entram direto)',
      autoCloseBatchOnLimit: 'Fechar lote automaticamente ao atingir limite de eventos',
      enablePdfIncome: 'Habilitar importação de baixa via PDF',
      separebyUserInspector: 'Separar lotes por Conferente/Responsável',
      autoBatchByMonthYear: 'Lote automático por competência ativo',
      separateByHospital: 'Separar lote por Hospital',
      separateByMainActor: 'Separar lote por ator principal',
      enablePerProcedureTeam: 'Habilitar equipes por procedimento (abas)',
    },
    configPdf: {
      showEventBarcode: 'Mostrar código de barras no evento',
      name: 'Configurações dos PDF\'s', //Configurações dos PDF's
      appeal: {
        name: 'Recurso',
        showPatientName: 'Mostrar nome do paciente',
      },
      guides: {
        name: 'Guia',
        proceduresMaxRowsPerPage: 'Número máximo de procedimentos por página',
        useHospitalAsExecutor: 'Utilizar hospital como executante',
        useProcedureDateAsGuideEmissionDate: 'Utilizar a data do procedimento como data de emissão da guia'
      }
    },
    factorByAccommodation: {
      enable: 'Habilitar',
      elective: 'Eletiva',
      emergency: 'Emergência',
    },
    setFactorByAccommodation: 'Definir o fator de redução ou acréscimo, por acomodação (será alterado nas guias para o envio): ',
    configs: {
      useReasonProviderRangeLabel: 'Justificativa do prestador no recurso',
      useReasonOperatorRangeLabel: 'Justificativa do operador no recurso',
      replaceDataByTypeUsing: {
        replaceDataByEventType: 'Substituir dado de um campo pelo dado de outro campo baseado no tipo do evento',
      },
      selectItemsConsideredToCalculateUnityValue: 'Selecionar os itens a serem considerados no cálculo do valor unitário',
      itemsConsideredToCalculateUnityValue: {
        title: 'Itens a serem considerados no cálculo do valor unitário',
        accommodation: 'Acomodação',
        isEmergency: 'Eletiva/emergência',
        techniqueUsed: 'Técnica utilizada',
        proportion: 'Via de acesso',
      },
      replaceDataBy: {
        replaceDataByAnotherField: 'Substituir dado de um campo pelo dado de outro campo',
        numberProviderGuide: 'Nº guia no prestador',
        numberMainGuide: 'Número da guia principal',
        guideNumberSetByOperator: 'Número da guia atribuído pela operadora',
        solicitationGuideNumberHospitalization: 'Nº guia de solicitação de internação',
        qtyZeros: 'Qtd. de zeros',
      },
      cooperativeDeadline: {
        sectionTitle: 'Prazo de envio à cooperativa',
        enabled: 'Ativar notificação de prazo cooperativa',
        billingFrequencyDays: 'Frequência de faturamento (dias)',
        notifyAfterDays: 'Notificar a partir de (dias)',
        invalidDays: 'Notificar a partir de deve ser menor que frequência de faturamento',
      },
      statusDeadline: {
        sectionTitle: 'Prazo de permanência no status',
        enabled: 'Habilitar notificação de prazo de permanência no status',
        maxDays: 'Dias máximos no mesmo status',
        invalidDays: 'O prazo deve ser maior que 0',
        perStatusTitle: 'Prazos específicos por status',
        perStatusHelper: 'Defina um prazo diferente para status específicos. Eles têm prioridade sobre o prazo global.',
        perStatusHelperGlobalOn: 'Status sem prazo específico seguem o prazo global de {days} dias.',
        perStatusHelperGlobalOff: 'O prazo global está desligado. Status com prazo específico continuam sendo acompanhados.',
        perStatusEmpty: 'Nenhum status com prazo específico. Todos seguem o prazo global.',
        addStatusOverride: 'Adicionar status específico',
        perStatusDaysLabel: 'dias',
        perStatusDaysPlaceholder: 'Segue o global',
        chipTracked: 'Acompanhando · {days} dias',
        chipMuted: 'Silenciado',
        muteAction: 'Silenciar',
        clearAction: 'Remover',
        clearTooltip: 'Remover — voltar a seguir o prazo global',
        muteTooltip: 'Silenciado: nunca notifica neste status, mesmo com o prazo global ligado.',
        inheritTooltip: 'Sem prazo específico: segue o prazo global.',
        trackedTooltip: 'Acompanhando: notifica após {days} dias neste status, mesmo com o prazo global desligado.',
        perStatusInvalid: 'Informe um número inteiro maior ou igual a 0.',
        infoTooltip: 'Valor maior que 0: acompanha. Valor 0: silenciado. Sem valor: segue o global.',
      },
      allowOverrideExecutant: 'Permitir que seja alterado o executante no xml do evento',
      configRangeGuideErrorTitle: 'Erro ao Gerar Guia',
      configRangeBatchGuidesErrorTitle: 'Erro ao Gerar Guia(s): ',
      configRangeGuideErrorInfo: 'Um ou mais campos dos dados adicionais com limites de mínimo e máximo definidos pelo convênio não foram preenchidos corretamente',
      configRangeXmlGuideTitleInfo: 'Ative os campos abaixo para definir os limites mínimo e máximo nos Dados Adicionais dos Eventos (Guia e XML). O campo será preenchido com zeros à esquerda, conforme a quantidade máxima definida. (se for um campo de apenas dígitos)',
      enableNumberGuideRangeLabel: 'Número da Guia do Prestador',
      enableInsuranceWalletLabel: 'Carteira do Convênio',
      enablePasswordLabel: 'Senha',
      enableNumberGuideRangeDescription: 'Os limites definidos serão usados nos campos de Númerno da Guia nos Dados Adicionais do Evento, XML e Guia',
      setValueZero: 'Zerar valores dos procedimentos',
      daysMedicalReturn: 'Quantidade de dias para considerar um evento como retorno',
      enableMedicalReturn: 'Habilitar identificação de retorno',
      padSequenceInNameXML: 'Quantidade de dígitos no número sequencial.',
      nameXML: 'Padrão de nome do XML',
      notChangeReducaoAcrescimo: 'Não alterar o fator de redução ou acréscimo no xml.',
      useFactorByAccomodationAndEmergencyExceptInOutpatient: 'Utilizar fator de redução ou acréscimo com base na acomodação e emergência, exceto quando for ambulatorial.',
      xmlEncoding: 'Codificação do xml',
      autoBatchMaxEvents: 'Máximo de eventos por lote',
      monthQuantityOnAutoBatchByMonthYear: 'Qtd. de competências por lote automático',
      monthQuantityOnAutoBatchByMonthYearHint: 'Ex: 2 competências irão cobrir eventos do mês do lote automático criado e do mês anterior',
      xmlTag: 'Selecionar tag do xml',
      numeroGuiaOperadoraPadStart: 'Definir o número de dígitos no número da guia na operadora',
      numeroGuiaOirgemPadStartInAppeal: 'Definir o número de dígitos no número da guia de origem (Recurso)',
      downloadType: 'Tipo padrão de download de xml',
      replaceNumberProviderGuideByPassword: 'Substituir número da guia pela senha selecionando quantidade de dígitos',
      amountDigitsToChangePassword: 'Quantidade de dígitos da senha para substituir o número da guia',
      allowRequester: 'Exibir solicitante no evento',
      showTypePersonInBatch: 'Exibir tipo de pessoa no lote',
    },
    downloadType: {
      XML: 'xml',
      ZIP: 'zip',
    },
    type: 'Tipo',
    versionXML: 'Versão do XML',
    registerANS: 'Registro ANS',
    begin: 'início',
    actual: '∞',
    to: 'até',
    addNegotiation: 'Adicionar negociação',
    cbhpm: 'CBHPM',
    insuranceName: 'Nome do convênio',
    limitToReceived: 'Limite para receber (dias)',
    limitToSendGuide: 'Limite para enviar guia/XML (dias)',
    limitToSendResource: 'Limite para enviar recurso (dias)',
    useCBHPM: 'Utilizar Tabela?',
    isParticular: 'Convênio particular?',
    isParticularDesc: ' (Acomodação nem emergência afetam os valores quando é particular)',
    proportion: 'Proporção(%)',
    ports: 'Portes',
    port: 'Porte ',
    portsValues: 'Valores dos portes: ',
    portsCodesDefault: 'Códigos equivalentes a cada porte anestésico (padrão — usado como fallback para qualquer tipo de evento e qualquer acomodação): ',
    portsCodes: 'Códigos equivalentes a cada porte anestésico: ',
    portsCodesByEventType: 'Códigos equivalentes a cada porte anestésico por tipo de evento: ',
    anestheticsCodesHelp: 'Ao gerar a guia, o código de cada porte é escolhido do mais específico para o mais genérico: primeiro o código cadastrado para a acomodação do evento; se não houver, o cadastrado para o tipo de evento; e, por fim, o código padrão, usado como fallback para qualquer tipo de evento e qualquer acomodação.',
    anestheticsCodesTierDefault: 'Padrão',
    anestheticsCodesTierByEventType: 'Por tipo de evento',
    anestheticsCodesTierByAccommodation: 'Por acomodação',
    sendGuia: 'Tem envio de guia/XML?',
    useSpecialCode: 'Utilizar códigos especiais?',
    clickToAddProcedure: 'Clique aqui para adicionar procedimento',
    useCustomCodes: 'Utilizar códigos customizados?',
    hasProceduresToAddCBHPM: 'Adicionar novos procedimentos à CBHPM',
    addProcedure: 'Adicionar procedimento',
    addProcedureCustom: 'Adicionar procedimento customizado',
    addProcedureToCBHPM: 'Adicionar procedimento à CBHPM',
    attInsurance: 'Atualizar convênio',
    addInsurance: 'Adicionar convênio',
    negotiations: 'Negociações',
    startVigencia: 'Início da vigência',
    endVigencia: 'Fim da vigência',
    startVigenciaAlert: 'Não é necessário definir uma data de vigência para a primeira negociação',
    alerts: {
      alertToCreateNewNegotiation: 'Crie uma nova vigência para editar',
      alertToCreateNewNegotiationBody: 'Não é possível editar uma negociação que já iniciou a vigência, somente negociações futuras',
      alertNegotiationCantRemove: 'Não é possível remover essa negociação',
      alertNegotiationInvalid: 'Negociação inválida',
      alertEmptyNegotiation: 'É necessário selecionar uma tabela ou adicionar procedimentos customizados',
      procedureAlreadyInCBHPM: 'Esse procedimento já está na CBHPM selecionada',
      alertEmptyPackageProcedures: 'Todos os pacotes devem conter pelo menos 1 procedimento',
      alertEmptyBillingPerHourProcedures: 'Todos os grupos de faturamento por hora devem conter pelo menos 1 procedimento',
      alertHospitalOverridesConflict: 'Especializações por hospital em conflito no fator "{factor}": o hospital "{hospital}" aparece em mais de uma especialização. Cada hospital pode estar em apenas uma especialização do mesmo fator.',
      alertParticipativeExecutantConflict: 'Co-participativo recebido pelo executante em conflito: o hospital "{hospital}" aparece em mais de uma entrada. Cada hospital pode estar em apenas uma entrada.',
    },
    negotiationOnlyReadCreateNew: 'Negociação apenas para visualização. Para editar os valores crie outra negociação.É possível editar uma negociação que ainda não iniciou sua vigência',
    importProcedures: 'Importar procedimentos (.xls)',
    currencyFormatLabel: 'Formato numérico da planilha',
    exportProcedures: 'Exportar procedimentos (.xls)',
    portAnestheticZero: 'Porte anestésico 0 (Costuma ser o mesmo que o porte anestésico 3)',
    portAnesthetic: 'Anestésico',
    porteAnesthetic0: 'Porte anestésico 0',
    showAllPortes: 'Mostrar todos os portes',
    customZero: 'Customizar porte anestésico 0',
    canEditProcedureCode: 'Agrupar procedimentos por um código customizado com base no porte?',
    isNotValued: 'Eventos não faturáveis',
    isNotValuedDesc: ' (sem valor)',
    isNotValuedInfo: '* Ao ativar essa opção os eventos deste convênio não serão inclusos no faturamento',
    negotiationNotValuedPreConfigInfo: '* As negociações são para configuração dos valores do convênio. Como a opção de eventos não faturáveis está habilitada, foi pré configurado a tabela CBHPM mais recente. A configuração dos valores deve estar correta se for desejável ter o dado correto de quanto a empresa teria produzido para este convênio.',
    isNotValuedNegotiationConfig: 'Configurar as negociações',
    addresses: 'Endereços',
    addressName: 'Nome do endereço',
    confirmRemoveAddress: 'Confirmar remoção do endereço',
    addAddress: 'Adicionar endereço',
    customFields: 'Campos Customizados',
    nocustomFieldsAssociatedWithHealthInsurance: 'Não há Campos Customizados associados ao convênio',
    userCustomDefault: 'Tipo de valoração padrão ao adicionar um procedimento',
    hasEvents: 'Este convênio deve aparecer no lançamento de eventos?',
    hasEventsInfo: '* Caso não queira que esse convênio apareça no lançamento de eventos, desative essa opção',
    configFinancial: 'Configurações de repasse',
    payer: 'Pagador (Tomador)',
    customProportionsOnProcedures: 'Vias de acesso customizadas',
    enableCustomProportionsOnProcedures: 'Habilitar vias de acesso customizadas',

    enableCustomProportionsNamesForGuides: 'Habilitar nomes customizados para vias de acesso nas guias',
    configCustomProportionsNamesForGuides: 'Configurar Nomes de Vias de Acesso',

    enableCustomTechniqueUsedNamesForGuides: 'Habilitar nomes customizados para técnicas utilizadas nas guias',
    configCustomTechniqueUsedNamesForGuides: 'Configurar Nomes de Técnicas',

    addCustomProportionsOnProcedures: 'Adicionar via de acesso customizada',
    eventTypeProportionConfig: 'Configurações específicas da proporção por tipo de evento',
    eventTypeProportionConfigHint: 'Ao editar os valores por tipo de evento, irá sobrescrever a proporção customizada acima',
    enableCustomProportionsForEventType: 'Habilitar proporções customizadas de {eventType}',

    sites: 'Sites',
    siteName: 'Site',
    siteUsername: 'Usuário/Login',
    sitePassword: 'Senha',
    addSite: 'Adicionar site',
    goToScheduleCore: 'Ir para o CoRE',
    goToScheduleCoreLabel: 'Ao ativar esta flag, os valores dos procedimentos serão acrescentados ao CoRE',
  },
  ocr: {
    selectImg: 'Selecione a imagem',
    loadOcr: 'Carregar Ocr',
    reloadMatriz: 'Recarregar matriz',
    drawAll: 'Desenhar tudo',
    selectMatriz: 'Selecionar matriz',
    tryMatchValues: 'Encontrar valores',
    discoverMatriz: 'Encontrar matriz',
    clearAlerts: 'Limpar alertas',
    healthInsuranceName: 'Convênio',
    eventOcrCommunicationId: 'Id do eventOcrCommunication',
    devInfo: 'Dev Info',
    error: {
      cloneEmptyId: 'Id não encontrado',
      cloneNotFound: 'Não encontrado o item para clonar',
      eventOcrCommunication: 'Não encontrado OcrCommunication'
    },
    cloneAlert: 'Os dados atuais serão substituídos',
    search: 'Buscar',
    cloneFromId: 'Id para clonar',
    clone: 'Clonar',
    areaName: 'Nome',
    areaMatch: 'Match',
    showOnlyMatched: 'Mostrar apenas matched',
    opacityOcr: 'Ocr',
    opacityAreas: 'Áreas'
  },
  anesthetist: {
    companyConfig: 'Configurações da empresa'
  },
  ProcedureType: {
    KOVERRIDEINDICATOR: 'Especial',
    KOVERRIDEPORTE: 'Especial',
    KOVERRIDE: 'Especial',
    KCUSTOM: 'Customizado',
    KCBHPM: 'CBHPM',
  },
  ProcedureBillingType: {
    BILLABLE: 'Faturável',
    NOT_BILLABLE: 'Não faturável',
    ONLY_MAIN_ACTOR: 'Faturável somente para o ator principal',
  },
  procedureTypeOverride: {
    KOVERRIDE: 'Valor',
    KOVERRIDEPORTE: 'Porte',
    KOVERRIDEINDICATOR: 'Indicador',
  },
  TaxType: {
    TAX: 'Imposto',
    FEE: 'Taxas diversas'
  },
  eventAdditionalData: {
    specialCoverage: 'Cobertura especial',
    numberProtocol: 'Número do protocolo',
    expenses: 'Taxas/despesas',
    addExpensesTitle: 'Adicione as taxas/despesas',
    emptyExpenses: 'Nenhuma taxa/despesa selecionada',
    name: 'Nome',
    taxOrExpens: 'Taxas ou despesas',
    addTaxOrExpense: 'Adicionar taxa/despesa',
    replaceNumberProviderGuide: 'Substituir número da guia no prestador',
    addExpense: 'Adicionar despesa',
    endTime: 'Hora de fim',
    startTime: 'Hora de início',
    functionAuthorizationNumber: 'Nº autorização de funcionamento',
    manufacturerRefCode: 'Referência do material no fabricante',
    anvisaRegister: 'Registro ANVISA do material',
    reductOrAcresc: 'Fator de redução/acréscimo',
    description: 'Descrição',
    totalValue: 'Valor total',
    unityValue: 'Valor unitário',
    itemCode: 'Código do item',
    unityOfMeasurement: 'Unidade de medida',
    amountRealized: 'Quantidade realizada',
    tableCode: 'Código da tabela',
    realizedDate: 'Data da execução',
    expenseCode: 'Código despesa',
    otherExpenses: 'Outras despesas',
    guide: 'Guia',
    record: 'Ficha',
    rgo: 'RGO ',
    term: 'Termo',
    apa: 'APA',
    medicalRecord: 'Prontuário',
    hospitalizationForm: 'Ficha de Internação',
    networkCharter: 'Carta de Rede',
    other: 'Outro',
    '3AFile': '3A',

    tradeName: 'Razão social',
    number: 'Número',
    street: 'Rua',
    city: 'Cidade',
    complement: 'Complemento',
    codigoIBGEMunicipio: 'Código IBGE município',
    country: 'País',
    state: 'Estado',
    zipcode: 'CEP',
    subtitle: 'Legenda: ',
    warning: {
      true: 'Pode ser alterado',
      false: 'Não pode ser alterado',
    },
    typeEvent: 'Tipo',
    mandatoryCantChange: 'Obrigatório, não pode ser alterado',
    mandatory: 'Obrigatório',
    notMandatory: 'Não obrigatório',
    anesthetist: 'Anestesista',
    secondaryAnesthetist: 'Segundo anestesista',
    resident: 'Residente',
    procedures: 'Procedimentos',
    hospital: 'Hospital',
    surgeon: 'Cirurgião',
    dtProcedure: 'Data do procedimento',
    accommodation: 'Acomodação',
    healthInsurance: 'Convênio',
    patient: 'Paciente',
    type: 'Tipo do evento. Ex: Consulta, SP/SADT e Honorário',
    grauPart: 'Grau de participação',
    crm: 'CRM',
    crmState: 'Estado do CRM',
    cbo: 'Especialidade / Código CBO',
    cpf: 'CPF',
    cnpj: 'CNPJ',
    cnes: 'Código CNES',
    anesthesiaStart: 'Horário do início da anestesia',
    anesthesiaEnd: 'Horário do fim da anestesia',
    empty: 'Vazio',
    typeANumber: 'Digite um número correspondente: ',
    typeALetter: 'Digite uma letra correspondente: ',
    aboutReasonFinishAttendiment: ' 11 Alta Curado\n 12 Alta Melhorado\n 14 Alta a pedido\n 15 Alta com previsão de retorno para acompanhamento do paciente\n 16 Alta por Evasão\n 17 Alta da Puérpera e recém-nascido\n 18 Alta por Outros motivos\n 21 Permanencia por características próprias da doença \n 22 Permanencia por Intercorrência\n 23 Permanencia por impossibilidade sócio-familiar \n 24 permanencia por Processo de doação de órgãos, tecidos e células - doador vivo\n 25 Permanencia por Processo de doação de órgãos, tecidos e células - doador morto\n 26 Permanencia por mudança de procedimento\n 27 Permanencia por re-operação\n 28 Permanencia por outros motivos\n 31 Transferido para outro estabelecimento\n 32 Transferencia para internação domiciliar\n 41 Óbito com declaração de óbito fornecida pelo médico assistente\n 42 Óbito com declaração de Óbito fornecida pelo Instituto Médico Legal - IML\n 43 Óbito com declaração de Óbito fornecida pelo Serviço de Verificação de Óbito - SVO. \n 51 ENCERRAMENTO ADMINISTRATIVO\n 61 Alta mãe/puerpera e do recem nascido\n 62 Alta mãe/puerpera e permanencia do recem-nascido\n 63 Alta mãe/puerpera e obito do recem-nascido\n 64 Alta mãe/puerpera com obito fetal\n 65 Óbito da gestante e do concepto\n 66 Óbito da mãe/puerpera e alta do recem-nascido \n 67 Obito da mae/puerpera e permanencia do recem nascido',
    aboutRNType: 'S - Sim \n N - Não',
    aboutConsultType: '1 - Primeira\n2 - Seguimento\n3 - Pré-Natal\n4 - Por encaminhamento',
    aboutAttendimentType: '01 - Remoção\n02 - Pequena Cirurgia\n03 - Terapias\n04 - Consulta\n05 - Exames (englobando exame radiológico)\n06 - Atendimento Domiciliar\n07 - Internação\n08 - Quimioterapia\n09 - Radioterapia\n10 - Terapia Renal Substitutiva (TRS)\n11 - Pronto Socorro\n12 - Ocupacional - Inativado na versão 3.01.00\n13 - Pequenos atendimentos\n14 - Admissional\n15 - Demissional\n16 - Periódico\n17 - Retorno ao trabalho\n18 - Mudança de função\n* Incluidos na versão 3.01.00 * \n14 - Saúde Ocupacional - Admissional\n15 - Saúde Ocupacional - Demissional\n16 - Saúde Ocupacional - Periódico\n17 - Saúde Ocupacional - Retorno ao trabalho\n18 - Saúde Ocupacional - Mudança de função\n19 - Saúde Ocupacional - Promoção a saúde\n20 - Saúde Ocupacional - Beneficiário novo\n21 - Saúde Ocupacional - Assistência a demitidos',
    aboutIndicationAccident: '0 - Trabalho\n1 - Trânsito\n2 - Outros Acidentes\n9 - Não Acidentes',
    codeProcedureConsult: 'Código do procedimento',
    valueProcedureConsult: 'Valor do procedimento',
    consult: 'Consulta',
    registerANS: 'Registro ANS',
    numberProviderGuide: 'Nº guia no prestador',
    numberMainGuide: 'Número da guia principal',
    authorizationDate: 'Data da autorização',
    password: 'Senha',
    passwordExpirationDate: 'Data de validade da senha',
    guideNumberSetByOperator: 'Número da guia atribuído pela operadora',
    codeProviderInOperator: 'Código do prestador na operadora',
    solicitationGuideNumberHospitalization: 'Nº da guia de solicitação de serviço',
    numberWallet: 'Número da Carteira',
    walletExpirationDate: 'Data de validade da carteira',
    healthCard: 'Cartão Nacional de Saúde',
    attendanceRN: 'Atendimento a RN',
    solicitationData: 'Dados da solicitação',
    solicitationDate: 'Data da Solicitação',
    clinicIndication: 'Indicação Clínica',
    attendanceData: 'Dados do atendimento',
    attendimentType: 'Tipo de atendimento',
    reasonForLeavingSADTGuide: 'Tipo saída na guia SP/SADT',
    reasonForLeavingConsultationGuide: 'Tipo saída na guia de consulta',
    accidenteIndication: 'Indicação de Acidente (acidente ou doença relacionada)',
    consultType: 'Tipo de Consulta',
    reasonToFinishAttendiment: 'Motivo de Encerramento do Atendimento',
    totals: 'Totais',
    totalProcedures: 'Total de procedimentos (R$)',
    totalTaxes: 'Total de taxas e aluguéis (R$)',
    totalDayly: 'Total de diárias (R$)',
    totalMaterials: 'Total de materiais (R$)',
    totalOPME: 'Total de OPME (R$)',
    totalDrugs: 'Total de medicamentos (R$)',
    totalGasesMedicinals: 'Total de gases medicinais (R$)',
    total: 'Total geral (R$)',
    totalFees: 'Total honorários (R$)',
    startDateBilling: 'Data do início do faturamento',
    endDateBilling: 'Data do fim do faturamento',
    emissionDate: 'Data de emissão',
    emissionDateHint: 'Usado na(o) guia/XML da honorários',
    attendanceDateConsult: 'Data do atendimento (consulta)',
    attendanceDateConsultHint: 'Usado na(o) guia/XML de consulta',
    table: 'Código da tabela utilizada'
  },
  xmlError: {
    healthCard: 'Cartão nacional de saúde',
    dtAppealed: 'Data do recurso',
    numberGuideAppealByOperator: 'Número da guia de recurso de glosas atribuído pela operadora',
    idProc: 'Código do procedimento',
    cutReasonCode: 'Motivo de glosa',
    totalAppealed: 'Valor total recursado',
    reasonProvider: 'Justificativa prestador',
    reasonForLeavingSADTGuide: 'Tipo saída na guia SP/SADT',
    reasonForLeavingConsultationGuide: 'Tipo saída na guia de consulta',
    address: 'Endereço',
    city: 'Cidade',
    codigoIBGEMunicipio: 'Codigo IBGE Municipio',
    complement: 'Complemento',
    country: 'Cidade',
    number: 'Número',
    state: 'Estado',
    street: 'Rua',
    zipcode: 'CEP',
    passwordExpirationDate: 'Data de expiração da senha',
    errorDownload: 'Houve um erro ao gerar o xml',
    errorDownloadTitle: 'XML não gerado',
    company: 'Empresa',
    healthInsurance: 'Convênio',
    cnpj: 'CNPJ',
    cnes: 'Código cnes',
    tradeName: 'Razão social',
    versionXML: 'Versão do XML',
    registerANS: 'Registro ANS',
    crm: 'CRM',
    crmState: 'Estado do CRM',
    cpf: 'CPF',
    cbo: 'Especialidade / Código CBO',
    numberProviderGuide: 'Nº guia no prestador',
    solicitationGuideNumberHospitalization: 'Nº guia de solicitação de internação',
    password: 'Senha',
    guideNumberSetByOperator: 'Número da guia atribuído pela operadora',
    codeProviderInOperator: 'Código do prestador na operadora/CNPJ',
    numberWallet: 'Número da carteira',
    attendanceRN: 'Atendimento a RN',
    startDateBilling: 'Data do início do faturamento',
    endDateBilling: 'Data do fim do faturamento',
    totalFees: 'Valor total dos honorários',
    authorizationDate: 'Data da autorização',
    clinicIndication: 'Indicação clínica',
    total: 'Valor total',
    attendanceDateConsult: 'Data do atendimento',
    codeProcedureConsult: 'Código do procedimento da consulta',
    valueProcedureConsult: 'Valor cobrado na consulta',
    accidenteIndication: 'Indicação de acidente',
    consultType: 'Tipo de consulta',
    anesthesiaStart: 'Horário do início da anestesia',
    anesthesiaEnd: 'Horário do fim da anestesia',
    healthInsuranceWrong: 'Convênio diferente do escolhido no lote'
  },
  xml: {
    appealedProcedures: 'Procedimentos do recurso',
    appeal: 'Recurso',
    spsadt: 'SP/SADT',
    fees: 'Honorario',
    xmlFee: 'XML Honorário',
    Successful: 'Sucesso',
    Creating: 'Processando',
    Error: 'Erro',
    createAppeal: 'Recurso',
    createFees: 'Honorario',
    createSADT: 'SP/SADT',
    createConsultation: 'Consulta',
    mandatoryData: 'Dados obrigatórios para gerar o xml: ',
    additionalData: 'Dados adicionais nos eventos',
    events: 'Eventos',
    guide: 'Guia'
  },
  batch: {
    PDF: 'PDF',
    PDFs: 'PDF\'s',
    PDFFiles: 'Arquivos PDF\'s',
    eventsResume: 'Resumo dos eventos',
    eventsResumeMinimized: 'Resumo minimizado dos eventos',
    batchResume: 'Resumo do lote',
    batchGuides: 'Guias do Lote',
    batchAttachments: 'Anexos do Lote',
    selectBathToChange: 'Selecione o lote para troca',
    confirmXmlAcceptance: 'Este é o xml que foi aceito?',
    statusName: 'Status do lote',
    status: {
      OPEN: 'Aberto',
      CLOSED: 'Fechado',
      ON_GOING: 'Em edição',
      ACCEPTED: 'Aceito',
    },
    statusInfo: {
      OPEN: 'Lote não está fechado e nem foi enviado. Eventos podem ser adicionados e removidos',
      CLOSED: 'Lote precisa ser enviado. Eventos não podem ser adicionados',
      ON_GOING: 'Eventos estão sendo conferidos e editados para envio em breve. Eventos não podem ser adicionados',
      ACCEPTED: 'Lote fechado, enviado e aceito no convênio',
    },
    confirmEventRemove: 'Tem certeza que deseja remover esse evento desse lote?',
    typePerson: 'Tipo de pessoa',
    creatingXml: 'Criando xml',
    eventRemoved: 'Evento removido do lote',
    protocol: 'Protocolo',
    selectType: 'Selecione o tipo para gerar as guias',
    createXml: 'Validar e criar XML',
    onlyValidate: 'Apenas validar',
    isClosed: 'Lote fechado?',
    isSend: 'Lote aceito?',
    countEvents: 'Qtd eventos',
    isSendTooltip: 'Os eventos serão alterados para aguardando pagamento, não é possível desmarcar se houver xml gerado',
    isClosedTooltip: 'Não será possível adicionar novos eventos ao lote',
    resultBatchActionTitle: 'Eventos alterados',
    changeStatusCount: {
      ok: 'Sucesso',
      error: 'Erros',
      warning: 'Não alterados'
    },
    warning: {
      noBatchSelected: 'Nenhum lote selecionado',
      batchSelectedIsClosed: 'O lote selecionado está fechado',
      maxEvents: 'Máximo de eventos no lote',
      typeMismatch: 'O tipo do evento é diferente do tipo do lote',
      insuranceMismatch: 'O convênio do evento é diferente do convênio do lote',
      codeExists: 'Esse número de lote já existe',
      sequencialTransacaoExists: 'Esse número de sequencial transação do recurso já existe',
      noHealthInsuranceIdOnBatch: 'Não há convênio vinculado ao lote, entre no lote e selecione um convênio',
    },
    batchAddToEvents: 'Lote adicionado nos eventos',
    deleteBatch: 'Deletar lote',
    confirmDelete: 'Confirmar exclusão do lote',
    confirmDeleteText: 'Tem certeza que deseja deletar este lote? Esta ação não pode ser desfeita.',
    deleteSuccess: 'Lote deletado com sucesso',
    deleteError: 'Erro ao deletar lote',
    deleteDisabled: {
      isNew: 'Não é possível deletar um lote que ainda não foi salvo',
      hasEvents: 'Não é possível deletar um lote que possui eventos',
      hasCobrancas: 'Não é possível deletar um lote que possui cobranças',
      statusNotOpen: 'Só é possível deletar lotes com status ABERTO'
    },
  },
  newTicket: {
    title: 'Novo Ticket'
  },
  company: {
    billingType: 'Tipo de faturamento',
    systemLine: 'Sistema',
    systemLineHint: 'Fora do sistema escolhido, o usuário da empresa vê um aviso com o endereço certo. Super admin não é bloqueado.',
    systemLineFollowsMatriz: 'Filial que não é cooperado cliente segue o sistema da matriz; o valor daqui é ignorado.',
    systemLines: {
      BOTH: 'Ambos',
      MED: 'Apenas med',
      MAIN: 'Apenas main',
    },
    ocrCredits: 'Créditos OCR',
    controlFlags: 'Flags de controle da empresa: ',
    type: 'Tipo de cadastro',
    agendaDisplay: 'Agrupamento da agenda',
    types: {
      personal: 'Pessoa física',
      company: 'Pessoa jurídica'
    },
    flags: {
      goToAwaitingCheckEvents: 'Ao salvar envia o evento para Aguardando Conferência',
      updateStartAndEndAnesthetistWithDtProcedure: 'Atualizar início e fim de anestesia quando alterar a data do procedimento',
      importSpreadsheetJustDoctor: 'Importar procedimentos da planilha do Just Doctor',
      importSpreadsheetHospitals: 'Importar eventos da planilha própria dos hospitais',
      hiddenPricesResidente: 'Esconder valores do residente',
      isFilialClient: 'Cooperado Cliente',
      filialHiddenMatrizData: 'Não mostrar dados da matriz',
      automaticNumberGuide: 'Gerar número da guia automaticamente',
      allowAlphanumericInNumberProviderGuide: 'Permitir alfanumérico no número da guia do prestador',
      isPersonalProduction: 'Empresa de produção pessoal',
      blockEventIfNoNumberGuide: 'Bloquear criação de eventos se não tiver número da guia',
      usePicker: 'Utilizar picker de data e hora',
      hideProcedureOnAdditional: 'Não mostrar procedimento e etc nos dados adicionais',
      repeatHeadersOnEventsReport: 'Repetir cabeçalho nos Relatórios de Eventos',
      onlyHourOnEventBeginEnd: 'Apenas horário no inicio e fim do evento',
      notUsePickerNewEvent: 'Não utilizar picker na criação de evento',
      changeStatusOnBatchClose: 'Alterar estados dos eventos ao fechar o lote(bloquear edição de eventos)',
      receiveOnlyOnCobranca: 'Recebimento apenas na cobrança(Não permitido na tela de eventos)',
      notValuedEvents: 'Eventos não valorados',
      receivedOnlyOnCobranca: 'Receber apenas através de cobrança',
      notValidateUniqueGuideNumber: 'Não validar unicidade de número da guia',
      validateDuplicateEventByPatientDate: 'Validar evento duplicado por paciente e data',
      validateDuplicateEventByPatientDateHint: 'Bloqueia o cadastro de eventos com o mesmo paciente e data/hora exatos. Afeta tanto o cadastro manual quanto a importação por planilha.',
      notUpdateConsultProcInAdditionalData: 'Não atualizar o procedimento nos dados adicionais de consulta',
      notChangeProcedureProportionInReportEvents: 'Não permitir alterar a via de acesso na tela de relatório de eventos',
      hasThirdAnesthetist: 'Tem terceiro anestesista',
      contractValuesOnDashboard: 'Valores de Contratos no Dashboard',
      filialCanManipulateEvent: 'Pode manipular eventos',
      flagEventsHadPendingStatus: 'Marcar eventos ao passar pelo status Pendente',
      showEventResumeDialog: 'Mostrar resumo após salvar evento',
      enableSaveAndCheckEvent: 'Habilitar botão "Salvar e Conferir" no lançamento de eventos',
      enableAutomaticAttendanceFee: 'Habilitar cálculo automático do co-participativo',
      receiveAttendanceFeeOnEventCreate: 'Perguntar se deseja receber Co-participativo ao salvar evento',
      enableObservationInsuranceMatrizAndFilial: 'Habilitar Observações para Matriz e Filial',
      enableCoreSpreadSheetByAnesthetist: 'Habilitar Exportação do CoRE por Anestesista',
      enableCoreScheduleProduction: 'Habilitar Produção na Escala do CoRE',
      showReportScheduleHeadersOnlyOnTop: 'Mostrar Cabeçalhos do Relatório de Escala somente na parte superior',
      useScheduleConfigAsHospital: 'Utilizar Configuração da Escala como Hospital',
      disableAutoFillProcedureDate: 'Desabilitar preenchimento automático da data do procedimento',
      enableTransferDistributionPreview: 'Habilitar "Prévia repasse" nas ações do evento para quem tem o perfil de leitura do financeiro (exceto eventos da cooperativa nas filiais)',
    },
    configs: {
      surgeonMandatory: 'Cirurgião obrigatório em:',
      surgeonVisible: 'Cirurgião visível em:',
      phonoaudiologistVisible: 'Fonoaudiólogo visível em:',
      surgeonOptLabel: 'Opções de cigurgião',
      emailUserTransferInvoice: 'Email para receber notas de transferências',
      multipleAttachmentsOneTap: 'Múltiplos Anexos (1-Tap)',
      enableMultipleAttachmentsOneTap: 'Habilitar múltiplos anexos no 1-Tap',
    },
    functionsEnabled: {
      blueAccount: 'Conta Azul',
      forms: 'Formulários',
      financial: 'Financeiro',
      schedules: 'Escala',
      customProceduresUsingPorte: 'Procedimento customizado com porte(funcionalidade beta)',
      transactions: 'Transações, nova forma de recebimento',
      insurancePricesImport: 'Importação de preços por convênio (planilha)'
    },
    notificationConfig: {
      title: 'Notificações',
      enabled: 'Habilitar notificações para esta empresa',
      deadlineEnabled: 'Notificar prazos de eventos',
      deadlineEnabledHint: 'Envia notificações quando eventos estão próximos dos prazos configurados no convênio (envio de guia, envio de recurso e recebimento).',
      warningDaysBefore: 'Dias de antecedência',
      warningDaysBeforeHint: 'Notificar quando o prazo estiver a N dias de vencer.',
      recipientUserIds: 'Usuários que receberão as notificações',
      recipientUserIdsHint: 'Selecione os usuários da empresa que devem receber as notificações de prazo.',
      noBatchEnabled: 'Notificar eventos sem lote',
      noBatchEnabledHint: 'Avisa quando um evento está sem lote há mais de N dias.',
      daysWithoutBatch: 'Dias sem lote',
      daysWithoutBatchHint: 'Notificar quando o evento estiver sem lote há este número de dias.',
      maxEventAgeDays: 'Idade máxima do evento',
      maxEventAgeDaysHint: 'Eventos com data de procedimento anterior a este número de dias não serão verificados (limita o custo de leitura).',
      pendingEnabled: 'Notificar eventos marcados como pendente',
      pendingEnabledHint: 'Envia notificação imediata quando um evento é marcado como pendente.',
      noBatchRecipientUserIds: 'Usuários que receberão as notificações de eventos sem lote',
      noBatchRecipientUserIdsHint: 'Selecione os usuários da empresa que devem receber as notificações de eventos sem lote.',
      pendingRecipientUserIds: 'Usuários que receberão as notificações de eventos pendentes',
      pendingRecipientUserIdsHint: 'Selecione os usuários da empresa que devem receber as notificações de eventos marcados como pendente.',
      cooperativeDeadlineEnabled: 'Habilitar notificação de prazo de envio à cooperativa',
      cooperativeDeadlineEnabledHint: 'Notifica os usuários selecionados após N dias do lançamento de eventos com convênios da matriz que tenham essa configuração ativada.',
      cooperativeDeadlineRecipientUserIds: 'Usuários que receberão as notificações de prazo cooperativa',
      cooperativeDeadlineRecipientUserIdsHint: 'Selecione os usuários da empresa que devem ser avisados (geralmente faturistas, admins e gestores de faturamento).',
      statusDeadlineEnabled: 'Habilitar notificação de prazo de permanência no status',
      statusDeadlineEnabledHint: 'Notifica os usuários selecionados quando eventos permanecem no mesmo status por mais dias do que o configurado no convênio.',
      statusDeadlineRecipientUserIds: 'Usuários que receberão as notificações de prazo no status',
      statusDeadlineRecipientUserIdsHint: 'Selecione os usuários da empresa que devem ser avisados quando eventos ficarem parados no mesmo status.',
      eventChangeEnabled: 'Habilitar notificação de alteração de evento',
      eventChangeEnabledHint: 'Notifica os usuários selecionados quando a cooperativa altera dados de um evento da filial.',
      eventChangeRecipientUserIds: 'Usuários que receberão as notificações de alteração de evento',
      eventChangeRecipientUserIdsHint: 'Selecione os usuários da filial que devem ser notificados quando a cooperativa modificar eventos.',
    },
    attachmentName: 'Anexo',
    attachments: 'Anexos customizados do anestesista',
    anesthetistCustomField: 'Campos customizados do anestesista',
  },
  acceptTerms: {
    acceptCookies: 'Utilizamos cookies para garantir que você tenha a melhor experiência em nosso site. Clique em OK para aceitar.',
    OK: 'OK'
  },
  menu: {
    changeSuperAdminToCompany: 'Ir para empresa',
    changeSuperAdminToAdmin: 'Ir para Admin'
  },
  auth: {
    selectProfiles: 'Selecione os perfis',
    selectProfilesMatriz: 'Selecione os perfis na Matriz'
  },
  FormInputType: {
    text: 'Texto',
    paragraph: 'Parágrafo',
    number: 'Número',
    radio: 'Escolha individual',
    checkbox: 'Escolha multipla',
    select: 'Seleção',
    date: 'Data',
    time: 'Hora',
    dateTime: 'Data e hora',
    booleanNa: 'Verdadeiro/Falso/Não se aplica',
  },
  formInput: {
    limitToResponseActive: 'Tem limite para responder?',
    limitToResponseString: 'Limite para responder(horas)',
    type: 'Tipo',
    other: 'Mostrar "Outra..."',
    otherText: 'Outra...',
    otherInputLabel: '(Outra)',
    addOption: 'Add Opção',
    addSection: 'Add Seção',
    confirmRemoveSection: 'Tem certeza que deseja remover essa seção e todos os itens dessa seção?',
    confirmRemoveInput: 'Tem certeza que deseja remover essa questão',
    mandatory: 'Obrigatório',
    sessionName: 'Nome da seção',
    inputName: 'Nome da opção',
    inputOption: 'Opção',
    formNotFound: 'Formulário não encontrado',
    submitResponse: 'Enviar resposta',
    responseSend: 'Resposta enviada',
    responseOther: 'Outra',
    responseOtherTextField: 'Descreva',
    cancel: 'Cancelar',
    link: 'Vínculo',
    canEditResponse: 'Pode editar resposta',
    errorValidate: 'Há campos obrigatórios não preenchidos',
    errorOnWriteCall: 'Erro ao tentar gravar no banco',
    errorOnSave: 'Erro ao tentar salvar dados',
    published: 'Publicado',
    notPublished: 'Não publicado',
    restrictHospital: 'Restringir hospital',
    allowedHospitals: 'Hospitais permitidos',
    isMandatory: 'É obrigatório?',
    releasedAt: 'Publicado em:',
    isEvent: 'Associado a evento?',
    isClosed: 'Fechado?',
    warnings: {
      attentionEditCustomField: 'Editar esse campo irá impactar em todos os convênios e eventos utilizando esse campo'
    }
  },
  FormLinkType: {
    none: 'Nenhum',
    eventId: 'Id do evento',
    eventAnesthetistName: 'Nome do anestesista',
    eventPatientName: 'Nome do paciente',
    eventPatientBirthDate: 'Data de nascimento do paciente',
    eventDate: 'Data da anestesia',
    userId: 'Id do usuário',
    userName: 'Nome do usuário',
    userEmail: 'Email do usuário',
    companyId: 'Id da empresa',
    companyName: 'Nome da empresa',
    eventSurgeonName: 'Nome do Cirurgião',
    eventHospitalName: 'Nome do hospital',
  },
  formInputEjs: {
    title: '',
    notFound: 'Post Não Encontrado'
  },
  spreadsheetProcedureCode: {
    code: 'Sigla na planilha',
    codeHint: 'Como o exame aparece na coluna EXAME da planilha do hospital. Ex.: IMP, AT, PSG.',
    name: 'Descrição',
    procedure: 'Procedimento na tabela',
    idProc: 'Código',
    customIdProc: 'Código digitado',
    customIdProcHint: 'Use para procedimento que não está na tabela. Quando preenchido, vence o procedimento selecionado.',
    resolved: 'Código que será usado na importação:',
  },
  errorsImport: {
    anesthetist: 'Anestesista',
    surgeon: 'Cirurgião',
    hospital: 'Hospital',
    healthInsurance: 'Convênio',
    patient: 'Paciente',
    procedures: 'Procedimentos',
    eventNotRealized: 'Evento não realizado',
    dtProcedure: 'Data do Evento não encontrada',
    customFields: 'Campos Customizados',
    additionalData: 'Dados Adicionais',
    duplicateEvent: 'Evento duplicado (mesmo paciente e mesma data/hora)',
    duplicatePassword: 'Senha duplicada (mesmo convênio, carteirinha e senha no dia)',
  },
  pdfsMap: {
    default: {
      header: {
        title: 'Pdf Título',
        subtitle: 'Pdf Subtítulo'
      },
      content: {
        title: 'Conteúdo'
      },
    },
    scheduleOnDuty: {
      title: 'Escala Diária',
      labels: {
        periodPrefix: 'Turno',
        datePrefix: 'Escala',
        generated: 'Documento gerado em',
        publishedBy: 'Publicado por',
      }
    },
    eventResume: 'Resumo dos eventos',
  },
  protocol: {
    protocol: 'Protocolo',
    dataProtocolacao: 'Data Protocolação',
    service: 'Serviço',
    services: {
      ProducaoPessoal: 'Produção pessoal',
    },
    value: 'Valor',
    healthInsurance: 'Convênio',
    addPreEvent: 'Adicionar evento',
    patient: 'Paciente',
    numberGuide: 'Nº Guia',
    cooperado: 'Cooperado',
    hospital: 'Hospital',
    anesthetistName: 'Cooperado',
    qtd: 'Quantidade',
    company: 'Serviço',
    personalProduction: 'Produção Pessoal',
    anesthetist: 'Anestesista',
    addPreEventConclude: 'Replicar',
    qtdGuides: 'Quantidade de guias',
    emptyList: 'Lista vazia, adicione eventos abaixo',
    hints: {
      pdfView: 'Visualizar PDF',
    },
    errors: {
      null: 'Algum erro inesperado neste Protocolo.',
      guideNumberDuplicated: 'Número da guia duplicado',
      guideNumberExists: 'O Número da guia já existe',
      checkGuideNumbers: 'Verifique o número das guias',
      eventExists: 'A guia selecionada já existe no relatório'
    },
    remove: 'Excluir Protocolo',
    areYouSure: 'Você tem certeza que deseja excluir este protocolo?'
  },
  protocolPdf: {
    title: 'Protocolo',
    label: '',
    header: {
      date: 'Data Protocolação',
      createdBy: 'Criado por',
      totalValue: 'Valor total',
    },
    company: {
      nullName: 'Sem nome da cooperativa',
    },
    subheaders: {
      events: 'Detalhamento',
      resumes: 'Resumo',
      null: 'Título de Lista',
    },
    content: {
      null: 'Sem Conteúdo',
    },
    cells: {
      numberGuide: 'Guia',
      cooperated: 'Cooperado',
      insurance: 'Convênio',
      hospital: 'Hospital',
      type: 'Tipo',
      value: 'Valor',
      service: 'Serviço',
      count: 'Quantidade',
      null: 'Valor indefinido',
    }
  },
  EventType: {
    Honorario: 'Honorário',
    SPSADT: 'SP/SADT',
    Consulta: 'Consulta',
  },
  shortCuts: {
    showShortCuts: 'Mostrar atalhos',
    sistem: 'Sistema',
    history: 'Tela de histórico',
    createEvent: 'Criar novo evento',
    title: 'Atalhos',
    nextHistory: 'Próxima modificação',
    prevHistory: 'Modificação anterior',
    conclude: 'Salvar'
  },
  sequential: {
    title: 'Números sequenciais',
    btn: 'Configurar sequenciais',
    batch: 'Lote',
    eventNumberGuide: 'Guia',
    protocol: 'Protocolo',
    transfers: 'Repasse',
    cobrancas: 'Cobrança',
    userTransfers: 'Transferência (userTransfers)',
    financialItems: 'Movimento financeiro (numMov)',
    financialItemsGroups: 'Grupo de pagamento',
    recurrentPayments: 'Pagamento recorrente',
    bankReconciliation: 'Conciliação bancária',
    errors: {
      exhausted: 'Não foi possível gerar o número automaticamente. Tente de novo; se persistir, ajuste o contador em Empresa → Configurar sequenciais.',
    },
  },
  BillingActions: {
    Received: 'Receber',
    Losed: 'Perder',
    Glosado: 'Glosar',
    Discounted: 'Desconto',
    ReceivedFromOver: 'Receber do over',
    ReceivedToOver: 'Receber para over'
  },
  BillingActionsPast: {
    Received: 'Recebido',
    Losed: 'Perdido',
    Glosado: 'Glosado',
    Discounted: 'Descontado',
    ReceivedToOver: 'Recebido para over',
    ReceivedFromOver: 'Recebido do over'
  },
  tax: {
    deductionOnSkip: 'Dedução ao não reter',
    addNegotiation: 'Adicionar negociação',
    begin: 'Início',
    end: 'Fim',
    taxValue: 'Taxa',
    floor: 'Piso(valor de imposto)',
    ceil: 'Teto(valor base de cálculo)',
    deduction: 'Dedução',
    baseCalc: 'Base de cálculo',
    addBaseCalc: 'Base',
    flags: {
      deductionOnSkip: 'Dedução ao não reter imposto (INSS)',
      applyOnPF: 'Incide em PF',
      applyOnPJ: 'Incide em PJ',
      applyMonth: 'Aliquota sobre o total mensal',
      canReceiveOnOtherSource: 'Pode recolher em outra fonte',
      hasFloor: 'Tem piso mensal',
      hasCeil: 'Tem teto mensal',
      hasBaseCalc: 'Tem taxa por faixa de valor',
      hasDeduction: 'Tem dedução',
      hasDeductionDependent: 'Tem dedução por dependente',
      hasDeductionAlimony: 'Tem dedução por pensão alimentícia',
      deductionBaseIR: 'Deduz base IRRF?',
      applayOnlyOnReceiver: 'Aplicar apenas nos recebedores (não pode ser associado a convênios ou contratos)',
      doNotCollectOnPayment: 'Não recolhe taxa na despesa(Ex: imposto já recolhido no recebimento)',
    },
    deductionDependent: 'Dedução por dependente',
    applyBase: 'Base de cálculo',
    type: 'Tipo',
    identifier: 'Identificador',
    redutorIRValue: 'Redutor valor',
    redutorIRFactor: 'Redutor fator',
  },
  TaxBase: {
    Received: 'Valor Recebido',
    Repasse: 'Valor bruto do repasse',
    BaseIRRF: 'Base IRRF',
    Liquid: 'Líquido',
    LiquidValue: 'Líquido por valor',
    Custom: 'Customizado',
    ReceivedValue: 'Valor Recebido por valor',
    BeforeReceivedValue: 'Antes do valor recebido',
  },
  post: {
    name: 'Título',
    description: 'Descrição',
    published: 'Publicado',
    relatedPosts: 'Publicações relacionadas',
    date: 'Data do post',
    dateChange: 'Data da última modificação do post',
    publishers: 'Autores',
    categories: 'Categorias',
    slug: 'Slug (evite a todo custo alterar o slug depois de publicar o post)',
    sureSlugChange: 'Tem certeza que deseja alterar o slug? isso pode impactar o SEO',
    errors: {
      slugExist: 'Essa slug já existe',
      slugEmpty: 'É necessário uma slug',
    }

  },
  seo: {
    componentTitle: 'SEO',
    title: 'Título',
    description: 'Descrição',
    custom: 'Customizar',
    keyWords: 'Palavras chave (key words)',
  },
  financial: {
    defaultFactor: 'Fator padrão',
    beginAccountDate: 'Data inicial da conta',
    beginAccountValue: 'Valor inicial da conta',
    accountType: 'Tipo de conta',
    isExternal: 'Conta externa',
    paidAt: 'Pago em',
    dateCompetence: 'Data de competência',
    datePayment: 'Data de pagamento',
    // Botão de período e coluna opcional das listagens de movimentações: a data PREVISTA
    // (`dueDateIso`), ao lado de `dateCompetence` e `datePayment` (a baixa).
    dueDate: 'Data prevista',
    // Colunas opcionais das listagens de movimentações (FinancialItems / CoopFinancialItems)
    transferNumber: 'Nº Repasse',
    negotiatorCanSee: 'Liberado para visualização',
    // Coluna opcional da FinancialItems: contas bancárias das parcelas (paymentBankAccountsNames).
    paymentBankAccounts: 'Bancos dos pagamentos',
    paymentWithoutBankAccount: 'Sem banco',
    paymentBankAccountNotFound: 'Conta não encontrada',
    addMoney: 'Valor adicionado',
    addParcels: 'Adicionar parcelas',
    addSchedules: 'Adicionar escalas',
    paymentEdit: 'Editar pagamento',
    savePayment: 'Salvar pagamento',
    payments: 'Pagamentos',
    addCobrancas: 'Adicionar cobranças',
    openEvent: 'Abrir evento',
    distributionPreview: {
      title: 'Prévia da distribuição do repasse',
      buttonTooltip: 'Ver como o repasse distribuiria este evento',
      patient: 'Paciente',
      date: 'Data',
      insurance: 'Convênio',
      hospital: 'Hospital',
      company: 'Empresa',
      baseValue: 'Valor base a repassar',
      flowStandard: 'Repasse padrão',
      flowCustom: 'Repasse customizado',
      flowFromInsurance: 'convênio',
      flowFromHospital: 'hospital',
      external: 'Recebedor externo',
      revenue: 'Receita',
      participativeRevenue: 'Receita co-participativo',
      receiver: 'Recebedor',
      personType: 'Tipo',
      percent: '% efetivo',
      value: 'Valor',
      baseFirstStage: 'Base 1ª etapa',
      invoiceValue: 'Valor de nota',
      baseIR: 'Base IRRF',
      taxes: 'Impostos',
      taxesBreakdownCols: 'Impostos (detalhado)',
      columnsFilter: 'Colunas',
      liquid: 'Líquido',
      totalExpense: 'Total despesas',
      totalRevenue: 'Total receita',
      linkedTransferWarning: 'Parte das transações deste evento já está vinculada a um repasse — a prévia reflete a distribuição daquele repasse, não de um futuro.',
      taxDisclaimer: 'Impostos e líquido estimados como se fosse o primeiro repasse do mês (sem acumulado real) e com data-base de hoje.',
      noTransactions: 'Evento sem transações recebidas para distribuir. A simulação a partir dos valores calculados está fora do escopo desta prévia.',
      noEvent: 'Evento não identificado para a prévia da distribuição.',
      loadError: 'Não foi possível montar a prévia da distribuição.',
      factorOriginTitle: 'Origem do fator por participante',
      factorOriginActor: 'Participante',
      factorOriginFactor: 'Fator',
      factorOriginPercent: '% configurado',
      factorOriginSource: 'Origem',
      sourceInsuranceHospitalOverride: 'Especialização convênio+hospital',
      sourceHospital: 'Hospital',
      sourceInsurance: 'Convênio',
      sourceNone: 'Sem fator — fora da divisão',
      viaPreferential: 'preferencial do usuário',
      factorOriginDisclaimer: 'O % exibido é o configurado para o participante, antes de deduções entre fatores e do limite PF.',
      overCapInfo: 'Over fora da distribuição — a negociação do convênio não repassa o over ao profissional: o evento produziu {produced} e recebeu {received}; {overCut} ficam com a cooperativa.',
    },
    errors: {
      paymentPeriodTooManyMonths: 'A busca por data de pagamento aceita até {max} meses',
      invoiceIsMandatory: 'É obrigatório selecionar uma nota para salvar valores recebidos',
      transferActionDeniedOnLocked: 'Essa ação não pode ser feita depois da transferência ser fechada',
      receivedNotCanByNegative: 'O valor recebido não pode ser negativo',
      needEventsToExport: 'É necessário ter eventos para exportar',
      selectHealthInsuranceFirst: 'Selecione um convênio antes de buscar',
      selectFiltersFirst: 'Selecione um convênio, anestesista ou lote antes de buscar',
      needTransferLock: 'É necessário fechar o repasse',
      resumeInsuranceTaxesMismatch: 'Convênio {insurance} com configuração de impostos diferente dos demais eventos do repasse',
      resumeContractTaxesMismatch: 'Contrato com configuração de impostos diferente dos demais itens do repasse',
      revenueSettledInLockedTransfer: 'Esta receita foi abatida (desconto em folha) em um repasse fechado. Para estorná-la, reverta o repasse — a reversão desfaz o abatimento dos dois lados — e então estorne a receita.',
      itemSettledInSettlement: 'Esta movimentação foi baixada por um encontro de contas ativo. Para estorná-la, reverta o encontro de contas — a reversão desfaz as baixas dos dois lados — e então estorne a movimentação.',
      itemInLockedTransfer: 'Esta movimentação foi gerada por um repasse fechado e não pode ser excluída isoladamente. Para removê-la, reverta o repasse — a reversão exclui os pagamentos gerados e desvincula as fontes.',
      deletePaidItem: 'Esta movimentação tem pagamento realizado e não pode ser excluída. Estorne o pagamento antes de excluí-la — o estorno devolve o saldo da conta e os impostos.',
      deletePaidItemsSelected: '{n} movimentação(ões) selecionada(s) têm pagamento realizado e não podem ser excluídas. Abra cada uma, estorne o pagamento e repita a exclusão. Movimentações: {nums}',
      unpayLinkedPayment: 'Esta parcela foi baixada por outro documento (encontro de contas ou abatimento de repasse) e não pode ser estornada por aqui. Reverta o documento de origem — a reversão desfaz a baixa dos dois lados.',
      transferSameAccountPayments: 'Parcela(s) com a conta de destino como origem: {payments}.',
      transferSameAccountItemPayments: 'Movimentação {item}: parcela(s) com a conta de destino como origem: {payments}.',
      transferSameAccountField: 'A conta de origem não pode ser a conta de destino da transferência',
      statementLineTransferDestination: 'Esta linha do extrato é uma entrada na conta {account}: na transferência, {account} é a conta de DESTINO. Escolha {account} como destino e, na parcela, a conta de onde o dinheiro saiu.',
      statementLineTransferOrigin: 'Esta linha do extrato é uma saída da conta {account}: na transferência, {account} é a conta de ORIGEM da parcela, e o destino é a conta que recebeu o dinheiro.',
      recurrentCreateAfterDue: 'O dia de criar a movimentação não pode ser depois do dia de vencimento: a parcela vence no mesmo mês, e já nasceria vencida.',
      recalculateWithDeductions: 'Esta movimentação de repasse tem abatimentos (desconto em folha) já aplicados. Recalcular as taxas redistribuiria os abatimentos sem refazer as baixas nas receitas de origem. Para alterá-la, reverta o repasse — a reversão desfaz os dois lados — e refaça o fechamento.',
      resumeContractNotFound: 'Contrato não encontrado',
      resumeDivisionWithoutReceiver: 'Divisão de horas sem recebedor definido (empresa/filial ou profissional)',
      resumeRescuedLinkedTransactions: '{n} transação(ões) já vinculada(s) a este repasse por uma tentativa anterior de fechamento foram reincorporadas ao cálculo',
      resumeLinkedTransactionsOrphan: '{n} transação(ões) continuam vinculada(s) a este repasse mas o evento não está nos lotes atuais (cobrança removida do repasse ou evento desativado) — ficaram FORA do cálculo. Corrija a origem ou desvincule antes de considerar o repasse completo. Transações: {ids}',
      resumeCobrancaWithoutValues: 'Cobrança {code} sem valores neste repasse — ela não será vinculada no fechamento (verifique o intervalo de datas e os lotes dos eventos)',
      resumeCobrancaWithoutBatch: 'Cobrança {code} sem lote (batchId) — os eventos dela não podem ser carregados e ela não será vinculada no fechamento',
      saveFinancialItemsFailed: 'Falha ao gravar os pagamentos do repasse ({errorCode}). O fechamento foi abortado — refaça o fechamento: itens parciais serão removidos e regravados automaticamente',
      savePaymentsLockedFailed: '{n} pagamento(s) do repasse fechado não foram salvos ({errorCode}). Os demais podem ter sido gravados — confira a lista antes de repetir',
      savePaymentsLockedExtrasFailed: '{n} pagamento(s) foram gravados, mas o detalhamento (eventos/horas) não. NÃO feche esta tela: salve novamente para regravar o detalhamento',
      saveFinancialItemFailed: 'Falha ao gravar a movimentação ({errorCode}) — as alterações não foram salvas',
      deleteFinancialItemsFailed: 'Falha ao remover pagamentos obsoletos do repasse ({errorCode}). O fechamento foi abortado — refaça o fechamento',
      resumeHasBlockingErrors: 'Não foi possível calcular o repasse. Verifique os erros listados acima das abas.',
      accountingResumeEmpty: 'Nenhuma movimentação {personType} na listagem atual'
    },
    confirms: {
      addTransactionsOrphans: 'Adicionar a(s) {n} transações não associadas a lotes?',
      lockTransfer: 'Tem certeza que deseja fechar essa transferência?',
      lockTransferBody: 'Não será possível adicionar mais pagamentos a esse repasse',
      revertTransfer: 'Tem certeza que deseja reverter esse repasse?',
      revertTransferBody: 'O repasse voltará para o status Aberto: os pagamentos gerados serão excluídos (estornando saldos e impostos) e as fontes (eventos, cobranças, horas) serão desvinculadas. Um backup é guardado antes.',
      revertPayment: 'Estornar este pagamento?',
      revertPaymentBody: 'A parcela volta para "em aberto" (a data de transferência, juros, multa e desconto são apagados) e o valor é devolvido ao saldo da conta bancária e ao plano de contas. O vencimento, a forma e a conta são mantidos.',
      removeFinancialItem: 'Excluir esta movimentação?',
      removeFinancialItemBody: 'A movimentação é desativada e sai das listagens, dos saldos e dos impostos. O histórico é preservado.',
    },
    taxesApplaying: 'Taxas aplicáveis',
    PickerCobrancasTitle: 'Selecione as cobranças',
    PickerParcelsTitle: 'Selecione as parcelas',
    PickerSchedulesProductionTitle: 'Selecione as escalas',
    filterByHospital: 'Filtrar por hospital',
    filterByHealthInsurance: 'Filtrar por convênio',
    isAllowTransfer: 'Liberado para repasse?',
    codeCobranca: 'Código da cobrança',
    isAllowPF: 'Liberado para PF',
    isAllowPJ: 'Liberado para PJ',
    isAllowPFAndPJ: 'Liberado para PF e PJ',
    isAllow: 'Liberado',
    isNotAllow: 'Não Liberado',
    codeTransfer: 'Código da transferência',
    insurances: 'Convênios',
    selectTransactionType: 'Selecione os tipos de transação',
    groupBy: 'Agrupado por',
    reportTransactions: {
      pdfTitles: {
        Received: 'Guias pagas desde ',
        Losed: 'Guias perdidas desde ',
        Glosado: 'Guias glosadas desde ',
        Discounted: 'Guias descontadas desde ',
      }
    },
    dateReference: 'Data de referência',
    transferStatus: 'Status',
    lockTransfer: 'Fechar repasse',
    revertTransfer: 'Reverter repasse',
    revertTransferSuccess: 'Repasse revertido com sucesso',
    taxesToCollect: 'Impostos a recolher',
    taxesToCollectBack: 'Voltar aos impostos',
    taxesToCollectByMonth: 'Por mês',
    taxesToCollectTax: 'Imposto',
    taxesToCollectValue: 'A recolher',
    taxesToCollectTotal: 'Total',
    taxesToCollectEmpty: 'Nenhum imposto a recolher no período',
    invoiceAttached: 'Nota anexada',
    valueBaseTransfer: 'Valor da nota',
    isPF: 'Tipo',
    invoiceUpload: 'Nota',
    isPaid: 'Pago',
    // Saldo da movimentação: líquido menos o já pago/recebido. Neutro de propósito — a mesma
    // coluna lista despesa (a pagar) e receita (a receber).
    openBalance: 'Em aberto',
    paidDate: 'Dt. Pagamento',
    isPFInput: 'É pessoa Física',
    filterByAnesthetist: 'Filtrar por anestesista',
    filterByBatch: 'Filtrar por lote',
    reportTransactionsOptions: {
      anesthetist: 'Anestesista',
      healthInsurance: 'Convênio',
      batch: 'Lote',
    },
    transferCode: 'Cod repasse',
    addTaxes: 'Adicionar taxas',
    // Tabela de taxas da movimentação (FinancialItemTaxesEdit)
    // Extrato mensal do cooperado (fase 4 da #1111)
    monthlyStatement: {
      download: 'Extrato mensal do cooperado (PDF)',
      error: 'Erro ao gerar o extrato mensal do cooperado.',
    },
    // Conferência do extrato contra uma lista externa de valores esperados (super admin)
    statementCheck: {
      title: 'Conferência do extrato',
      menuAction: 'Conferir com lista externa',
      enabled: 'Conferência ligada',
      disable: 'Desligar conferência',
      manageSets: 'Listas de conferência',
      set: 'Lista',
      setName: 'Nome da lista',
      setNamePlaceholder: 'Ex.: Fechamento julho — planilha do cliente',
      month: 'Competência',
      monthMismatch: 'Esta lista é da competência {month} e a tela está em {screenMonth}.',
      noSet: 'Nenhuma lista de conferência salva. Cole a lista para começar.',
      base: 'Base da comparação',
      baseLiquid: 'Líquido (despesa − receita)',
      baseDiff: 'Valor a pagar (em aberto)',
      onlySuspect: 'Somente suspeitos',
      expected: 'Esperado',
      actual: 'Calculado',
      diff: 'Diferença',
      noMatch: 'sem correspondência',
      matchTooltip: '{name} · similaridade {score}%',
      sumTooltip: 'Soma das linhas deste prestador',
      matched: 'Conferidos: {n}',
      divergent: 'Suspeitos (Δ > {tolerance}): {n}',
      missing: 'Na lista e não na tela: {n}',
      extra: 'Na tela e não na lista: {n}',
      missingTitle: 'Sem prestador na tela',
      extraTitle: 'Fora da lista',
      // Editor das listas (StatementCheckDialog)
      tabTable: 'Tabela',
      tabText: 'JSON / colar',
      addEntry: 'Adicionar linha',
      searchEntry: 'Buscar prestador',
      entryName: 'Prestador',
      entryValue: 'Valor',
      entriesTotal: '{n} entradas · total {total}',
      emptyEntries: 'Nenhuma entrada. Adicione uma linha ou cole a lista na aba JSON.',
      textHint: 'Cole aqui o JSON desta tela ou o texto copiado da planilha (NOME<tab>valor). Aceita ; e , como separador, e valor no formato brasileiro ou americano.',
      copyJson: 'Copiar JSON',
      copyTsv: 'Copiar p/ planilha',
      copied: 'Copiado para a área de transferência',
      copyError: 'Não foi possível copiar',
      applyText: 'Aplicar à tabela',
      applied: '{n} entradas lidas',
      parseEmpty: 'Nada reconhecido no texto colado.',
      parseErrors: '{n} linha(s) ignorada(s): {lines}',
      parseDuplicates: 'Nomes repetidos somados: {names}',
      newSet: 'Nova lista',
      duplicateSet: 'Duplicar',
      removeSet: 'Excluir lista',
      removeConfirm: 'Excluir a lista "{name}"? Ela só existe neste navegador.',
      removed: 'Lista excluída',
      saved: 'Lista salva',
      nameRequired: 'Dê um nome à lista',
      entriesRequired: 'A lista está vazia',
      invalidValue: 'Valor inválido',
      localOnly: 'As listas ficam salvas apenas neste navegador. Use "Copiar JSON" para enviar a outra pessoa.',
    },
    participativeExecutant: {
      // Description da REVENUE gerada pelo repasse (cobrança do co-part recebido pelo
      // executante) — identifica a origem nas deductions da despesa e no extrato
      revenueDescription: 'Cobrança do co-participativo (recebido pelo executante)',
    },
    settlement: {
      pairedPaymentDescription: 'Desconto em folha — repasse {code}',
      // Fechamento financeiro sobre financialSettlements (fase 3 da #1111)
      settlementPaymentDescription: 'Encontro de contas {code}',
      notaOpenWarning: 'Receitas com abatimento pré-nota (NOTA) em aberto: {total}. Elas NÃO entram nesta compensação — serão abatidas no próximo repasse do cooperado.',
      notaItemTooltip: 'Abatimento pré-nota (NOTA): será abatida no próximo repasse, não neste fechamento',
      revenueResidualOpen: 'Saldo de receita que permanece em aberto após a compensação: {total}. Boleto apenas por ação manual.',
      revertAction: 'Reverter encontro de contas {code}',
      revertConfirm: 'Reverter o encontro de contas {code}? As baixas pareadas dos dois lados e o pagamento bancário do residual serão removidos; as movimentações voltam ao estado anterior.',
      reverted: 'Encontro de contas revertido',
      compensations: 'Compensações',
      compensationOrigin: 'Compensada com a movimentação',
      tooManyItems: 'Este cooperado tem {n} movimentações em aberto e o fechamento aceita no máximo {max} por vez. Filtre a lista (por competência ou vencimento) e feche em lotes menores.',
    },
    taxesTable: {
      tax: 'Taxa',
      factor: 'Fator da taxa',
      value: 'Valor da taxa',
      deduction: 'Abatimento',
      previous: 'Anterior',
      previousTooltip: 'Anteriormente recolhido no mês de competência',
      gross: 'Bruto',
      liquid: 'Líquido',
      baseIR: 'Base IR',
      baseMonthGross: 'Total do mês antes das deduções',
      baseMonthGrossTooltip: 'Base Repasse desta movimentação somada à dos outros repasses do mesmo mês de competência. É o total sobre o qual as deduções do mês incidem.',
      baseMonthIR: 'Base IR do mês (após INSS)',
      baseMonthIRTooltip: 'Deduzido do mês: {value} — INSS mensal, dependentes e pensão. A alíquota do IRRF é aplicada sobre esta base do MÊS; do imposto resultante é abatido o que já foi retido nos repasses anteriores (coluna Anterior).',
      baseMonthPending: 'Total do mês calculado a partir das bases gravadas. A dedução do mês só aparece em movimentações calculadas depois deste detalhamento — recalcule as taxas para vê-la.',
      baseTransfer: 'Base Repasse (Valor base da nota do cooperado)',
      others: 'Outras taxas',
      recalculate: 'Recalcular taxas',
      recalculateConfirm: 'Recalcular as taxas dessa movimentação?',
      fixFactor: 'Fixar a % informada — no recálculo o valor é obtido por ela',
      fixValue: 'Fixar o valor informado — ele é preservado no recálculo',
      signDebit: 'Desconto: reduz o líquido',
      signCredit: 'Acréscimo: aumenta o líquido',
      configRate: 'Alíquota do cadastro: {rate}',
      configRateUnknown: 'Sem alíquota no cadastro para esta data de competência',
      effectiveRate: 'Fator efetivo (valor ÷ base de cálculo da etapa)',
      noStepBase: 'Esta etapa não tem base de cálculo percentual — aqui só é possível fixar o valor',
      customFactor: 'Fixo em %',
      customValue: 'Fixo em R$',
      lockedNotPending: 'Movimentação já paga: as taxas não podem ser customizadas',
    },
    warnings: {
      selectTranferItem: 'Selecione um item de repasse para efetuar download'
    },
    // Abas do filtro de Contas a pagar e receber (FilterFinancialItems) e coluna da listagem.
    filters: {
      transfer: 'Repasse',
      isTransfer: 'É repasse',
      isNotTransfer: 'Não é repasse',
      transferType: 'Tipo de repasse',
      transferEvents: 'Eventos',
      transferHours: 'Horas de contrato',
    },
    // Coluna "Tipo de repasse" das listagens (TransferKind em FinancialItemsListFilters).
    transferKinds: {
      EVENTS: 'Eventos',
      HOURS: 'Horas',
      SCHEDULES: 'Escalas',
      TRANSFER: 'Repasse',
      IMPORTED: 'Importado',
      MANUAL: 'Manual',
    },
    healthInsurances: 'Convênios',
    invoice: {
      REVENUE: 'Nota Fiscal de Recebimento',
      EXPENSE: 'Nota Fiscal de Pagamento',
      INTERNAL_TRANSFER: 'Nota Fiscal',
      EXTERNAL_TRANSFER: 'Nota Fiscal',
    }
  },
  TransferStatus: {
    OPEN: 'Aberto',
    LOCKED: 'Fechado'
  },
  cobranca: {
    batch: 'Lote',
    cut: 'Glosado',
    paid: 'Pago',
    charged: 'Cobrado',
    dtBaixa: 'Dt. Baixa',
    qtd: 'Qtd',
    user: 'Usuário',
    dtBilling: 'Dt. Faturamento',
    cobranca: 'Cobrança',
    cobrancas: 'Cobranças',
    code: 'Código',
    value: 'Valor',
    date: 'Data',
    addCobranca: 'Adicionar cobranca',
    createFisrtCobranca: 'Criar primeira cobranca',
    batchName: 'Lote',
    infoHeader: 'Informações',
    codeBatch: 'Código do lote',
    nameBatch: 'Lote',
    receiveRemaining: 'Receber restante',
    finalize: 'Finalizar',
    finalizeTooltip: 'Finalizar e glosar o restante do evento',
    errors: {
      cobrancaExists: 'Já existe cobrança',
      codeNotGenerated: 'Não foi possível gerar o código da cobrança — nada foi gravado. Confira o contador de cobranças em Empresa → Configurar sequenciais e tente de novo.',
      someEventsManipulationStatusDenied: 'Alguns eventos selecionados não podem ser manipulados por causa do estado do evento e não serão exibidos'
    },
    guide: 'Guia',
    glosaValueIdentified: 'Glosar valor identificado',
    makeAppeal: 'Gerar recurso da glosa identificada',
    hasCuteReasons: 'Códigos de glosas',
    appealName: 'Recurso',
    openedCobrancasNamePDF: 'Relatório de Cobranças em Aberto',
    openedCobrancasNameWithoutAppealPDF: 'Relatório de Cobranças em Aberto (Sem Recurso)',
    openedReport: {
      openedEvents: 'Eventos em Aberto',
      dateRegister: 'Data de Criação da Cobrança',
      dateBatch: 'Data de Criação do Lote',
      dateSentBatch: 'Data de Envio do Lote',
      status: 'Situação'
    },
    evolucaoGlosasNamePDF: 'Relatório de Evolução de Glosas',
    evolucaoGlosasReport: {
      totalAppealed: 'Glosa Ident.',
      totalAppealedPercent: '% Glosa',
      totalReceivedAppeal: 'Recebido Rec.',
      totalReceivedAppealPercent: '% Recebido',
      totalAccepted: 'Glosa Acatada',
      totalAcceptedPercent: '% Acatada',
      totalOpened: 'Aberto',
      totalOpenedPercent: '% Aberto'
    }
  },
  transfer: {
    healthInsurance: 'Convênio',
    fullValue: 'Valor Bruto',
    discounts: 'Descontos',
    liquidValue: 'Valor Líquido',
    total: 'Total do repasse',
  },
  tableConfig: { //SpreadsheetConfig
    tableConfigTitle: 'Campos da tabela para download',
    byProcedure: 'Por procedimento?',
    confirmDelete: 'Tem certeza que deseja apagar essa Configuração de campos da tabela?',
    byProcedureLabel: '* Quando ativado cada linha da tabela será um procedimento',
    isWithTotalRow: 'Linha de Totais?',
    isWithTotalRowLabel: '* Ao final de cada evento, uma linha exibirá os totais de cada coluna de valor.',
    maxLength25: 'Tamanho máximo de 25 caracteres',
    yes: 'Sim',
    no: 'Não',
    labelTotal: 'TOTAL',
    labelTotalOfEvents: 'TOTAL DOS EVENTOS',
    orderTable: 'Ordenação da planilha',
    orderTableInfo: 'Arraste os itens na ordem que deseja que apareçam nas colunas na planilha',
    configDates: 'Configuração de datas',
    configDatesInfo: 'Selecione como deseja que as datas sejam apresentadas na planilha',
    dateConfig: {
      KDateHourTogether: 'Data e hora juntos',
      KDateHourSeparated: 'Data e hora em colunas separadas',
      KDate: 'Somente data',
      KHour: 'Somente hora',
    },
    event: {
      'id': 'ID do Evento',
      'description': 'Descrição',
      'counterNumberEvent': 'Nº Evento',
      'numberProviderGuides': 'Nº da Guia',
      'isParticular': 'Particular',
      'companyName': 'Empresa',
      'attachments': 'Anexos',
      'numGuide': 'Nº da Guia',
      'genericCodesEvent': 'Código',
      'status': 'Status',
      'invoices': 'Notas Fiscais',
      'event': 'Evento',
      'accommodation': 'Acomodação do evento',
      'type': 'Tipo do evento',

      'anesthesiaStart': 'Início da Anestesia',
      'anesthesiaStartDate': 'Início da Anestesia - Data',
      'anesthesiaStartHour': 'Início da Anestesia - Hora',
      'anesthesiaStartDateHour': 'Início da Anestesia - Data e Hora',

      'anesthesiaEnd': 'Fim da Anestesia',
      'anesthesiaEndDate': 'Fim da Anestesia - Data',
      'anesthesiaEndHour': 'Fim da Anestesia - Hora',
      'anesthesiaEndDateHour': 'Fim da Anestesia - Data e Hora',

      'dtProcedure': 'Procedimento',
      'dtHourProcedure': 'Procedimento - Data e Hora',
      'dtProcedureDate': 'Procedimento - Data',
      'dtProcedureHour': 'Procedimento - Hora',

      'procedureStart': 'Início do Procedimento',
      'procedureStartDate': 'Início do Procedimento - Data',
      'procedureStartHour': 'Início do Procedimento - Hora',
      'procedureStartDateHour': 'Início do Procedimento - Data e Hora',

      'procedureEnd': 'Fim do Procedimento',
      'procedureEndDate': 'Fim do Procedimento - Data',
      'procedureEndHour': 'Fim do Procedimento - Hora',
      'procedureEndDateHour': 'Fim do Procedimento - Data e Hora',

      'dtRecourse': 'Recurso',
      'dtHourRecourse': 'Recurso - Data e Hora',
      'dtRecourseDate': 'Recurso - Data',
      'dtRecourseHour': 'Recurso - Hora',

      'startPaymentDate': 'Início do pagamento',
      'startPaymentDateDateHour': 'Início do pagamento - Data e Hora',
      'startPaymentDateDate': 'Início do pagamento - Data',
      'startPaymentDateHour': 'Início do pagamento - Hora',

      'installmentsAmount': 'Quantidade de parcelas',
      'periodOfPayment': 'Período dos pagamentos',
      'typeOfPayment': 'Forma de pagamento',

      'healthInsuranceWallet': 'Carteira do convênio',
      'observation': 'Observação do evento',
      'observationGuideSent': 'Observação de envio da guia',
      'observationRecourse': 'Observação de recurso',
      'healthInsuranceName': 'Convênio',
      'hospitalName': 'Hospital',
      'anesthetistName': 'Anestesista',
      'secondaryAnesthetistName': 'Segundo Anestesista',
      'surgeonName': 'Cirurgião',
      'surgeonSpeciality': 'Especialidade do Cirurgião',
      'auxAnesthetistName': 'Segundo Anestesista - Auxiliar',
      'auxSurgeonName': 'Cirurgião Auxiliar',
      'auxSurgeonName1': 'Cirurgião Auxiliar 1',
      'auxSurgeonName2': 'Cirurgião Auxiliar 2',
      'auxSurgeonName3': 'Cirurgião Auxiliar 3',
      'auxSurgeonName4': 'Cirurgião Auxiliar 4',
      'doctorActorsName': 'Médicos/Atores - Nome',
      'doctorActorsFunction': 'Médicos/Atores - Função',
      'residentName': 'Residente',
      'NURSERY': 'Enfermaria',
      'APARTMENT': 'Apartamento',
      'OUTPATIENT': 'Ambulatorial',
      'ONE_DAY_CLINIC': 'One day clinic',
      'NONE': 'Sem acomodação',
      'null': '',
      'isEmergency': 'Emergência / Eletiva',
      'durationEvent': 'Duração total do Evento',
      statusHistory: {
        'AwaitingCheck': 'Aguar. Conferência',
        'WaitSendGuia': 'Aguar. Envio da Guia',
        'WaitPayment': 'Aguar. Pagamento',
        'WaitSendRecourse': 'Aguar. Envio do Recurso',
        'WaitRecourse': 'Aguar. Recurso',
        'Finished': 'Finalizado',
        'Received': 'Recebido',
        'Losed': 'Perdido',
        'Cuted': 'Glosado',
        'Imported': 'Importado',

        'DateAwaitingCheck': 'Data - Aguar. Conferência',
        'UserNameAwaitingCheck': 'Usuário - Aguar. Conferência',
        'DateWaitSendGuia': 'Data - Aguar. Envio da Guia',
        'UserNameWaitSendGuia': 'Usuário - Aguar. Envio da Guia',
        'DateWaitPayment': 'Data - Aguar. Pagamento',
        'UserNameWaitPayment': 'Usuário - Aguar. Pagamento',
        'DateWaitSendRecourse': 'Data - Aguar. Envio do Recurso',
        'UserNameWaitSendRecourse': 'Usuário - Aguar. Envio do Recurso',
        'DateWaitRecourse': 'Data - Aguar. Recurso',
        'UserNameWaitRecourse': 'Usuário - Aguar. Recurso',
        'DateFinished': 'Data - Finalizado',
        'UserNameFinished': 'Usuário - Finalizado',
        'DateReceived': 'Data - Recebido',
        'UserNameReceived': 'Usuário - Recebido',
        'DateLosed': 'Data - Perdido',
        'UserNameLosed': 'Usuário - Perdido',
        'DateGlosado': 'Data - Glosado',
        'UserNameGlosado': 'Usuário - Glosado',
        'DateImportado': 'Data - Importado',
        'UserNameImportado': 'Usuário - Importado',

        // Chaves alinhadas à chave do STATUS (Cuted/Imported). As variantes
        // 'Glosado'/'Importado' acima são anteriores e seguem em uso.
        'DateCuted': 'Data - Glosado',
        'UserNameCuted': 'Usuário - Glosado',
        'DateImported': 'Data - Importado',
        'UserNameImported': 'Usuário - Importado',
      },
      emergency: {
        'isEmergency': 'Emergência / Eletiva',
        'true': 'Emergência',
        'false': 'Eletiva',
        'null': 'Eletiva',
        'undefined': 'Eletiva',
      },
    },
    patient: {
      patient: 'Paciente',
      name: 'Nome do paciente',
      initials: 'Iniciais',
      birthDate: 'Data de Nascimento do paciente',
      cpf: 'CPF do paciente',
      email: 'Email do paciente',
      gender: 'Gênero do paciente',
      healthInsuranceWallet: 'Carterinha do convênio',
      momName: 'Nome da mãe do paciente',
      phone: 'Telefone do paciente',
      accommodation: 'Acomodação do paciente',
      NURSERY: 'Enfermaria',
      APARTMENT: 'Apartamento',
      OUTPATIENT: 'Ambulatorial',
      NONE: 'Sem acomodação',
      ONE_DAY_CLINIC: 'One day clinic',
      null: '',
    },
    procedures: {
      procedures: 'Procedimentos',
      name: 'Nome do procedimento',
      cutReason: 'Motivo da Glosa',
      cutReasonCode: 'Código do Motivo da Glosa',
      idProc: 'ID do procedimento',
      porte: 'Porte',
      doctorActors: 'Médicos/Atores',
      porteAnestesico: 'Porte Anestésico',
      portePercent: 'Porcentagem do Porte',
      proportion: 'Proporção do Procedimento',
      procedureReceiverPercentage: 'Porcentagem de Recebimento do Procedimento por Ator',
      techniqueUsed: 'Técnica Utilizada',
      techniqueUsedProportion: 'Proporção da Técnica Utilizada',
      totalDiscount: 'Descontado',
      totalGlosado: 'Glosado',
      totalLoss: 'Perdido',
      totalOver: 'Over',
      totalReceived: 'Recebido',
      type: 'Tipo do procedimento',
      value: 'Valor do procedimento',
      valueOriginal: 'Valor original',
      KNone: 'Convencional',
      KConventional: 'Convencional',
      KVideo: 'Video',
      KRobotic: 'Robótica',
      KOVERRIDEPORTE: 'Especial',
      KOVERRIDE: 'Especial',
      KCUSTOM: 'Customizado',
      KCBHPM: 'CBHPM',
      accessRoute: 'Via de acesso',
    },
    values: {
      totalTransferred: 'Total repassado',
      values: 'Valores',
      complementation: 'Complementação',
      complementationDiscount: 'Desconto da complementação',
      complementationGlosado: 'Glosado da complementação',
      complementationLoss: 'Perda da complementação',
      complementationReceived: 'Complementação Recebida',
      total: 'Total',
      totalChanged: 'Total alterado',
      totalChangedLess: 'Total alterado para menos',
      totalChangedPlus: 'Total alterado para mais',
      totalDiscount: 'Total descontado',
      totalGlosado: 'Total glosado',
      totalInProcessing: 'Total processando',
      totalLoss: 'Total perdido',
      totalOver: 'Total Over',
      totalProcedures: 'Total procedimentos',
      totalProceduresGlosado: 'Total glosado dos procedimentos',
      totalProceduresLoss: 'Total perdido dos procedimentos',
      totalProceduresOver: 'Total Over dos procedimentos',
      totalProceduresReceived: 'Total recebido dos procedimentos',
      totalProduced: 'Total produzido',
      totalReceived: 'Total recebido',
      totalProducedByActor: 'Total Produzido por Ator',
      installmentValue: 'Valor da parcela',
    },
    batches: {
      'batches': 'Lote',
      'name': 'Nome do lote',
      'code': 'Código do lote',
    },
    additionalData: {
      additionalData: 'Dados adicionais',
      grauPart: 'Grau de participação',
      anesthesiaStart: 'Horário do início da anestesia',
      anesthesiaEnd: 'Horário do fim da anestesia',
      codeProcedureConsult: 'Código do procedimento',
      valueProcedureConsult: 'Valor do procedimento',
      numberProviderGuide: 'Nº guia no prestador',
      authorizationDate: 'Data da autorização',
      password: 'Senha',
      passwordExpirationDate: 'Data de validade da senha',
      numberProtocol: 'Número do Protocolo (PEG)',
      guideNumberSetByOperator: 'Número da guia atribuído pela operadora',
      codeProviderInOperator: 'Código do prestador na operadora',
      solicitationGuideNumberHospitalization: 'Nº da guia de solicitação de serviço',
      numberWallet: 'Número da Carteira',
      walletExpirationDate: 'Data de validade da carteira',
      healthCard: 'Cartão Nacional de Saúde',
      attendanceRN: 'Atendimento a RN',
      clinicIndication: 'Indicação Clínica',
      attendimentType: 'Tipo de atendimento',
      accidenteIndication: 'Indicação de Acidente',
      consultType: 'Tipo de Consulta',
      reasonToFinishAttendiment: 'Motivo de Encerramento do Atendimento',
      totalProcedures: 'Total de procedimentos (R$)',
      totalTaxes: 'Total de taxas e aluguéis (R$)',
      totalMaterials: 'Total de materiais (R$)',
      totalOPME: 'Total de OPME (R$)',
      totalDrugs: 'Total de medicamentos (R$)',
      totalGasesMedicinals: 'Total de gases medicinais (R$)',
      total: 'Total geral (R$)',
      totalFees: 'Total honorários (R$)',
      startDateBilling: 'Data do início do faturamento',
      endDateBilling: 'Data do fim do faturamento',
      emissionDate: 'Data de emissão',
      attendanceDateConsult: 'Data do atendimento (consulta)',
      error: 'Nem todos os campos obrigatórios foram preenchidos'
    },
    customFields: {
      customFields: 'Campos Customizados',
    },
    additionalConfigs: 'Configurações adicionais',
    additionalConfigsInfo: 'Configurações adicionais da planilha',
    procProportionInPercentage: 'Proporção do procedimento em porcentagem (100%, 70%, 50%)',
    replacePortNull: 'Substituir porte vazio',
    portNullReplacement: 'Valor do porte para substituição',
    hospital: 'Local',
    valueBaseIR: 'Base IRRF',
  },
  ProcedureUserCustom: {
    TABLE: 'Tabela',
    BASE: 'Base',
    FINAL: 'Final',
    EMPTY: 'Nenhum'
  },
  OcrGuideCreditType: {
    PAYMENT: 'Pagamento',
    GIFT: 'Brinde',
    TEST: 'Teste',
    GIFT_FIRST: 'Brinde inicial'
  },
  externalPayment: {
    date: 'Data do repasse',
    code: 'Número do repasse'
  },
  CompanyBillingType: {
    MEDICAL: 'Médico',
    ANESTHETIST: 'Anestesista'
  },
  CBHPMApplayTo: {
    MEDICAL: 'Médico',
    ANESTHETIST: 'Anestesista',
    ALL: 'Ambos'
  },
  PayerType: {
    HEALTH_INSURANCE: 'Convênio',
    HOSPITAL: 'Hospital',
  },
  payment: {
    dateRegisterIso: 'Data Cadastro',
    datePaymentIso: 'Data Pagamento',
    numMov: 'Nº Movim',
    notaFiscal: 'NF Movim',
    healthInsurance: 'Contratante',
    receiver: 'Prestador',
    hospital: 'Local',
    valueBaseIR: 'Base IRRF',
    value: 'Valor',
    liquid: 'Líquido'
  },
  TaxIdentifier: {
    TAX: 'TAXA',
    INSS: 'INSS',
    IR: 'IR',
    IRJ: 'IRJ',
    CSLL: 'CSLL',
    PIS: 'PIS',
    COFINS: 'COFINS',
    PIS_TOMADOR: 'PIS TOMADOR',
    COFINS_TOMADOR: 'COFINS TOMADOR',
    CUSTOM: 'CUSTOMIZADO',
    OTHER: 'OUTRO',
  },
  AgendaDisplayMode: {
    SHIFT: 'Turno',
    DEMAND: 'Demanda'
  },
  UserType: {
    KANESTHETIST: 'Anestesista',
    KSURGEON: 'Cirurgião',
    KDENTIST: 'Dentista',
    KRESIDENT_ANESTHETIST: 'Residente Anestesista',
    KRESIDENT_SURGEON: 'Residente cirurgião',
    KUSER: 'Usuário',
    KSCRUB_NURSE: 'Instrumentador',
    KNURSE: 'Enfermeira',
    KPHONOAUDIOLOGIST: 'Fonoaudiólogo',
  },
  TeamTypes: {
    KANESTHETIST: 'Anestesista',
    KSURGEON: 'Cirurgião',
    KDENTIST: 'Dentista',
    KRESIDENT_ANESTHETIST: 'Residente Anestesista',
    KRESIDENT_SURGEON: 'Residente cirurgião',
    KUSER: 'Usuário',
    KSCRUB_NURSE: 'Instrumentador',
    KNURSE: 'Enfermeira',

    KASSISTANT_SURGEON: 'Cirurgião Auxiliar',
    KSECONDARY_ANESTHETIST: 'Anestesista Auxiliar',
    KASSISTANT_ANESTHETIST: 'Anestesista Auxiliar',
    KOVERRIDE_EXECUTANT: 'Executante sobreescrito',
    KREQUESTER: 'Solicitante',
    KPHONOAUDIOLOGIST: 'Fonoaudiólogo'
  },
  reportsGenerator: {
    report: 'Download de documento PDF',
    spreadsheet: 'Download de planilha'
  },
  report: {
    inssIrrfExternal: 'Retenção INSS/IRRF de outra fonte',
    boletos: 'Exportar boletos'
  },
  billsToPayAndReceive: {
    KPay: 'A pagar',
    KReceive: 'A receber',
    KIncome: 'A receber',
    KOutcome: 'A pagar',
    KEvent: 'Evento',
    dueDate: 'Data de vencimento',
    viewEvent: 'Ver evento',
    billType: 'Tipo de conta',
    billOrigin: 'Origem da conta',
    pending: 'Pendente',
    paid: 'Pago',
    valueReceived: 'Valor recebido',
    valuePaid: 'Valor pago',
    valueToReceive: 'A receber',
    valueToPay: 'A pagar',
    invoice: 'Nota',
    actionsOnBill: 'Ações na conta',
    editBillValues: 'Editar valores',
  },
  FinancialNegotiatorOrigin: {
    COMPANY: 'Empresa',
    USER: 'Usuário',
    SUPPLIER: 'Fornecedor',
    HEALTH_INSURANCE: 'Convênio',
    HOSPITAL: 'Hospital',
    BANK_ACCCOUNT: 'Contas'
  },
  FinancialPaymentFormat: {
    MONEY: 'Dinheiro',
    CHEQUE: 'Cheque',
    PIX: 'PIX',
    CREDIT: 'Crédito',
    CREDITCARD: 'Cartão de Crédito',
    DEBITCARD: 'Cartão de Débito',
    BANK_TRANSFER: 'Transferência bancaria',
    BOLETO: 'Boleto',
    DARF: 'DARF',
    DEBIT_AUTOMATIC: 'Débito automático',
    EXTERNAL_ACCOUNT: 'Conta externa',
    USING_EXPENSE: 'Usando despesa',
    USING_REVENUE: 'Usando receita',
  },
  FinancialItemsPaymentStatus: {
    PAID: 'Pago',
    PARTIAL_PAID: 'Parcialmente pago',
    PENDING: 'Pendente'
  },
  PaymentSlipStatus: {
    PAID: 'Pago',
    PENDING: 'Pendente'
  },
  boletosReport: {
    title: 'Relatório de Boletos',
    emptyState: 'Nenhum boleto no período.',
    headers: {
      documentNumber: 'Nº Documento',
      payerName: 'Nome Pagador',
      payerDocument: 'Inscrição Pagador',
      issueDate: 'Emissão',
      dueDate: 'Vencimento',
      paymentDate: 'Data Pagamento',
      documentValue: 'Valor Documento',
      paidValue: 'Valor Pago',
      status: 'Situação'
    }
  },
  PaymentSlip: {
    title: 'Boleto',
    titlePlural: 'Boletos',
    create: 'Criar Boleto',
    edit: 'Editar Boleto',
    pay: 'Pagar Boleto',
    paymentSlipCode: 'Código do Boleto',
    barcode: 'Código de Barras',
    dueDate: 'Data de Vencimento',
    createdAt: 'Data de Criação',
    paidAt: 'Data de Pagamento',
    description: 'Descrição',
    totalValue: 'Valor Total',
    totalLiquid: 'Valor Líquido',
    itemsCount: 'Quantidade de Itens',
    associatedItems: 'Itens Associados',
    selectItems: 'Selecionar Itens',
    noItemsSelected: 'Nenhum item selecionado',
    negotiator: 'Negociador',
    code: 'Código',
    payConfirm: 'Confirmar pagamento do boleto?',
    paySuccess: 'Boleto pago com sucesso',
    createSuccess: 'Boleto criado com sucesso',
    errors: {
      differentNegotiators: 'Todos os itens devem pertencer ao mesmo negociador. Foram selecionados itens de negociadores diferentes.',
      noNegotiator: 'Existem itens sem negociador definido.',
      itemAlreadyLinked: 'Este item já está vinculado a um boleto.',
      noItems: 'Nenhum item selecionado.',
      paymentFailed: 'Erro ao processar pagamento.'
    },
    tabs: {
      intervalCustom: 'Período',
      searchByCode: 'Código do boleto',
    }
  },
  BankAccountType: {
    CREDIT: 'Crédito',
    CHECKING_ACCOUNT: 'Conta corrente',
    SAVINGS_ACCOUNT: 'Conta poupança',
    CASHIER: 'Caixa',
    APPLICATION: 'Aplicação',
  },
  FinancialItemsTypes: {
    REVENUE: 'Receita',
    EXPENSE: 'Despesa',
    INTERNAL_TRANSFER: 'Movimentação interna',
    EXTERNAL_TRANSFER: 'Movimentação externa',
  },
  FinancialDeductionPoint: {
    NOTA: 'Abate na nota (antes dos impostos)',
    LIQUID: 'Compensa no líquido (após impostos)',
  },
  HonorarioGroup: {
    HONORARIO: 'Honorários',
    OUTROS: 'Outros',
  },
  // Tela "Financeiro cooperado" (empresa filial) — docs/financial/FinanceiroCooperado.md
  coopFinancial: {
    ownScopeHint: 'Você vê apenas as movimentações em seu nome.',
    // Aviso do escopo pessoal (filial de produção pessoal): de quem são os pagamentos da lista.
    personalScope: {
      own: 'Você está vendo apenas os seus pagamentos — de todos os locais em que trabalhou, os mesmos em qualquer empresa de produção pessoal em que entrar.',
      ownAdmin: 'Você está vendo apenas os seus pagamentos. Para ver o que um cooperado vê, escolha-o em "Ver como".',
      viewAs: 'Você está vendo apenas os pagamentos de {name} — o que ele vê ao entrar numa empresa de produção pessoal.',
      all: 'Você está vendo os pagamentos de todos os cooperados que a cooperativa liberou.',
    },
    // "Ver como" do superadmin (suporte), no escopo pessoal.
    viewAs: {
      label: 'Ver como',
      hint: 'Suporte: a tela como um usuário desta empresa a vê, ou a de todos os cooperados.',
      all: 'Todos os cooperados',
    },
    ownScopeEmpty: 'Nenhuma movimentação em seu nome nesta busca. Movimentações emitidas para a empresa só aparecem para quem tem acesso ao financeiro da empresa.',
    empty: 'Nenhuma movimentação liberada nesta busca.',
    detailTitle: 'Movimentação',
    direction: {
      RECEIVABLE: 'Recebimento',
      PAYABLE: 'Cobrança',
    },
    columns: {
      direction: 'Tipo',
      places: 'Locais',
      status: 'Situação',
      paidAt: 'Data do pagamento',
      paidValue: 'Valor pago',
    },
    export: {
      sheet: 'Exportar planilha',
      empty: 'Nada para exportar com os filtros atuais.',
    },
    invoice: {
      title: 'Nota fiscal',
      hint: 'Informe o número e anexe a nota fiscal emitida para esta movimentação.',
      save: 'Salvar nota',
      saved: 'Nota fiscal salva',
      saveError: 'Não foi possível salvar a nota fiscal',
      codeTooLong: 'O número da nota aceita até {max} caracteres',
    },
    errors: {
      notFilial: 'O financeiro cooperado é da empresa filial. Selecione a empresa do cooperado.',
      accessDenied: 'Acesso negado ao financeiro cooperado',
      dateNoSelected: 'Selecione o período',
      tooManyMonths: 'O período personalizado aceita até {max} meses',
      notInScope: 'Movimentação não encontrada ou não liberada para você',
    },
  },
  FinancialItem: {
    REVENUE: {
      title: 'Receita',
      negotiator: 'Cliente',
      negotiators: 'Clientes',
      payment: 'Recebimento',
      paymentFormat: 'Forma de recebimento',
      isPaid: 'Recebido',
      acquittanceDate: 'Data de recebimento',
      negotiatorCanSee: 'Liberado para visualização do Cliente'
    },
    EXPENSE: {
      title: 'Despesa',
      negotiator: 'Fornecedor',
      negotiators: 'Fornecedores',
      payment: 'Pagamento',
      paymentFormat: 'Forma de pagamento',
      isPaid: 'Pago',
      acquittanceDate: 'Data de pagamento',
      negotiatorCanSee: 'Liberado para visualização do Fornecedor'
    },
    INTERNAL_TRANSFER: {
      title: 'Tranferência interna',
      negotiator: 'Destino',
      negotiators: 'Destinos',
      payment: 'Origem',
      paymentFormat: 'Forma de transferência',
      isPaid: 'Tranferido',
      acquittanceDate: 'Data de transferência',
      negotiatorCanSee: 'Liberado para visualização'
    },
    EXTERNAL_TRANSFER: {
      title: 'Tranferência externa',
      negotiator: 'Destino',
      negotiators: 'Destinos',
      payment: 'Origem',
      paymentFormat: 'Forma de transferência',
      isPaid: 'Tranferido',
      acquittanceDate: 'Data de transferência',
      negotiatorCanSee: 'Liberado para visualização'
    },
    flags: {
      canAttachEvent: 'Pode ser anexado a evento?',
      canAttachContract: 'Pode ser anexado a contrato?',
    },
    dueDate: 'Data prevista',
    dateCompetence: 'Data de competência',
    deductionPoint: 'Desconto em folha (ponto da dedução)',
    deductionPointInherit: 'Herdar da categoria de imposto',
    deductionPointHint: 'Abate na nota reduz a base do próximo repasse; compensa no líquido entra no fechamento financeiro',
    deductions: 'Abatimentos',
    deductionsHint: 'Receitas do negociador abatidas na base desta movimentação ANTES dos impostos da nota (não entram na NF). O valor é negativo porque desconta da base.',
    deductionsRevenue: 'Receita abatida',
    deductionsTotal: 'Total abatido',
    eventsInfo: 'Informações de eventos',
    eventsInfoUnavailable: 'Não foi possível carregar os vínculos de eventos desta movimentação. Os dados vêm de um serviço externo (volanpg) que não respondeu — o restante da movimentação está correto. Veja o console para o erro completo.',
    revertPayment: 'Estornar pagamento',
    revertPaymentLinked: 'Parcela baixada por outro documento (encontro de contas ou abatimento de repasse) — estorne pelo documento de origem',
    revertPaymentReconciled: 'Parcela conciliada com o extrato bancário — desfaça o vínculo na tela de conciliação',
    revertPaymentOriginSettlement: 'Origem: encontro de contas {code} (id {id}). Reverta o fechamento financeiro para desfazer a baixa dos dois lados.',
    revertPaymentOriginItem: 'Origem: movimentação {numMov} (id {id}). Reverta o repasse que gerou o abatimento para desfazer a baixa dos dois lados.',
    revertPaymentOriginUnknown: 'A parcela está marcada como baixa de outro documento (forma de pagamento {format}), mas não guarda referência a ele. Abra o console do navegador (F12) e envie o registro ao suporte.',
    revertPaymentOriginReconciled: 'Conciliação {operation}.',
    revertPaymentOriginReconciledDeparture: 'Saída (extrato da conta de origem): conciliação {operation}.',
    revertPaymentOriginReconciledDestination: 'Chegada (extrato da conta de destino): conciliação {operation}.',
    revertPaymentReconciledOrphan: 'A conciliação foi excluída e o vínculo ficou para trás, sem conciliação onde desfazê-lo: peça ao suporte o script "Desfazer vínculos de conciliações excluídas", que desfaz o vínculo e libera o estorno.',
    reconciliationMovementRef: 'da linha do extrato de id {id}',
    // Atalho para a conciliação (#1311). `leg` vem vazio fora da transferência, por isso traz a
    // própria pontuação.
    reconciliationLeg: {
      origin: 'da saída · ',
      destination: 'da chegada · ',
    },
    reconciliationOpen: 'Abrir conciliação {leg}{operation}',
    reconciliationUnavailable: 'Conciliação {leg}{operation}',
    revertPaymentSuccess: 'Pagamento estornado',
    revertPaymentSameAccountCleared: 'Pagamento estornado. A conta da parcela era a própria conta de destino da transferência e foi limpa: escolha a conta de origem antes de baixar de novo.',
    remove: 'Excluir movimentação',
    removeOnlyPending: 'Só é possível excluir movimentação sem pagamento realizado — estorne os pagamentos antes',
    removeSuccess: 'Movimentação excluída',
    recalculateNegativeLiquid: {
      title: 'Taxas recalculadas, mas o líquido ficou zero ou negativo',
      text: 'As retenções consumiram todo o valor da movimentação (líquido {liquid}). Confira o IR e o INSS do mês antes de salvar: com líquido zero ou negativo a movimentação é gravada como paga, sem pagamento nenhum.',
    },
    recalculateError: {
      title: 'Não foi possível recalcular os impostos',
      text: 'A consulta do retido do mês falhou, e os impostos ficaram como estavam. Tente "Recalcular taxas" de novo em instantes.',
      saveBlocked: 'Esta cópia ainda está com os impostos do mês da movimentação de origem. Clique em "Recalcular taxas" antes de salvar.',
    },
    view: {
      title: 'Visualizar movimentação',
      identification: 'Identificação',
      numMov: 'N.º movimentação',
      numMovAnterior: 'N.º anterior (renumerado)',
      compensationRef: 'Compensada com',
      transferCode: 'Código do repasse',
      reference: 'Origem',
      recurrentCode: 'Código de recorrência',
      duplicatedFrom: 'Duplicado da movimentação',
      document: 'Documento',
      origin: 'Tipo de cadastro',
      isExternal: 'Externo',
      dates: 'Datas',
      lockedAt: 'Fechado em',
      dateReleased: 'Data de lançamento',
      values: 'Valores',
      valueProduced: 'Produção',
      valueOriginal: 'Valor recebido',
      valueGross: 'Valor bruto',
      adjustmentValue: 'Ajuste de valor',
      totalTax: 'Descontos',
      liquid: 'Valor líquido',
      paidValue: 'Valor pago',
      valueBaseTransfer: 'Base transferência',
      valueBaseIR: 'Base IR',
      baseLiquid: 'Base líquido',
      taxName: 'Taxa',
      previouslyRetained: 'Anterior',
      previouslyRetainedHint: 'Anteriormente recolhido no mês de competência',
      bankAccount: 'Conta',
      payByBoleto: 'Pagar por boleto',
      valuesByTomador: 'Valores por tomador',
      paymentsByHospital: 'Pagamentos por hospital',
      paymentsByInsurance: 'Pagamentos por convênios',
      payer: 'Pagador',
      events: 'Eventos',
      eventsSearch: 'Buscar por paciente, ator, convênio, hospital ou lote',
      columnsFilter: 'Colunas',
      taxesBreakdown: 'Impostos (detalhado)',
      patient: 'Paciente',
      receivedBy: 'Recebido por',
      batch: 'Lote',
      hours: 'Horas',
      hoursAmount: 'Horas',
      anesthetist: 'Anestesista',
      attachment: 'Anexo',
      place: 'Local',
      otherAttachments: 'Outros anexos',
      honorarioGroup: 'Grupo',
    },
  },
  FinancialReference: {
    FINANCIAL_ENTRY: 'Lançamento manual',
    FINANCIAL_EXTERNAL: 'Lançamento externo',
    TRANSFER_EVENTS: 'Repasse de eventos',
    TRANSFER_HOURS: 'Repasse de horas de contrato',
    TRANSFER_SCHEDULES: 'Repasse de escalas',
  },
  FinancialPersonType: {
    FINANCIAL_PERSON_NATURAL: 'Pessoa Física',
    FINANCIAL_PERSON_LEGAL: 'Pessoa Jurídica',
    FINANCIAL_PERSON_NATURAL_LIMIT: 'Pessoa Física, após limite, PJ',
  },
  ReceiverType: {
    SELF: 'Próprio',
    EXTERNAL: 'Externo',
  },
  UserBoardType: {
    KCRFA: 'CRFA',
    KCRM: 'CRM',
  },
  OcrGuideStatus: {
    CREATED: 'Criado',
    NEED_CLIENT: 'Aguardando feedback do cliente',
    NEED_DEVELOPER: 'Necessário desenvolvedor',
    NEED_SUPPORT: 'Necessário suporte',
    ON_TEST: 'Em testes',
    READY: 'Pronto para uso',
  },
  FieldDisplayType: {
    NOT_VISIBLE: 'Não visível',
    VISIBLE: 'Visível internamente',
    MANDATORY: 'Obrigatório e visível internamente',
    EXTERNAL: 'Visível externamente',
    MANDATORY_EXTERNAL: 'Obrigatório e visível externamente',
  },
  FieldDisplayTypeDescription: {
    NOT_VISIBLE: 'Não aparece no lançamento do evento',
    VISIBLE: 'Aparece dentro de um menu (como por exemplo os dados adicionais)',
    MANDATORY: 'É obrigatório e aparece dentro de um menu',
    EXTERNAL: 'Aparece na tela de lançamento do evento',
    MANDATORY_EXTERNAL: 'É obrigatório e aparece na tela de lançamento do evento',
  },
  MandatoryType: {
    EVENT: 'Evento',
    XML: 'XML'
  },
  configFields: {
    fillWithDefault: 'Preencher com valor padrão',
    patientIdentification: {
      title: 'Identificação do paciente',
      patient: 'Paciente',
      patientAddress: 'Endereço do paciente',
      patientEmail: 'E-mail do paciente',
      insuranceWallet: 'Carteirinha do convênio',
      insurance: 'Convênio',
      accomodation: 'Acomodação'
    },
    attachments: {
      title: 'Anexos',
      guide: 'Guia',
      record: 'Ficha',
      rgo: 'RGO',
      term: 'Termo',
      apa: 'APA',
      medicalRecord: 'Prontuário',
      hospitalizationForm: 'Formulário de internação',
      networkCharter: 'Convênio',
      '3AFile': '3A',
      other: 'Outro'
    },
    procedures: {
      title: 'Área dos procedimentos',
      procedures: 'Procedimentos',
      emergency: 'Urgência/Emergência'
    },
    sideBar: {
      title: 'Campos do evento',
      procedureDate: 'Data do procedimento',
      procedureStart: 'Início procedimento',
      procedureEnd: 'Fim procedimento',
      anesthesiaStart: 'Início da anestesia',
      anesthesiaEnd: 'Fim da anestesia',
      anesthetist: 'Anestesista',
      assistentAnesthetist: 'Auxiliar anestésico',
      residentAnesthetist: 'Residente anestésico',
      surgeon: 'Cirurgião',
      assistentSurgeon: 'Auxiliar cirúrgico',
      residentSurgeon: 'Residente cirúrgico',
      phonoaudiologist: 'Fonoaudiólogo',
      hospital: 'Hospital',
      observation: 'Observação'
    },
    additionalData: {
      title: 'Dados adicionais',
      numberProviderGuide: 'Número de guia do prestador',
      numberProtocol: 'Número do Protocolo',
      numberMainGuide: 'Número da guia principal',
      solicitationGuideNumberHospitalization: 'Nº da guia de solicitação de serviço',
      guideNumberSetByOperator: 'Número da guia atribuído pela operadora',
      startDateBilling: 'Data do início do faturamento',
      endDateBilling: 'Data do fim do faturamento',
      emissionDate: 'Data de emissão',
      attendanceDateConsult: 'Data do atendimento',
      anesthesiaStart: 'Início da anestesia',
      anesthesiaEnd: 'Fim da anestesia',
      healthCard: 'Cartão Nacional de Saúde',
      attendanceRN: 'Atendimento a RN',
      numberWallet: 'Número da Carteira',
      walletExpirationDate: 'Data de validade da carteira',
      password: 'Senha',
      passwordExpirationDate: 'Data de validade da senha',
      solicitationDate: 'Data da solicitação',
      authorizationDate: 'Data de autorização',
      clinicIndication: 'Indicação clínica',
      attendimentType: 'Tipo de atendimento',
      accidenteIndication: 'Indicação de Acidente (acidente ou doença relacionada)',
      grauPart: 'Grau de Participação',
      consultType: 'Tipo de Consulta',
      reasonToFinishAttendiment: 'Motivo de Encerramento do Atendimento',
      codeProcedureConsult: 'Código do procedimento',
      valueProcedureConsult: 'Valor do procedimento',
      totalFees: 'Total Honorários',
      totalTaxes: 'Total de taxas e aluguéis',
      totalMaterials: 'Total de materiais',
      totalOPME: 'Total de OPME',
      totalDrugs: 'Total de medicamentos',
      totalGasesMedicinals: 'Total de gases medicinais',
      reasonForLeavingSADTGuide: 'Tipo saída na guia SP/SADT',
      reasonForLeavingConsultationGuide: 'Tipo saída na guia de consulta'
    }
  },
  insuranceCrud: {
    eventFields: {
      create: 'Campos obrigatórios para preencher evento',
      check: 'Campos obrigatórios para conferir evento',
      xml: 'Campos obrigatórios para XML'
    }
  },
  ExternalINSSType: {
    MONTHLY: 'Mensal',
    YEARLY: 'Anual',
  },
  validation: {
    minCharacters: 'Mínimo de {min} caracteres',
    maxCharacters: 'Máximo de {max} caracteres',
  },

  // Conciliação Bancária
  bankReconciliation: {
    title: 'Conciliação Bancária',
    importTitle: 'Importar OFX',
    operation: 'Operação',
    operations: 'Operações',
    movements: 'Movimentações',
    movement: 'Movimentação',
    bankMovement: 'Movimentação Bancária',
    bankMovements: 'Movimentações Bancárias',
    reconcile: 'Conciliar',
    reconciled: 'Conciliado',
    pending: 'Pendente',
    discrepancy: 'Discrepância',
    ignored: 'Ignorado',
    suggestions: 'Sugestões',
    suggestion: 'Sugestão',
    autoSuggestion: 'Sugestão Automática',

    errors: {
      noOpenBalance: 'Esta movimentação já está quitada no sistema e nenhum pagamento dela corresponde a esta linha do extrato (mesma conta, data próxima e valor compatível). Criar outro pagamento deixaria a movimentação paga acima do próprio valor e inflaria o saldo bancário. Confira a movimentação ou marque esta linha como discrepância.',
      ambiguousPaidMatch: '{n} pagamentos desta movimentação correspondem a esta linha do extrato (mesma conta, data e valor). A conciliação não escolhe por você: confira os pagamentos na movimentação — se forem duplicados, estorne o que sobra — ou marque esta linha como discrepância.',
      transferNotSettled: 'Esta linha do extrato é a chegada de uma transferência na conta de destino, e nenhuma parcela baixada da transferência corresponde a ela (data próxima e valor compatível). A chegada só reconhece uma saída que já existe: baixe a transferência ou concilie antes o extrato da conta de origem.',
      transferDestinationLinked: 'A chegada desta transferência já foi conciliada no extrato da conta de destino (conciliação {code}). Desfazer este vínculo apagaria a baixa que aquela linha reconhece: desvincule primeiro a linha do extrato do destino.',
      transferAlreadyReceived: 'A chegada desta transferência já foi reconhecida por outra linha do extrato da conta de destino — comum quando dois extratos com períodos sobrepostos são importados. A transferência está baixada: confira as conciliações da conta de destino ou marque esta linha como discrepância.',
      transferOriginIsDestination: 'A parcela desta transferência tem a própria conta de destino como origem: o dinheiro sairia e entraria na mesma conta, e o saldo das duas contas está errado. Corrija a conta de origem da parcela na movimentação antes de conciliar.',
      transferAmbiguousArrival: '{n} parcelas baixadas desta transferência têm a mesma data e o mesmo valor desta linha do extrato. Todas são legítimas, mas a conciliação não tem como saber qual delas chegou aqui: confira as parcelas na movimentação ou marque esta linha como discrepância.',
      transferArrivalNotCredit: 'No extrato da conta de destino, a transferência é uma ENTRADA (crédito), e esta linha é uma saída. Escolha a linha de crédito que corresponde à chegada.',
      transferDepartureNotDebit: 'No extrato da conta de origem, a transferência é uma SAÍDA (débito), e esta linha é uma entrada. Escolha a linha de débito que corresponde à saída.',
      operationDeleteBlocked: 'Esta conciliação não pode ser excluída: a chegada de transferências que ela baixou foi conciliada no extrato da conta de destino (movimentação {items}; conciliação {codes}). Excluir apagaria as baixas que aquelas linhas reconhecem. Desvincule primeiro essas linhas na conciliação do destino. Nada foi alterado.',
    },

    delete: {
      confirmTitle: 'Excluir conciliação',
      confirmText: 'Excluir a conciliação {code} desfaz todos os vínculos dela, como o desvínculo de cada linha: os pagamentos criados pela conciliação são apagados, as parcelas previstas que ela baixou voltam a ficar em aberto e o saldo bancário é estornado. Baixas lançadas manualmente que ela só reconheceu continuam pagas. Depois, o mesmo extrato pode ser importado e conciliado de novo. Esta ação não pode ser desfeita.',
      progress: 'Excluindo a conciliação {code}: desfazendo os vínculos ({done} de {total} movimentações)…',
      success: 'Conciliação excluída. Vínculos desfeitos em {saved} movimentação(ões).',
      failedTitle: 'A conciliação {code} continua ativa',
      failedText: 'Não foi possível desfazer o vínculo de {n} movimentação(ões): {items}. As demais foram desvinculadas. Corrija o problema e exclua a conciliação de novo: a exclusão retoma de onde parou.',
    },

    result: {
      linkedExisting: 'Linha do extrato vinculada ao pagamento que a movimentação já tinha. Nenhum pagamento novo foi criado.',
      linkedDestination: 'Chegada da transferência reconhecida na conta de destino. Nenhum pagamento foi criado nem alterado, e os saldos ficam como estavam.',
      partialApplied: 'Vinculado {applied} — o valor restante da movimentação. Sobraram {remaining} desta linha do extrato: destine a outra movimentação ou marque como discrepância.',
      residual: 'Vinculado. Restante desta linha do extrato: {remaining}.',
    },

    status: {
      IMPORTING: 'Importando',
      PENDING: 'Pendente',
      IN_PROGRESS: 'Em Andamento',
      COMPLETED: 'Concluído',
      ERROR: 'Erro'
    },

    movementStatus: {
      PENDING: 'Pendente',
      MATCHED: 'Conciliado',
      DISCREPANCY: 'Discrepância',
      IGNORED: 'Ignorado',
      MANUAL: 'Manual'
    },

    actions: {
      linkMovement: 'Vincular Item',
      createFromMovement: 'Criar Item',
      markAsDiscrepancy: 'Marcar Discrepância',
      markAsIgnored: 'Ignorar',
      acceptSuggestion: 'Aceitar Sugestão',
      rejectSuggestion: 'Rejeitar Sugestão',
      finishOperation: 'Finalizar Operação'
    },

    import: {
      title: 'Importar Arquivo OFX',
      selectFile: 'Selecionar Arquivo',
      uploadFile: 'Importar Arquivo',
      fileSelected: 'Arquivo Selecionado',
      bankAccount: 'Conta Bancária',
      uploading: 'Importando...',
      success: 'Arquivo importado com sucesso',
      error: 'Erro na importação',
      duplicateFile: 'Este arquivo já foi importado anteriormente',
      invalidFile: 'Arquivo inválido ou corrompido',
      maxFileSize: 'Arquivo muito grande (máximo 10MB)',
      onlyOfxFiles: 'Apenas arquivos .ofx são aceitos'
    },

    link: {
      title: 'Vincular Movimentação',
      selectItem: 'Selecionar Item',
      linkAmount: 'Valor a Vincular',
      notes: 'Observações',
      confidence: 'Confiança',
      similarity: 'Similaridade',
      matchCriteria: 'Critérios de Match',
      link: 'Vincular',
      cancel: 'Cancelar'
    },

    create: {
      title: 'Criar Item Financeiro',
      type: 'Tipo do Item',
      description: 'Descrição',
      value: 'Valor',
      dueDate: 'Data de Vencimento',
      negotiator: 'Negociador',
      category: 'Categoria',
      notes: 'Observações',
      createAndLink: 'Criar e Vincular'
    },

    filters: {
      status: 'Status',
      type: 'Tipo',
      category: 'Categoria',
      search: 'Buscar',
      minAmount: 'Valor Mínimo',
      maxAmount: 'Valor Máximo',
      dateStart: 'Data Início',
      dateEnd: 'Data Fim',
      apply: 'Filtrar',
      clear: 'Limpar'
    },

    stats: {
      totalOperations: 'Total de Operações',
      completed: 'Concluídas',
      pending: 'Pendentes',
      progress: 'Progresso',
      totalMovements: 'Total de Movimentações',
      reconciledMovements: 'Movimentações Conciliadas',
      totalAmount: 'Valor Total',
      reconciledAmount: 'Valor Conciliado',
      pendingAmount: 'Valor Pendente',
      discrepancies: 'Discrepâncias'
    },

    messages: {
      operationCreated: 'Operação de conciliação criada com sucesso',
      movementReconciled: 'Movimentação conciliada com sucesso',
      itemCreated: 'Item financeiro criado e conciliado',
      operationFinished: 'Operação finalizada com sucesso',
      suggestionAccepted: 'Sugestão aceita com sucesso',
      suggestionRejected: 'Sugestão rejeitada',
      markedAsDiscrepancy: 'Movimentação marcada como discrepância',
      markedAsIgnored: 'Movimentação ignorada',
      confirmFinish: 'Ainda há movimentações pendentes. Deseja finalizar mesmo assim?',
      confirmDelete: 'Deseja realmente excluir esta operação? Esta ação não pode ser desfeita.',
      selectMovement: 'Selecione uma movimentação primeiro',
      noItemsFound: 'Nenhum item financeiro encontrado para conciliação',
      loadingOperation: 'Carregando operação...',
      operationNotFound: 'Operação não encontrada'
    }
  },
  onCallScheduleProductionReport: {
    title: 'Relatório de Produção e Plantões',
    reportTitle: 'Relatório de Produção e Plantões - {headerName}',
    professionalName: 'Nome do Profissional:',
    companyBranch: 'Empresa / Filial:',
    periodReference: 'Referente ao período {start} a {end}',
    tableHeaders: {
      date: 'Data',
      type: 'Tipo',
      value: 'Valor (R$)',
      electiveQty: 'Qtde. Eletivas'
    },
    onCall: 'Plantão: {slotName} ({timeRange})',
    onCallNoTime: 'Plantão: {slotName}',
    onCallPrefix: 'Plantão: ',
    elective: 'Eletivas: {procedureName}',
    electivePrefix: 'Eletivas: ',
    procedureSingular: '1 procedimento realizado no dia.',
    procedurePlural: '{count} procedimentos realizados no dia.',
    totalOnCall: 'Total de plantões:',
    totalProduction: 'Total de produção:',
    errors: {
      professionalRequired: 'O filtro de profissional é obrigatório para gerar o relatório.',
      professionalNotFound: 'Profissional não encontrado.'
    },
    fileName: 'Relatorio_Producao_Plantoes'
  },
  cnab: {
    title: 'Gerar Arquivo CNAB',
    selectType: 'Selecione o tipo de pagamento',
    selectBankAccount: 'Selecione a conta bancária',
    generate: 'Gerar CNAB',
    generating: 'Gerando arquivo CNAB...',
    success: 'Arquivo CNAB gerado com sucesso',
    error: 'Erro ao gerar arquivo CNAB',
    download: 'Baixar arquivo',
    noItems: 'Nenhum item selecionado',
    noItemsSelected: 'Nenhum item selecionado para gerar o arquivo CNAB',
    invalidBank: 'Banco não suportado para geração CNAB',
    errors: {
      VALIDATION_ERROR: 'Dados inválidos para gerar o arquivo CNAB. Verifique os campos obrigatórios.',
      GENERATION_ERROR: 'Erro durante a geração do arquivo CNAB. Tente novamente.',
      UNSUPPORTED_BANK: 'O banco da conta selecionada não é suportado para geração CNAB. Selecione uma conta do banco Unicred (136).',
      unknown: 'Ocorreu um erro inesperado ao gerar o arquivo CNAB. Tente novamente.',
      TIMEOUT: 'Tempo limite excedido. O arquivo CNAB não foi processado a tempo.',
    },
    types: {
      TED: 'TED - Transferência Eletrônica',
      BOLETO: 'Boleto Bancário',
      PIX: 'PIX',
    },
    status: {
      PENDING: 'Pendente',
      PROCESSING: 'Processando',
      COMPLETED: 'Concluído',
      ERROR: 'Erro',
    },
    summary: 'Resumo',
    totalItems: 'Total de itens',
    totalAmount: 'Valor total',
    bankAccount: {
      columnName: 'Nome da conta',
      columnAccount: 'Número da conta',
    },
  },
  financialDuplicate: {
    title: 'Duplicar movimentação',
    mode: 'Tipo de duplicação',
    modes: {
      simple: 'Duplicação simples',
      batch: 'Duplicação em lote',
    },
    hintSimple: 'Abre uma nova movimentação com os mesmos dados (sem nº, sem nota fiscal, sem pagamentos e como não paga) para você ajustar e salvar.',
    hintBatch: 'Cria várias movimentações iguais nos períodos seguintes, salvando diretamente, com os impostos recalculados na competência de cada cópia. Todas ficam como não pagas.',
    count: 'Quantidade',
    periodicityLabel: 'Periodicidade',
    periodicity: {
      month: 'Mensal',
      fortnight: 'Quinzenal',
      year: 'Anual',
    },
    adjustLabel: 'Ajuste de valor',
    adjust: {
      none: 'Sem ajuste',
      percent: 'Percentual (%)',
      fixed: 'Valor fixo',
    },
    adjustValue: 'Valor do ajuste',
    groupByCode: 'Agrupar as cópias com um código recorrente comum',
    groupCode: 'Código recorrente',
    groupCodePlaceholder: 'Deixe em branco para gerar automaticamente',
    preview: 'Movimentações que serão criadas',
    dueShort: 'venc.',
    openToEdit: 'Abrir cópia para editar',
    createBatch: 'Criar {count} movimentações',
    successCount: '{count} movimentações criadas',
    errorNumbers: 'Não foi possível gerar os números das movimentações. Tente novamente.',
    negativeLiquid: {
      title: 'Líquido negativo depois do recálculo',
      text: 'Com os impostos recalculados, {count} cópia(s) ficam com líquido zero ou negativo (competência {competences}) — retenção maior que o valor. Criar assim mesmo?',
    },
  },
  pdfIncome: {
    configTitle: 'Configurar PDF de Baixa',
    importTitle: 'Importar PDF de Baixa',
    importPrefix: 'Importar Arquivo de Baixa',
    steps: {
      header: 'Cabeçalho',
      columns: 'Colunas',
      match: 'Match',
    },
    dropzone: {
      title: 'Clique para selecionar um PDF de exemplo',
      subtitle: 'Suba um espelho de pagamento do convênio para configurar',
    },
    selectHeader: 'Selecione a linha que é o cabeçalho da tabela:',
    lineContent: 'Conteúdo',
    wordsCount: 'Palavras',
    mapColumns: 'Associe cada coluna do PDF ao campo do sistema:',
    selectField: 'Digite para buscar...',
    matchQuestion: 'Como encontrar o evento na cobrança?',
    guideMinDigitsLabel: 'Mínimo de dígitos da guia',
    guideMinDigitsHint: 'Linhas cujo campo de guia não tenha um número com essa quantidade de dígitos são descartadas (separa dado de linha institucional). Padrão: 6.',
    continuationTitle: 'Linhas de continuação (guia com vários procedimentos)',
    continuationEnabledLabel: 'Tratar linha sem guia como continuação da guia acima',
    continuationEnabledHint: 'Espelhos costumam imprimir a guia/beneficiário só na primeira linha do grupo — as demais herdam da linha acima.',
    continuationMatchLabel: 'Conferir com a linha de cima por (opcional)',
    continuationMatchHint: 'Se selecionado, a linha só é aceita como continuação quando estes campos baterem com a linha acima.',
    validationWarning: 'É necessário mapear pelo menos os campos "Nº Guia/Autorização" e "Valor Pago" no passo anterior.',
    configSaved: 'Configuração salva com sucesso',
    configError: 'Erro ao salvar configuração',
    parseError: 'Erro ao processar PDF',
    valuesProcessed: 'Valores processados',
    noRowsSelected: 'Nenhuma guia selecionada para processar',
    configNotFound: 'Configure o mapeamento de PDF na tela do convênio',
    maxPages: 'Páginas a analisar',
    processing: 'Processando PDF...',
    linesLabel: 'linhas',
    fields: {
      ignore: 'Ignorar',
      numberProviderGuide: 'Nº Guia do Prestador',
      guideNumberSetByOperator: 'Nº Guia da Operadora',
      procedureCode: 'Código do Procedimento',
      valuePaid: 'Valor Pago',
      valueTotal: 'Valor Total',
      valueGlosa: 'Valor Glosa',
      glosaReason: 'Motivo Glosa',
      walletNumber: 'Nº Carteirinha',
      patientName: 'Nome do Paciente',
      dateTime: 'Data/Hora',
      quantity: 'Quantidade',
    },
    matchFields: {
      numberProviderGuide: 'Nº Guia do Prestador (padrão)',
      guideNumberSetByOperator: 'Nº Autorização da Operadora',
      healthInsuranceWallet: 'Nº Carteirinha',
      password: 'Senha',
    },
    preview: {
      title: 'Preview',
      validRows: '{count} linhas válidas',
      invalidRows: '{count} com erro',
      total: 'Total',
      confirm: 'Confirmar Baixa',
    },
    buttons: {
      next: 'Próximo',
      back: 'Voltar',
      save: 'Salvar Configuração',
    },
  },
};
